import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import mapOutlines from './images/basemap.png'

const SwissMap = ({
  tenant,
  colorMode,
  isMobile,
  activeColor,
  mapData,
  blau,
  rot,
  gelb,
  highlights,
  setIsHovering,
}: {
  tenant?: Tenant
  colorMode?: string
  isMobile?: boolean
  activeColor?: string
  mapData?: MapData
  blau: string
  rot: string
  gelb: string
  highlights?: string[]
  setIsHovering: (isHovering: boolean) => void
}) => {
  const getColor = function (region: string) {
    const regionData = mapData?.filter((obj: any) => {
      return obj.site_code === region
    })
    //console.log('regionData:', regionData)

    const domVar =
      regionData !== undefined && regionData.length > 0
        ? regionData[0].dom_var
        : 'missing'
    let colorClass = domVar
      .replace(blau, 'blau')
      .replace(rot, 'rot')
      .replace(gelb, 'gelb')
      .replace('andere', 'beige')
      .replaceAll('/', '')
    /*
    console.log('blau:', blau)
    console.log('rot:', rot)
    console.log('domVar:', domVar)
    console.log('colorClass:', colorClass)
    console.log('regionData:', regionData)
    console.log('mapData:', mapData)
	*/

    if (
      highlights?.includes(
        regionData !== undefined && regionData.length > 0
          ? regionData[0].site_code
          : 'none'
      )
    ) {
      colorClass += ' highlight'
    }
    return colorClass
  }
  return (
    <Swissmap
      className={isMobile ? 'mobile' : 'desktop'}
      onTouchStart={() => {
        setIsHovering(true)
      }}
      onTouchEnd={() => {
        setIsHovering(false)
      }}
    >
      <MapContainer className='MapContainer'>
        <BaseMap>
          <img src={mapOutlines} alt='schweiz' />
        </BaseMap>
        <StyledSVG viewBox='0 0 600.4391 405.2469' preserveAspectRatio='none'>
          {/* patterns for diagonal hatched fill */}
          <pattern
            id='rotblaugelb'
            className={'diagonalHatch rotblaugelb'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              style={{ fill: '#D3343F' }}
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              style={{ stroke: '#378EBD', strokeWidth: '2' }}
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
            <path
              style={{ stroke: '#FFE462', strokeWidth: '2' }}
              d='
			  	M1,1.5 l4,-4
				M1.25,9.25 l9.25,-9.25
				M1,1.5 l-4,4
				'
            />
          </pattern>

          <pattern
            id='blaurotgelb'
            className={'diagonalHatch rotblaugelb'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              style={{ fill: '#D3343F' }}
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              style={{ stroke: '#378EBD', strokeWidth: '2' }}
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
            <path
              style={{ stroke: '#FFE462', strokeWidth: '2' }}
              d='
			  	M1,1.5 l4,-4
				M1.25,9.25 l9.25,-9.25
				M1,1.5 l-4,4
				'
            />
          </pattern>

          <pattern
            id='gelbblaurot'
            className={'diagonalHatch rotblaugelb'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              style={{ fill: '#D3343F' }}
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              style={{ stroke: '#378EBD', strokeWidth: '2' }}
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
            <path
              style={{ stroke: '#FFE462', strokeWidth: '2' }}
              d='
			  	M1,1.5 l4,-4
				M1.25,9.25 l9.25,-9.25
				M1,1.5 l-4,4
				'
            />
          </pattern>

          <pattern
            id='gelbrotblau'
            className={'diagonalHatch gelbrotblau'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              style={{ fill: '#D3343F' }}
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              style={{ stroke: '#378EBD', strokeWidth: '2' }}
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
            <path
              style={{ stroke: '#FFE462', strokeWidth: '2' }}
              d='
			  	M1,1.5 l4,-4
				M1.25,9.25 l9.25,-9.25
				M1,1.5 l-4,4
				'
            />
          </pattern>

          <pattern
            id='beigegelbblau'
            className={'diagonalHatch beigegelbblau'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              style={{ fill: '#575247' }}
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              style={{ stroke: '#378EBD', strokeWidth: '2' }}
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
            <path
              style={{ stroke: '#FFE462', strokeWidth: '2' }}
              d='
			  	M1,1.5 l4,-4
				M1.25,9.25 l9.25,-9.25
				M1,1.5 l-4,4
				'
            />
          </pattern>

          <pattern
            id='beigerotblau'
            className={'diagonalHatch beigerotblau'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              style={{ fill: '#575247' }}
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              style={{ stroke: '#378EBD', strokeWidth: '2' }}
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
            <path
              style={{ stroke: '#D3343F', strokeWidth: '2' }}
              d='
			  	M1,1.5 l4,-4
				M1.25,9.25 l9.25,-9.25
				M1,1.5 l-4,4
				'
            />
          </pattern>

          <pattern
            id='beigeblaurot'
            className={'diagonalHatch beigeblaurot'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              style={{ fill: '#575247' }}
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              style={{ stroke: '#378EBD', strokeWidth: '2' }}
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
            <path
              style={{ stroke: '#D3343F', strokeWidth: '2' }}
              d='
			  	M1,1.5 l4,-4
				M1.25,9.25 l9.25,-9.25
				M1,1.5 l-4,4
				'
            />
          </pattern>

          <pattern
            id='beigerotgelb'
            className={'diagonalHatch beigerotgelb'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              style={{ fill: '#575247' }}
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              style={{ stroke: '#FFE462', strokeWidth: '2' }}
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
            <path
              style={{ stroke: '#D3343F', strokeWidth: '2' }}
              d='
			  	M1,1.5 l4,-4
				M1.25,9.25 l9.25,-9.25
				M1,1.5 l-4,4
				'
            />
          </pattern>

          <pattern
            id='beigerotblaugelb'
            className={'diagonalHatch beigerotblaugelb'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              style={{ fill: '#FFE462' }}
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              style={{ stroke: '#378EBD', strokeWidth: '2' }}
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
            <path
              style={{ stroke: '#D3343F', strokeWidth: '2' }}
              d='
			  	M1,1.5 l4,-4
				M1.25,9.25 l9.25,-9.25
				M1,1.5 l-4,4
				'
            />
          </pattern>

          <pattern
            id='beigegelbrotblau'
            className={'diagonalHatch beigegelbrotblau'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              style={{ fill: '#FFE462' }}
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              style={{ stroke: '#378EBD', strokeWidth: '2' }}
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
            <path
              style={{ stroke: '#D3343F', strokeWidth: '2' }}
              d='
			  	M1,1.5 l4,-4
				M1.25,9.25 l9.25,-9.25
				M1,1.5 l-4,4
				'
            />
          </pattern>

          <pattern
            id='beigegelbrot'
            className={'diagonalHatch beigegelbrot'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              style={{ fill: '#575247' }}
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              style={{ stroke: '#D3343F', strokeWidth: '2' }}
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
            <path
              style={{ stroke: '#FFE462', strokeWidth: '2' }}
              d='
			  	M1,1.5 l4,-4
				M1.25,9.25 l9.25,-9.25
				M1,1.5 l-4,4
				'
            />
          </pattern>

          <pattern
            id='blaurot'
            className={'diagonalHatch rotblau'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              className='background'
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
          </pattern>

          <pattern
            id='rotblau'
            className={'diagonalHatch rotblau'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              className='background'
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
          </pattern>

          <pattern
            id='gelbrot'
            className={'diagonalHatch gelbrot'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              className='background'
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
          </pattern>

          <pattern
            id='rotgelb'
            className={'diagonalHatch rotgelb'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              className='background'
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
          </pattern>

          <pattern
            id='gelbblau'
            className={'diagonalHatch gelbblau'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              className='background'
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
          </pattern>

          <pattern
            id='blaugelb'
            className={'diagonalHatch blaugelb'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              className='background'
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
          </pattern>

          <pattern
            id='beigerot'
            className={'diagonalHatch beigerot'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              className='background'
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
          </pattern>

          <pattern
            id='rotbeige'
            className={'diagonalHatch beigerot'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              className='background'
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
          </pattern>

          <pattern
            id='beigeblau'
            className={'diagonalHatch beigeblau'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              className='background'
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
          </pattern>

          <pattern
            id='blaubeige'
            className={'diagonalHatch beigeblau'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              className='background'
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
          </pattern>

          <pattern
            id='beigegelb'
            className={'diagonalHatch beigegelb'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              className='background'
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
          </pattern>

          <pattern
            id='gelbbeige'
            className={'diagonalHatch beigegelb'}
            patternUnits='userSpaceOnUse'
            width='8'
            height='8'
          >
            <rect
              className='background'
              x='0'
              y='0'
              width='100%'
              height='100%'
            />
            <path
              className='stripe'
              d='M-1,1 l4,-4
				M0,8 l8,-8
				M7,9 l4,-4'
            />
          </pattern>

          {/* filled regions */}
          <g
            className={
              activeColor ? 'regions filled ' + activeColor : 'regions filled'
            }
          >
            <polygon
              id='ZH07'
              className={getColor('ZH07') + ' st13'}
              fill={'url(#' + getColor('ZH07') + ')'}
              points='333.6784,110.5847 332.6496,110.4389 327.4278,99.2471 327.0876,94.9459 329.9768,78.4515 
		349.9535,78.5169 347.0695,99.597 	'
            />
            <polygon
              id='ZH06'
              className={getColor('ZH06') + ' st13'}
              fill={'url(#' + getColor('ZH06') + ')'}
              points='368.414,87.4765 350.4747,77.9461 351.7749,54.9361 352.8322,52.1786 367.6292,41.2566 
		368.5172,42.8628 376.3834,73.5993 	'
            />
            <g
              id='ZH05'
              className={getColor('ZH05') + ' st13'}
              fill={'url(#' + getColor('ZH05') + ')'}
            >
              <polygon
                points='327.3583,55.1176 327.743,54.9555 327.8135,54.922 327.8733,54.8934 328.3931,54.6861 
			328.4207,54.6793 328.521,54.6731 328.5508,54.6751 328.7859,54.7003 328.8182,54.7045 329.0396,54.7574 329.2663,54.7708 
			329.4393,54.7439 330.1883,54.3576 330.6653,53.8773 330.9592,53.6775 331.2408,53.6156 331.3136,53.6187 331.3673,53.6237 
			331.4194,53.6321 331.4949,53.6489 331.547,53.6607 331.6713,53.6993 331.7234,53.711 331.8023,53.7245 331.8779,53.7329 
			331.9048,53.7329 331.9266,53.7295 332.0089,53.7194 332.1147,53.7127 332.1399,53.711 332.1651,53.706 332.1886,53.6976 
			332.2136,53.686 332.2994,53.6758 332.726,53.3013 332.9276,53.1552 333.2567,52.9922 333.2215,52.9357 333.1694,52.7302 
			332.5631,51.8809 332.5262,51.8216 332.5221,51.8234 332.4657,51.7444 332.2642,51.8401 331.7637,51.9191 331.6579,51.9812 
			331.6008,52.1155 331.5554,52.213 331.5502,52.2227 331.5151,52.2533 331.3747,52.2611 331.3556,52.2449 331.3388,52.2214 
			331.3169,52.2079 331.2901,52.2096 331.2178,52.2247 331.1154,52.2499 331.0163,52.2768 330.7342,52.3574 330.6351,52.3843 
			330.5889,52.3932 330.2992,52.3691 330.2757,52.3786 330.1917,52.3708 330.1363,52.3607 330.1127,52.3691 330.0976,52.3876 
			330.0808,52.4094 330.0523,52.4615 330.0453,52.4715 330.0036,52.4884 329.8957,52.4984 329.8709,52.4934 329.8073,52.4753 
			329.4997,51.8572 329.4577,51.7494 329.231,51.7293 329.1096,51.7206 331.6014,46.8824 331.7217,46.9377 331.856,46.8672 
			331.8754,46.806 331.949,46.7492 332.0257,46.7714 332.076,46.7832 332.155,46.8033 332.1819,46.8067 332.2071,46.805 
			332.2306,46.7983 332.2524,46.7832 332.2709,46.7681 332.328,46.7076 332.3465,46.6874 332.3545,46.6814 332.3978,46.6656 
			332.4187,46.6656 332.5984,46.6925 332.8066,46.7278 332.9091,46.7496 332.9612,46.7597 332.9864,46.763 333.0384,46.7647 
			333.0653,46.763 333.0921,46.7597 333.1173,46.7546 333.1425,46.7496 333.2164,46.721 333.287,46.6908 333.5036,46.5934 
			333.601,46.5548 333.7505,46.5044 334.0323,46.383 334.4189,46.2894 334.8724,46.2222 334.8668,46.1743 334.8707,46.1735 
			334.8661,46.1684 334.8469,46.0029 334.8623,46.0005 334.8472,45.2918 334.8274,45.2388 334.8455,45.0903 335.1228,45.0813 
			335.1613,45.0903 335.498,45.0692 335.5224,45.0684 335.7004,45.0684 335.7005,45.0627 335.7306,45.0617 335.7155,44.8434 
			335.7053,44.8436 335.7054,44.84 335.4266,44.7796 335.3997,44.657 335.5005,44.4403 335.5778,44.5411 335.7021,44.3966 
			335.6853,44.1716 335.7945,44.1229 335.6987,43.9381 335.6735,43.6594 335.6736,43.6593 335.8683,43.4628 335.7883,43.3828 
			335.8045,43.3436 335.7676,43.1219 336.4282,43.017 336.4931,43.1588 336.9816,43.4459 337.0238,43.4863 337.1374,43.4786 
			337.5276,43.4746 337.6641,43.4428 337.7393,43.4376 337.9142,43.4802 338.0433,43.5418 338.2851,43.6056 338.6059,43.5754 
			338.6882,43.6308 338.7604,44.1111 338.6748,44.5159 339.2374,44.3479 339.3802,44.6687 339.4468,44.6588 339.454,44.6754 
			339.9193,44.6754 340.4281,44.7208 340.4524,44.7211 340.4936,44.7342 341.0479,44.7695 341.11,44.8182 341.1705,44.8971 
			341.2041,45.013 341.2326,45.1776 341.2981,45.3153 341.4996,45.4379 341.4828,45.5622 341.6357,45.7402 341.6491,45.9048 
			341.7583,46.2155 342.3831,46.1735 342.5489,46.1192 342.5815,46.1181 342.7139,46.4238 342.6904,46.5497 342.6954,46.6958 
			342.8416,46.7042 342.86,46.7698 342.7895,46.8168 342.8096,46.9981 343.2228,47.0334 343.2379,47.0973 343.2195,47.1711 
			343.028,47.2954 342.6551,47.3173 342.2319,47.497 342.2403,48.0646 342.2017,48.3367 341.8926,48.8523 341.6306,49.0908 
			341.7801,49.4049 341.8103,49.4536 341.9313,49.6249 342.2773,49.8801 342.4183,49.7659 342.5628,49.7089 342.897,49.6736 
			343.3135,50.1623 343.3648,50.1201 343.4445,50.2211 343.7863,49.9437 344.2842,50.0313 344.2867,50.0264 344.3128,50.033 
			344.3569,49.886 344.4068,49.7861 344.5513,49.5694 344.9407,48.9909 345.1585,49.0357 345.2684,49.0723 345.4095,48.8775 
			345.5603,48.15 345.7178,48.1869 345.9318,48.251 345.938,48.2384 345.9419,48.2393 346.0897,48.0495 346.57,47.6364 
			346.9429,47.2769 347.1024,46.9562 347.1091,46.6387 347.1075,46.3398 347.0799,46.2643 347.0789,46.2592 347.0688,46.2071 
			347.0554,46.1567 347.0386,46.108 347.0184,46.0576 346.9899,45.9854 346.9328,45.8662 346.8605,45.7285 346.71,45.469 
			346.4465,44.9478 346.4323,44.9173 346.3802,44.798 346.3692,44.7706 346.2382,44.3716 346.2274,44.3261 346.2039,44.2505 
			346.1396,44.0325 346.0544,43.6644 346.0359,42.8481 345.9755,42.4652 345.8361,41.958 345.7924,41.5919 345.8512,41.2325 
			345.8677,41.2109 352.8322,52.1786 351.7749,54.9361 326.5748,56.6365 		'
              />
              <polygon
                points='343.6396,37.7439 343.6028,37.8 343.5653,37.8005 343.5279,37.8011 343.4903,37.8016 
			343.4521,37.7466 343.3387,37.6928 343.3004,37.6378 343.2629,37.6383 343.2254,37.6389 343.1879,37.6394 343.1129,37.6405 
			343.0754,37.641 342.9238,37.5322 342.8472,37.4223 342.7706,37.3123 342.7331,37.3129 342.6948,37.2579 342.6573,37.2584 
			342.6198,37.259 342.4706,37.3167 342.3956,37.3177 342.0549,37.1005 341.8683,37.1588 341.7079,36.4393 341.743,36.2722 
			341.4048,36.2215 341.2173,36.2242 340.8822,36.3955 340.5822,36.3998 340.3205,36.459 339.9128,36.798 339.7261,36.8561 
			339.6511,36.8572 339.5745,36.7472 339.3519,36.9169 339.3144,36.9175 339.3152,36.973 339.0558,37.1987 338.7566,37.2584 
			338.7215,37.4255 338.6847,37.4815 338.648,37.5376 338.7668,37.9801 338.8847,38.3671 338.8855,38.4226 338.9246,38.5331 
			338.9254,38.5886 338.9652,38.7546 338.7753,38.5907 338.1714,38.3216 337.9823,38.2131 338.0526,37.8791 337.9363,37.603 
			337.4909,37.9424 337.1182,38.1141 337.119,38.1697 337.2759,38.6672 337.3885,38.6656 337.5025,38.775 337.4658,38.8311 
			337.429,38.8871 337.4298,38.9426 337.3923,38.9431 337.3931,38.9987 337.3938,39.0542 337.3946,39.1097 337.3954,39.1652 
			337.4329,39.1647 337.4337,39.2202 337.4712,39.2197 337.5094,39.2747 337.5469,39.2741 337.5477,39.3297 337.5852,39.3291 
			337.6243,39.4396 337.6626,39.4946 337.6633,39.5501 337.7008,39.5496 337.7016,39.6051 337.7024,39.6606 337.7032,39.7161 
			337.7407,39.7156 337.8165,39.7701 337.8923,39.8246 337.9305,39.8795 337.9688,39.9345 337.9696,39.99 337.9712,40.1011 
			337.9719,40.1566 337.9727,40.2121 337.9735,40.2676 337.9758,40.4341 337.9391,40.4902 337.9031,40.6017 337.8296,40.7138 
			337.7929,40.7698 337.7936,40.8253 337.7561,40.8258 337.6819,40.8824 337.6444,40.8829 337.5318,40.8845 337.4193,40.886 
			337.3818,40.8865 337.3068,40.8876 337.195,40.9447 337.12,40.9457 336.8206,41.0054 336.7456,41.0064 336.7081,41.0069 
			336.6706,41.0075 336.6331,41.008 336.5956,41.0085 335.7274,40.6318 335.5016,40.5794 335.4266,40.5804 335.3132,40.5264 
			335.2015,40.5835 335.0897,40.6405 334.8286,40.7551 334.7528,40.7006 339.6102,31.3055 		'
              />
            </g>
            <polygon
              id='ZH04'
              className={getColor('ZH04') + ' st13'}
              fill={'url(#' + getColor('ZH04') + ')'}
              points='357.2706,112.2388 347.0695,99.597 349.9535,78.5169 350.4747,77.9461 368.414,87.4765 
		370.2981,105.2371 	'
            />
            <polygon
              id='ZH03'
              className={getColor('ZH03') + ' st13'}
              fill={'url(#' + getColor('ZH03') + ')'}
              points='352.7658,125.5574 343.6913,123.3232 333.6784,110.5847 347.0695,99.597 
		357.2706,112.2388 	'
            />
            <polygon
              id='ZH02'
              className={getColor('ZH02') + ' st13'}
              fill={'url(#' + getColor('ZH02') + ')'}
              points='349.9535,78.5169 329.9768,78.4515 322.4114,59.7397 326.5748,56.6365 351.7749,54.9361 
		350.4747,77.9461 	'
            />
            <polygon
              id='ZH01'
              className={getColor('ZH01') + ' st13'}
              fill={'url(#' + getColor('ZH01') + ')'}
              points='373.2689,109.105 370.2981,105.2371 368.414,87.4765 376.3834,73.5993 383.233,74.3843 
		392.1216,98.6171 	'
            />
            <polygon
              id='ZG02'
              className={getColor('ZG02') + ' st13'}
              fill={'url(#' + getColor('ZG02') + ')'}
              points='336.8878,146.9906 322.5036,134.4647 332.6496,110.4389 333.6784,110.5847 
		343.6913,123.3232 	'
            />
            <polygon
              id='ZG01'
              className={getColor('ZG01') + ' st13'}
              fill={'url(#' + getColor('ZG01') + ')'}
              points='341.0145,154.6342 336.8878,146.9906 343.6913,123.3232 352.7658,125.5574 
		356.1141,137.6608 356.0078,140.2967 	'
            />
            <polygon
              id='VS11'
              className={getColor('VS11') + ' st13'}
              fill={'url(#' + getColor('VS11') + ')'}
              points='258.992,352.9792 257.0115,353.9357 256.9561,354.2178 257.2416,354.5755 
		257.4297,355.7142 257.035,356.0417 257.0199,356.4599 256.6974,356.8445 256.988,357.5197 256.9342,358.3896 256.1012,358.7323 
		255.7905,360.7711 256.1231,361.2683 256.9342,362.5531 256.422,363.7505 256.1886,363.9319 255.547,363.9319 255.1926,364.503 
		254.4402,363.7052 253.4073,363.8093 252.2233,363.5037 251.6775,363.5625 251.1064,363.0284 249.7578,362.6052 249.4102,362.6337 
		248.7249,363.2316 248.2009,363.3559 247.462,364.162 246.8422,364.4156 246.0747,363.848 245.8362,363.1258 245.2098,362.5413 
		243.9182,362.0576 242.9021,360.7779 240.5156,360.2858 240.126,360.0557 239.4626,361.7268 238.5859,362.4053 238.3961,363.2602 
		236.4949,363.3021 235.5074,362.3532 235.3915,361.6361 234.8524,361.2565 235.1513,358.7457 234.7936,358.2687 234.1655,357.775 
		233.408,357.4743 232.4339,357.4021 231.4598,357.0813 230.998,356.3591 230.8384,355.5631 230.5143,355.1751 229.7014,353.9172 
		229.127,353.5359 228.4956,353.4435 228.0874,353.3764 227.8473,353.7627 227.2746,353.8029 226.5137,354.3219 225.6606,354.6024 
		223.4067,354.2329 222.7013,354.3622 222.127,354.7905 219.9957,354.4294 219.1291,354.51 218.3649,353.7375 218.3901,352.7751 
		218.0643,351.8027 217.6125,351.4366 216.5208,351.4567 215.849,351.7675 215.6012,351.7578 225.0911,333.9241 225.7727,333.4962 
		227.384,331.7369 231.7585,324.8395 252.1007,335.071 	'
            />
            <polygon
              id='VS10'
              className={getColor('VS10') + ' st13'}
              fill={'url(#' + getColor('VS10') + ')'}
              points='258.3803,311.3307 245.6236,298.6583 245.9008,287.7173 263.1252,275.1359 
		262.9924,309.1691 	'
            />
            <polygon
              id='VS09'
              className={getColor('VS09') + ' st13'}
              fill={'url(#' + getColor('VS09') + ')'}
              points='225.0525,298.8444 226.4611,273.0212 226.8488,267.4395 228.7676,268.1241 
		230.288,268.8361 232.2206,269.7901 232.6607,269.7515 233.3661,270.6702 233.9001,271.0044 234.2226,271.3756 245.9008,287.7173 
		245.6236,298.6583 234.1306,311.9548 234.1614,310.6089 234.2334,310.3794 227.9672,303.5253 227.0646,301.2694 	'
            />
            <polygon
              id='VS08'
              className={getColor('VS08') + ' st13'}
              fill={'url(#' + getColor('VS08') + ')'}
              points='252.1007,335.071 231.7585,324.8395 233.9139,321.4369 234.1306,311.9548 
		245.6236,298.6583 258.3803,311.3307 	'
            />
            <polygon
              id='VS07'
              className={getColor('VS07') + ' st13'}
              fill={'url(#' + getColor('VS07') + ')'}
              points='287.8832,294.7718 287.7813,295.1604 287.4236,295.6139 287.1566,296.2605 
		286.2362,296.5326 285.032,298.0793 283.6162,298.9728 283.6481,299.8176 283.3861,300.0595 282.9478,300.1015 283.0738,300.6557 
		283.8782,301.3241 285.4637,301.5727 285.687,302.1303 286.7955,302.1437 287.2036,304.1641 287.5395,304.6109 288.1391,304.6411 
		288.6748,305.8453 289.8505,306.4381 290.5575,306.4633 291.1739,309.2026 292.2068,310.8098 292.3126,311.8528 292.2253,312.1148 
		292.4604,313.0016 293.0012,313.2871 294.0508,314.5971 294.0424,315.6384 293.1322,316.2648 292.9793,317.0626 292.232,317.7965 
		292.0691,318.5472 292.0489,319.3383 292.4755,319.9261 292.5528,320.9657 292.7661,321.1051 292.1614,322.3731 291.3922,323.1557 
		290.7036,323.4228 290.2972,323.1322 288.9956,323.4211 287.5428,324.4876 287.61,325.1006 287.5395,325.5591 287.5832,326.0209 
		287.4925,326.7902 286.9718,327.252 286.824,327.6601 286.6494,327.9406 285.5896,328.0279 285.3713,328.4814 285.0102,328.4209 
		284.2242,328.7803 283.7304,328.8609 283.1711,329.0339 282.7563,328.9231 281.7436,328.8744 280.6519,329.3396 280.2119,329.6335 
		279.1186,329.6067 278.4787,330.0063 277.1855,329.9795 277.1121,330.2163 268.6874,310.7248 283.0907,291.8233 	'
            />
            <polygon
              id='VS06'
              className={getColor('VS06') + ' st13'}
              fill={'url(#' + getColor('VS06') + ')'}
              points='213.299,279.5336 212.7134,278.6225 213.0023,277.4385 214.9001,276.4661 213.79,275.5239 
		213.009,275.3711 211.4471,274.3197 212.0416,273.1407 212.1306,272.5881 212.8696,272.2136 214.094,272.1649 214.8161,271.8744 
		215.4728,271.8811 215.797,272.086 216.2168,271.7383 217.0499,271.6308 217.6998,271.2177 218.5194,271.179 218.8956,271.829 
		219.9016,272.2707 220.2577,271.8542 220.6624,271.5233 220.4458,270.3981 220.6389,270.116 221.042,270.1882 221.4753,269.8439 
		221.9674,269.0612 221.7826,268.3911 221.7944,267.9511 221.8918,267.538 223.3009,267.2188 223.6082,266.9249 223.6889,266.4446 
		224.0113,265.9794 225.3683,266.8846 226.8488,267.4395 226.4611,273.0212 225.0525,298.8444 222.8863,296.2318 220.7272,295.8234 
		218.877,296.2438 216.0319,294.5026 215.3425,292.7814 215.5062,283.4137 213.9333,281.0265 	'
            />
            <polygon
              id='VS05'
              className={getColor('VS05') + ' st13'}
              fill={'url(#' + getColor('VS05') + ')'}
              points='277.1121,330.2163 277.0662,330.3641 277.125,331.0812 276.5842,332.0923 
		276.6934,332.5374 276.5422,333.5954 275.679,334.8685 275.7613,335.337 275.5849,335.8426 275.9292,336.3834 275.8721,337.04 
		276.4129,338.3097 276.905,340.0178 277.2443,340.2747 277.3719,340.5787 276.9185,340.8978 276.0652,341.2186 275.6891,341.5511 
		274.3623,343.0089 274.6948,343.2491 275.1096,344.2014 274.2783,345.2729 274.5722,345.9228 274.4513,346.5694 273.7744,346.7038 
		272.9851,346.551 272.8155,347.2916 272.0782,348.4505 272.0664,348.8838 271.4265,349.5639 269.8915,348.9677 269.4934,348.9761 
		268.6671,349.3103 268.0004,349.3238 267.7048,349.3876 267.4226,349.6076 266.2722,349.3322 265.2275,349.3624 264.1745,349.616 
		263.7479,349.4565 263.3213,349.3876 262.3372,349.6731 260.9818,349.4833 260.6946,349.8696 260.661,350.2878 260.347,351.0184 
		259.9422,351.1645 259.2351,352.2528 259.0773,352.938 258.992,352.9792 252.1007,335.071 258.3803,311.3307 262.9924,309.1691 
		268.6874,310.7248 	'
            />
            <polygon
              id='VS04'
              className={getColor('VS04') + ' st13'}
              fill={'url(#' + getColor('VS04') + ')'}
              points='288.321,250.0052 305.7548,284.0449 305.9786,284.101 306.3733,283.9381 
		305.9886,283.4124 306.7175,282.8548 306.5412,282.1494 306.647,281.8723 306.0793,281.1619 306.5529,280.4951 307.7924,280.0434 
		309.0067,280.643 309.5659,279.9225 310.5652,279.1885 311.4184,278.3219 311.9659,278.4428 312.7502,278.0162 312.9518,277.509 
		313.0408,276.76 313.5161,276.3132 312.9652,275.843 312.8846,275.3375 313.286,274.7631 313.2457,274.2827 313.0912,273.9905 
		312.4849,273.4296 312.3152,273.0332 311.84,273.3825 311.5208,273.3322 310.9179,272.9156 310.3586,272.8871 310.1521,272.6049 
		309.9522,272.4286 309.6029,272.2119 310.1924,271.871 310.792,271.1505 311.0052,270.5509 311.3126,269.8976 311.5259,269.4694 
		312.0129,268.9773 312.4345,269.4576 312.9249,269.4694 313.4858,269.1788 313.8856,269.0713 314.3558,269.0696 314.6598,268.6447 
		315.3249,268.2316 315.9245,267.7781 316.2587,267.4321 316.5156,266.9014 317.5771,265.9911 317.9953,265.1816 318.3278,264.8457 
		319.6076,264.0026 320.098,263.7927 320.6707,263.7927 321.2249,264.2075 321.3912,264.2579 321.9001,263.9472 321.5641,262.523 
		322.0092,262.1334 321.9488,261.4397 322.8523,260.9863 322.8187,260.6991 322.503,260.5966 322.4123,259.9769 321.9975,259.5638 
		323.1059,257.8003 322.7012,256.5726 322.7784,255.9864 323.1009,256.1376 323.6131,256.0671 323.9121,256.4147 325.1969,256.3223 
		325.6168,255.9529 326.3003,256.3358 327.3749,255.7505 327.8421,255.496 329.3032,255.7748 329.4309,255.6441 330.0595,254.3171 
		330.3998,253.5988 330.7294,253.3927 331.2034,253.0965 331.434,252.8741 331.7152,252.4596 332.4018,251.4478 333.5785,249.7137 
		333.589,249.6753 333.1576,249.5456 332.0492,248.2356 331.1507,248.6589 329.5081,248.0257 328.7625,247.3421 328.4904,247.4967 
		328.1897,247.448 327.8874,246.9223 327.397,246.8249 327.1501,246.2354 326.8159,245.409 326.6429,244.6231 326.6631,243.7632 
		326.4968,243.7161 326.2835,243.5566 326.1542,243.1098 326.1458,242.5943 325.7746,241.6739 324.8744,240.552 324.8845,239.8785 
		324.6074,239.6787 324.5906,239.2067 324.3605,238.9078 324.8644,236.9126 324.5318,236.4473 324.5637,236.0728 325.3044,235.3506 
		325.7477,234.2724 325.6621,233.9365 326.1088,233.2227 326.0836,231.5332 326.3372,231.2006 326.1441,230.9924 325.8603,229.6236 
		326.0517,229.3213 326.0753,227.6149 326.2483,227.3479 325.7477,226.5417 324.7484,226.4074 323.8147,226.3016 323.2806,226.2411 
		322.7331,227.7745 322.7331,227.7745 322.462,227.9272 322.241,228.0516 321.7163,228.8232 320.9243,229.988 320.6866,230.0606 
		320.1215,230.2332 319.9351,230.1661 319.5102,231.0125 319.4396,231.5592 319.3947,231.6131 319.422,231.6955 319.4111,231.78 
		319.4262,232.566 319.7419,232.8499 319.705,233.7635 319.3775,234.6217 319.0281,235.6361 318.6049,236.1719 318.5629,236.7479 
		318.8518,237.7792 318.5159,238.9682 319.0046,239.5695 318.5008,240.5285 317.3654,241.6756 317.2177,242.25 316.2856,243.0494 
		315.4576,243.6842 312.9383,244.089 312.3774,244.9808 312.4026,245.3217 311.1312,246.6367 310.0563,246.7493 309.1578,247.1272 
		308.6456,248.0173 308.0729,248.328 307.4464,248.3952 306.7528,248.6874 306.2069,248.9679 305.4042,249.7018 304.6148,249.7136 
		303.241,250.2594 302.7086,250.209 301.9411,250.1805 301.2475,250.1939 300.3439,250.3098 299.2909,250.55 298.6342,250.8623 
		297.954,250.7129 296.8623,250.9144 295.9554,251.4082 295.4633,251.4602 295.2383,251.0656 294.6471,250.8103 294.5026,250.1939 
		294.6622,249.7287 294.6135,249.4449 293.9014,249.4348 293.1557,249.3139 292.6619,249.4751 292.6619,249.4751 292.1698,249.4617 
		291.4644,249.3995 291.4644,249.3995 289.0317,248.5932 	'
            />
            <polygon
              id='VS03'
              className={getColor('VS03') + ' st13'}
              fill={'url(#' + getColor('VS03') + ')'}
              points='268.6874,310.7248 262.9924,309.1691 263.1252,275.1359 268.7221,265.5433 
		271.3079,264.7175 283.0907,291.8233 	'
            />
            <polygon
              id='VS02'
              className={getColor('VS02') + ' st13'}
              fill={'url(#' + getColor('VS02') + ')'}
              points='271.3079,264.7175 283.0907,291.8233 287.8832,294.7718 288.0366,294.1863 
		288.6597,293.7379 288.9435,293.6136 290.2519,292.3641 290.7003,292.3103 291.624,292.4531 292.7661,293.2626 293.3623,293.3886 
		295.1005,293.0577 295.6094,293.1031 296.5953,292.4111 297.6114,291.9727 298.1723,292.2029 299.0188,291.4672 299.8216,290.787 
		299.7426,290.08 300.2347,289.5761 300.1978,288.911 301.1903,288.1989 301.5078,287.6783 301.2979,287.5574 301.3146,287.1661 
		301.1097,286.9864 301.5447,286.4607 301.3902,286.1466 302.4466,285.3875 302.8615,285.0012 303.2998,285.0415 303.5399,285.1742 
		304.6602,284.9475 304.6517,284.2068 305.0884,283.8777 305.9786,284.101 306.3733,283.9381 306.3732,283.9381 305.9786,284.101 
		305.7548,284.0449 288.321,250.0052 289.0318,248.5932 288.3423,248.4086 287.9174,247.7687 287.2892,247.3136 286.8106,246.6888 
		285.6198,246.3647 285.0858,246.3949 284.4946,246.185 284.1805,245.7953 283.0973,245.7517 282.3314,245.3839 281.878,245.0396 
		281.2397,245.3536 280.1968,245.4846 280.1968,245.4846 280.0356,245.8424 279.0614,245.0026 277.6255,244.8044 276.5624,244.225 
		276.433,243.9143 276.0216,243.7984 275.3078,243.9076 274.1355,243.659 272.2763,244.6483 271.7708,244.6063 271.188,245.0396 
		271.1628,245.3268 270.3248,246.5394 269.7403,246.5142 269.5086,246.5394 269.3406,246.6871 269.0299,246.7207 268.2237,247.1608 
		267.9802,247.7738 267.3471,248.1987 267.3252,248.6589 267.5738,249.0586 267.9517,249.5087 267.8341,249.7942 268.1482,250.125 
		268.1398,250.4777 268.6688,250.995 268.3497,251.5929 268.4085,252.431 268.4085,252.431 268.0105,253.1196 269.9562,265.1492 
		269.9562,265.1492 	'
            />
            <polygon
              id='VS01'
              className={getColor('VS01') + ' st13'}
              fill={'url(#' + getColor('VS01') + ')'}
              points='234.2226,271.3756 245.9008,287.7173 263.1252,275.1359 268.7221,265.5433 
		269.9565,265.1507 268.0105,253.1196 267.6141,253.0608 266.1916,254.0298 265.9111,253.8753 264.7052,254.0937 263.7563,254.9334 
		263.5262,255.8857 262.8796,256.0435 262.3372,256.4702 262.5202,256.7725 262.3086,257.1117 261.2808,257.2175 260.7484,258.0203 
		260.0665,257.9514 259.9875,258.2605 259.4552,258.42 259.0017,258.766 258.7212,258.8735 258.1452,258.682 257.6279,259.0868 
		256.3112,259.6057 255.3219,259.6998 254.536,259.6561 252.8699,259.7149 252.492,259.5554 252.0251,259.7485 249.9745,261.1794 
		249.5496,261.873 248.0431,262.6187 247.603,262.7397 247.2705,262.8455 246.1234,263.4719 245.5675,264.2075 244.8705,264.5652 
		244.4674,265.1816 243.8931,265.5847 243.6462,266.2128 242.8367,266.4715 242.3379,266.8712 242.0372,266.9333 241.4041,267.5967 
		240.8398,267.81 240.603,268.2064 239.2694,269.0444 239.0058,269.4274 238.2702,269.8506 237.6319,270.2704 236.6713,270.3779 
		236.1792,270.7105 235.1665,271.7635 	'
            />
            <polygon
              id='UR03'
              className={getColor('UR03') + ' st13'}
              fill={'url(#' + getColor('UR03') + ')'}
              points='362.7525,177.1879 362.7525,177.1879 359.9894,212.1369 359.9894,212.137 
		363.8481,216.6234 362.9366,217.234 362.1775,216.5421 361.8483,216.438 361.5392,216.4749 361.2033,216.5807 360.8759,216.7772 
		360.6844,217.0207 360.6844,217.0208 360.8759,216.7772 361.2033,216.5807 361.5392,216.4749 361.8483,216.438 362.1775,216.5421 
		362.9366,217.234 363.9896,216.5286 364.1508,215.8753 365.1636,215.6083 365.523,215.3816 366.3224,214.4881 367.2965,214.0615 
		367.881,213.5761 368.0708,213.1327 367.4376,211.6061 367.8558,210.2491 368.9827,209.327 370.1096,208.5309 370.637,208.667 
		370.6286,208.9827 370.6421,209.3724 371.0602,209.5386 371.6665,210.9276 372.0763,211.1173 372.2729,211.6481 373.0152,211.2232 
		373.7491,210.9964 374.1219,210.9696 374.5133,211.0233 375.0238,210.5396 376.2213,209.898 375.8015,208.6888 376.2011,207.703 
		376.3741,207.3956 376.2683,207.0496 376.4145,206.5307 376.5354,206.1427 376.841,205.8774 376.7352,205.2509 377.3214,204.9167 
		377.8017,204.5976 378.5071,204.7303 378.8144,204.3171 378.3744,203.5177 378.3643,203.1028 377.9982,202.0448 378.1342,201.4771 
		377.9075,200.7449 377.8538,200.105 377.9612,199.7053 378.4282,199.3828 378.7859,199.0402 379.4274,198.931 379.5349,199.2384 
		380.5342,199.1712 380.467,198.8386 380.467,198.4238 381.0884,198.1635 382.0105,197.0248 383.1861,196.7309 383.8008,196.4437 
		384.2005,195.5989 384.0427,195.2395 384.0561,195.0128 384.5616,194.3158 384.7447,192.559 384.6557,192.3054 383.7807,191.5161 
		383.7353,190.5991 383.3356,190.2095 383.8126,189.8534 384.2173,189.6602 384.5633,189.4537 385.5659,189.0137 386.0698,188.8541 
		386.5484,188.5333 387.0221,187.796 387.5729,187.1729 388.0533,186.4927 388.7335,186.654 389.2659,186.6003 389.8268,186.1619 
		390.2383,185.9066 391.1318,185.6413 391.7985,185.1609 392.2704,184.6638 392.8784,184.2406 394.0809,183.7905 394.3026,183.0095 
		394.2774,182.6937 394.2052,181.4459 393.5888,179.5162 393.6493,179.056 393.0615,178.93 392.3712,178.0718 392.2301,177.4185 
		391.2409,175.4703 390.9991,175.5878 390.7455,175.8683 390.2786,176.0531 389.9276,176.4142 389.5833,176.4259 389.4523,176.656 
		389.0794,176.7081 388.8141,177.1615 388.1591,177.175 388.0247,177.6772 387.7274,177.7074 387.4705,177.7359 387.2001,177.7359 
		386.9482,177.8417 386.8121,178.2011 386.6123,178.3876 386.2915,178.4883 386.2025,178.7822 385.6533,178.7755 385.136,178.92 
		384.7733,179.2407 384.5062,179.6942 383.5069,180.2552 383.213,180.3744 382.4119,180.319 381.9735,180.2014 381.8795,180.974 
		381.6931,181.3619 381.4142,181.5484 381.1069,181.6525 381.0011,182.027 380.8869,182.1647 380.1782,181.1369 380.2941,180.1477 
		380.3377,179.7597 380.4133,179.4423 380.2269,179.1483 380.1866,178.4447 380.3377,177.7393 380.3209,177.348 380.1614,176.9331 
		379.9867,176.7887 379.9212,177.1347 379.671,177.2724 379.4274,177.5478 379.4325,177.7091 378.6247,178.0517 377.5195,175.8599 
		377.4843,175.3191 377.7429,175.0135 377.585,174.8271 377.6084,174.6554 377.748,173.6296 377.402,173.3222 377.3449,172.8352 
		376.6042,172.7646 376.4883,172.5463 375.7242,172.3145 375.2657,171.8023 374.5653,172.328 373.645,172.7059 372.8976,173.8261 
		372.3753,173.9319 371.1879,173.512 370.6219,172.4707 370.6387,172.2054 370.1768,171.8829 367.4695,173.3222 366.9354,172.8957 
		366.7759,173.03 366.9102,173.4818 365.9227,173.5339 365.6557,174.2292 365.1905,174.1754 365.0964,174.3349 364.8294,174.3484 
		364.8663,174.5735 364.2164,174.9228 364.1643,175.2285 363.8384,175.6198 363.6571,175.9758 363.2977,176.268 362.8845,176.2025 	
		'
            />
            <polygon
              id='UR02'
              className={getColor('UR02') + ' st13'}
              fill={'url(#' + getColor('UR02') + ')'}
              points='338.6815,203.6294 341.6835,204.8287 359.9894,212.1369 359.9894,212.137 
		363.8481,216.6234 362.9366,217.234 362.1775,216.5421 361.8483,216.438 361.5392,216.4749 361.2033,216.5807 360.8759,216.7772 
		360.6844,217.0208 360.4174,217.7681 360.0899,218.2232 359.8044,218.1141 359.5373,218.1141 359.062,218.0956 358.7244,218.2888 
		358.5111,218.6213 358.5011,219.3552 358.6908,220.0488 358.4171,220.3142 358.3516,220.4872 358.3784,220.7273 358.5649,220.9541 
		358.5179,221.5067 358.5431,222.5731 358.9915,223.1122 359.1897,223.8226 357.6345,225.3963 356.9811,225.3879 356.1817,226.5384 
		356.6486,227.0556 356.4017,227.6989 356.563,228.0852 355.9113,228.6327 355.7517,229.2323 356.4571,230.0149 356.6486,230.9772 
		357.3909,231.6322 357.6714,231.7784 357.9384,232.0723 358.3885,232.173 359.1158,232.2167 359.3509,232.8331 359.2182,233.9785 
		359.5508,234.6587 359.2703,235.0718 359.2568,236.1517 359.6901,236.7362 359.6179,237.4449 359.8413,237.9538 359.5373,238.9901 
		359.4584,239.7039 358.7244,239.8835 357.9132,240.2161 357.5119,240.6712 357.045,240.9635 356.872,241.3363 356.2455,241.8704 
		355.5653,242.2836 354.8986,242.4296 353.8271,242.5506 353.3266,242.2919 353.0343,241.296 353.1788,240.8442 352.8781,240.7082 
		352.7371,240.3437 351.951,240.0196 351.5799,240.0834 351.2373,240.0112 350.7956,240.6124 349.5108,240.8929 348.1168,240.9433 
		347.2872,240.3185 346.9244,240.2984 346.4121,239.4368 345.8881,239.0707 344.7965,239.5225 344.1012,239.4838 342.6618,239.42 
		341.4778,238.5551 341.0529,238.9498 340.4667,238.9833 339.8151,239.5963 339.6774,240.2547 339.1819,240.3538 339.2676,240.8425 
		339.0409,241.2372 339.1903,242.2987 338.6882,242.8562 338.3809,243.3786 338.2347,243.8303 338.5807,244.5089 338.3809,245.2025 
		338.8074,246.0557 339.0694,247.5219 337.9946,247.8074 337.5142,248.0022 337.2757,248.2574 336.7686,248.2961 336.4243,248.4556 
		335.9204,248.3918 335.3578,248.7143 334.3417,248.8537 334.1956,249.282 333.7051,249.7102 333.589,249.6753 333.1576,249.5456 
		332.0492,248.2356 331.1507,248.6589 329.5081,248.0257 328.7625,247.3421 328.4904,247.4967 328.1897,247.448 327.8874,246.9223 
		327.397,246.8249 327.1501,246.2354 326.8159,245.409 326.6429,244.6231 326.6631,243.7632 326.4968,243.7161 326.2835,243.5566 
		326.1542,243.1098 326.1458,242.5943 325.7746,241.6739 324.8744,240.552 324.8845,239.8785 324.6074,239.6787 324.5906,239.2067 
		324.3605,238.9078 324.8644,236.9126 324.5318,236.4473 324.5637,236.0728 325.3044,235.3506 325.7477,234.2724 325.6621,233.9365 
		326.1088,233.2227 326.0836,231.5332 326.3372,231.2006 326.1441,230.9924 325.8603,229.6236 326.0517,229.3213 326.0753,227.6149 
		326.2483,227.3479 325.7477,226.5417 324.7484,226.4074 324.4294,223.8932 323.6568,223.4767 323.4318,222.7797 323.1177,222.4925 
		323.0841,222.291 323.2235,221.4529 322.9917,220.5964 323.2722,219.8507 323.1513,219.582 323.2588,219.0092 324.3907,219.4157 
		324.9097,219.3855 325.1935,219.6038 325.2339,219.9783 325.6504,220.0287 325.9124,219.98 326.9553,220.2084 327.5364,220.0136 
		328.6146,220.2857 329.278,219.9363 330.0456,219.676 330.148,218.6616 330.3781,218.0267 330.3714,217.7379 329.975,216.7537 
		330.2051,216.0382 330.185,215.5529 329.5132,215.269 329.3351,214.8576 329.4023,214.1337 329.3351,212.5617 329.6173,212.0007 
		328.4501,210.595 328.4568,209.5621 328.6969,208.8282 328.6298,208.2555 328.1494,207.629 328.4954,207.3755 328.8162,207.483 
		329.1219,206.9875 329.4359,205.5297 329.436,205.5297 331.2648,204.6111 331.2649,204.611 331.6764,204.4767 332.1164,204.7034 
		332.543,204.8243 333.7287,204.5035 334.8623,203.8637 334.382,202.2648 	'
            />
            <polygon
              id='UR01'
              className={getColor('UR01') + ' st13'}
              fill={'url(#' + getColor('UR01') + ')'}
              points='333.6458,176.8623 333.7805,176.8886 335.8528,177.2925 336.1975,177.3597 
		336.6521,177.4483 336.8231,177.0921 340.7197,168.9768 342.6472,169.1692 348.8315,169.7868 359.0449,170.8066 359.2779,171.2076 
		359.1779,171.243 359.2779,171.2076 359.7792,171.0297 360.1503,171.0045 360.6709,171.7217 361.1849,173.6564 360.7348,174.3937 
		360.8389,174.8506 361.1647,175.4552 361.7777,175.7894 362.2177,176.4931 362.4697,176.3487 362.8845,176.2025 362.7525,177.1879 
		359.9894,212.137 341.6835,204.8287 338.6815,203.6294 334.382,202.2648 334.1418,201.7845 333.8244,201.4032 333.1442,200.849 
		333.5658,199.9941 333.4902,199.1275 332.239,199.6918 331.8493,199.3005 331.364,199.1796 331.4849,199.0889 331.4849,199.0889 
		331.3035,198.7983 332.3196,198.978 333.5557,198.2357 333.5557,198.2357 333.7371,197.2381 333.0569,196.2892 333.6094,195.5855 
		333.7488,195.1303 333.8362,193.9581 334.1015,192.9856 334.5281,192.119 336.3,191.1634 336.5418,190.8225 336.4847,190.4311 
		336.6795,190.3186 336.0732,189.8299 335.4837,188.7936 335,188.965 334.2073,188.8407 333.2887,188.1336 332.9007,188.2797 
		332.7965,188.5468 332.1667,188.5333 331.6377,187.5307 332.0576,186.1871 331.8493,185.5606 331.4227,184.8401 331.5957,184.4136 
		332.0995,184.306 332.4758,183.856 333.0065,183.4462 332.674,182.3444 332.1936,181.8053 332.3314,181.4291 331.8846,181.199 
		331.3152,180.6549 330.7694,180.6817 330.3563,180.4147 331.1288,179.3885 333.2181,178.579 	'
            />
            <polygon
              id='TI01'
              className={getColor('TI01') + ' st13'}
              fill={'url(#' + getColor('TI01') + ')'}
              points='329.2792,291.0424 329.2478,290.9617 329.5921,290.3773 329.5384,289.3494 
		329.8239,288.6272 331.149,288.2678 331.3623,287.1661 331.8812,286.8873 332.5211,285.8745 332.4287,285.3018 335.0356,284.7358 
		338.3479,285.1122 340.3805,284.9617 340.8322,287.446 340.0794,290.9088 337.294,291.2852 335.1109,290.9088 333.53,291.8122 
		332.0996,291.9628 331.121,291.8875 330.0671,291.6617 329.2478,290.9617 	'
            />
            <polygon
              id='TG06'
              className={getColor('TG06') + ' st13'}
              fill={'url(#' + getColor('TG06') + ')'}
              points='413.8966,70.3082 397.424,55.7557 397.2517,52.3528 398.1671,48.7707 423.8704,39.1032 
		422.5166,63.625 	'
            />
            <polygon
              id='TG05'
              className={getColor('TG05') + ' st13'}
              fill={'url(#' + getColor('TG05') + ')'}
              points='368.4279,33.8858 368.5293,33.9402 368.6687,34.0107 368.7375,34.0477 368.8517,34.1165 
		369.0449,34.2475 369.1137,34.2862 369.4261,34.4742 369.5201,34.5263 369.6108,34.5767 369.7049,34.6254 369.8224,34.6825 
		369.9165,34.7262 370.0139,34.7681 370.1096,34.8068 370.2087,34.8454 370.2591,34.8622 370.2826,34.8689 370.3078,34.874 
		370.333,34.8756 370.3868,34.8857 370.4388,34.8857 370.5178,34.884 370.5401,34.8825 370.6185,34.8924 371.025,34.8252 
		370.9973,34.7575 370.6646,33.9418 370.7891,33.5056 371.0636,32.7948 371.0387,32.4886 371.2248,32.1213 371.4348,31.7434 
		371.7178,31.6606 371.9763,31.6797 372.1956,31.7585 372.2845,31.7024 372.3165,31.7048 372.5343,31.5448 372.7095,31.4344 
		372.7002,31.4231 372.7397,31.3941 372.3417,30.9473 372.3022,30.9423 372.2258,30.8499 372.1284,30.8885 371.8684,30.887 
		371.8306,30.8822 371.166,30.7021 371.2517,30.3192 371.1408,29.7717 371.0586,29.6978 370.6656,29.4459 370.5883,29.3955 
		370.4036,29.2746 370.2322,29.2024 370.113,29.2981 369.7922,29.3804 369.2162,29.3031 368.9328,29.2201 369.3521,25.3405 
		369.4166,25.2081 369.4648,25.1565 369.6495,25.3177 369.7298,25.2232 369.7351,25.227 369.9199,25.0406 370.1567,25.1246 
		370.1885,25.0569 370.3129,24.8189 370.597,24.9091 371.2366,25.1246 371.2231,25.0801 371.2231,24.8609 370.8738,23.7323 
		371.2483,23.5929 371.2404,23.5657 371.7455,23.4199 371.7331,23.3675 371.8546,23.346 371.9121,23.152 372.0159,23.1293 
		372.1473,23.0735 372.256,23.262 372.2057,23.734 372.4022,24.3789 372.8486,24.4799 372.8372,24.5389 372.7129,24.6342 
		372.7878,24.7943 372.7678,24.8975 372.7481,24.923 372.3988,25.1397 371.9706,25.3916 371.9773,25.62 372.3165,25.5814 
		372.7263,25.6435 372.9514,25.7124 373.0907,25.9307 373.7206,26.8628 374.1191,26.7363 374.5605,26.6521 374.5676,26.661 
		374.2882,27.1903 374.287,27.192 374.2849,27.1937 373.7642,27.6354 373.7693,27.7546 374.0499,27.8211 374.2582,28.014 
		374.2563,28.0233 374.441,28.1073 374.7038,28.0112 374.9592,27.939 375.1548,27.894 375.1593,27.8824 375.1952,27.8722 
		375.2849,27.5991 375.524,27.4406 375.5898,27.4218 375.6654,27.5581 375.8367,27.5514 376.5001,27.7227 376.5572,27.8521 
		376.7855,27.8182 376.8646,27.8461 377.1417,28.0385 377.2239,28.7707 377.5397,29.4392 377.5929,29.4178 377.6371,29.5231 
		378.2568,29.2359 379.0882,29.3484 379.7213,29.0629 380.1691,29.2149 380.1698,29.2158 380.1707,29.2154 380.5583,29.3469 
		380.5512,29.3616 380.2935,29.6557 380.2151,29.7247 380.2224,29.7367 380.205,29.7566 380.5409,30.2655 381.0023,30.7037 
		380.85,31.0767 380.4738,31.2312 380.3969,31.2203 380.279,31.122 380.1508,31.1854 379.8927,31.1489 379.8399,31.201 
		379.6357,31.3437 379.3644,31.4069 379.3354,31.3432 379.3527,31.2878 379.6004,31.0431 379.6886,30.8827 379.7952,30.8113 
		379.7524,30.7667 379.7852,30.7072 379.4258,30.3024 379.3183,30.5275 379.0456,30.7028 379.0046,30.6537 378.9958,30.4385 
		378.7691,30.3024 378.3596,30.5455 378.0839,30.4771 378.0583,30.5451 377.9125,30.5207 377.7933,31.117 378.0049,31.1741 
		378.0372,31.1662 378.0587,31.1959 378.3324,31.2211 378.6591,31.3992 378.67,31.4092 378.5423,32.1112 378.1829,32.3228 
		378.1688,32.5026 378.1035,32.6828 377.9109,32.7528 377.8538,32.9795 377.8806,33.2919 377.8118,33.5455 377.8302,33.564 
		377.8672,33.6076 377.884,33.6261 377.9025,33.6396 377.931,33.6463 377.9529,33.6479 377.978,33.6496 377.9982,33.6463 
		378.0318,33.6429 378.0579,33.6379 378.3539,33.6673 378.3643,33.6715 378.4147,33.6916 378.4869,33.7269 378.5356,33.747 
		378.5575,33.7554 378.5843,33.7605 378.6062,33.7638 378.633,33.7638 378.6599,33.7605 378.6851,33.7554 378.764,33.7353 
		378.8144,33.7252 378.8684,33.7184 379.1402,33.7453 379.6104,34.1013 380.0169,34.5313 380.4402,35.3409 380.7945,35.5508 
		381.0632,37.0103 381.1556,37.3613 381.0683,37.5225 381.0397,38.2531 381.0297,38.4949 381.0817,38.4865 381.2888,38.4543 
		381.3303,38.4489 381.3874,38.4429 381.4296,38.4403 381.7905,38.505 382.44,38.8847 382.5462,38.9971 382.5832,39.0357 
		382.6033,39.0508 382.7679,39.1785 382.9577,39.3195 383.1508,39.4522 383.2399,39.511 383.3289,39.5681 383.3961,39.6067 
		383.4649,39.647 383.5355,39.6806 383.5825,39.7008 383.6077,39.7092 383.6346,39.7142 383.6866,39.721 383.7152,39.7243 
		383.7622,39.7226 383.8176,39.7176 383.8932,39.7042 384.0225,39.6756 384.1233,39.6504 384.237,39.6213 384.5364,39.7176 
		387.7,38.3429 387.8131,38.2984 387.8708,38.277 389.3565,38.1036 389.5768,37.8841 389.6471,37.8416 390.0149,37.6417 
		390.1728,37.5477 390.3542,37.4436 390.7337,37.2135 390.9386,37.0942 391.1452,36.9817 391.4643,36.8104 391.5382,36.7701 
		391.6994,36.6828 392.0168,36.5014 392.1075,36.4476 392.1966,36.3922 392.2839,36.3334 392.3193,36.3091 392.4468,36.2528 
		394.8065,34.3584 396.3516,33.5583 398.1671,48.7707 397.2517,52.3528 368.5172,42.8628 367.6292,41.2566 	'
            />
            <polygon
              id='TG04'
              className={getColor('TG04') + ' st13'}
              fill={'url(#' + getColor('TG04') + ')'}
              points='383.233,74.3843 376.3834,73.5993 368.5172,42.8628 397.2517,52.3528 397.424,55.7557 
		392.9294,66.6632 	'
            />
            <polygon
              id='TG03'
              className={getColor('TG03') + ' st13'}
              fill={'url(#' + getColor('TG03') + ')'}
              points='400.5173,102.3715 392.1216,98.6171 383.233,74.3843 392.9294,66.6632 405.6304,94.3638 	
		'
            />
            <polygon
              id='TG02'
              className={getColor('TG02') + ' st13'}
              fill={'url(#' + getColor('TG02') + ')'}
              points='396.3516,33.5583 398.0815,32.6621 399.5678,32.1918 404.7356,33.2465 405.5855,33.3268 
		405.6627,33.3792 405.7047,33.4078 405.75,33.433 405.7735,33.4447 405.797,33.4531 405.8222,33.4598 405.8491,33.4649 
		405.9045,33.4682 405.9784,33.4682 406.0338,33.4682 406.2404,33.4884 406.3227,33.4951 406.4218,33.4968 406.5545,33.4917 
		406.6602,33.4817 406.7392,33.4749 406.8434,33.4615 406.9071,33.4516 409.3651,33.6838 409.4208,33.7075 411.3175,35.2115 
		411.4764,35.2418 411.5929,35.319 411.6836,35.3577 411.8767,35.4383 411.9742,35.4802 412.0732,35.5189 412.1186,35.5323 
		412.1455,35.539 412.1723,35.539 412.2546,35.529 412.3588,35.529 412.4864,35.5306 412.5922,35.534 412.6443,35.539 
		412.6964,35.5491 412.745,35.5609 412.7921,35.5878 412.8878,35.6297 412.913,35.6398 412.9617,35.6549 413.0373,35.6818 
		413.1145,35.7036 413.2153,35.7271 413.2657,35.7389 413.3161,35.7406 413.3412,35.7389 413.4692,35.7264 413.5401,35.7357 
		413.5512,35.7389 413.5999,35.759 413.6721,35.7926 413.8535,35.8716 413.9576,35.9203 414.0282,35.9589 414.0802,35.9908 
		414.1541,36.0177 414.2029,36.0328 414.228,36.0395 414.2801,36.0479 414.3338,36.0496 414.3909,36.053 414.438,36.0496 
		414.5152,36.0412 414.5673,36.0328 414.6445,36.0126 414.6932,35.9959 414.7167,35.9824 414.7386,35.9707 414.7604,35.9522 
		414.7991,35.9186 414.8528,35.8615 414.8965,35.8229 414.9687,35.7473 415.08,35.6315 415.2643,35.4651 415.6102,35.4114 
		416.4596,35.5975 416.5625,35.6281 416.5979,35.6381 416.9523,36.2414 416.9505,36.2562 416.9538,36.2814 416.9605,36.3049 
		416.9723,36.325 416.9874,36.3435 417.021,36.3821 417.058,36.4191 417.0983,36.451 417.2041,36.5367 417.2354,36.5645 
		417.3838,36.718 418.2773,37.6518 418.2778,37.6517 418.3209,37.7324 418.5124,37.6065 418.8531,37.5392 418.9402,37.5827 
		418.9944,37.8634 419.7905,37.4822 419.8929,37.4318 420.3682,37.1984 421.4448,37.3579 422.3248,37.499 422.3584,37.5024 
		422.5129,37.4896 422.6086,37.504 424.5254,37.3353 423.8704,39.1032 398.1671,48.7707 	'
            />
            <polygon
              id='TG01'
              className={getColor('TG01') + ' st13'}
              fill={'url(#' + getColor('TG01') + ')'}
              points='424.5254,37.3353 426.3808,37.1715 428.0602,36.6676 428.5626,36.6676 429.0663,36.6693 
		430.5778,37.1715 450.3647,46.7027 448.2093,58.7968 435.2672,72.7083 429.1651,71.5505 422.5166,63.625 423.8704,39.1032 	'
            />
            <polygon
              id='SZ05'
              className={getColor('SZ05') + ' st13'}
              fill={'url(#' + getColor('SZ05') + ')'}
              points='356.1141,137.6608 352.7658,125.5574 357.2706,112.2388 370.2981,105.2371 
		373.2689,109.105 376.2714,122.5475 	'
            />
            <polygon
              id='SZ04'
              className={getColor('SZ04') + ' st13'}
              fill={'url(#' + getColor('SZ04') + ')'}
              points='359.0449,170.8066 340.7197,168.9768 341.0145,154.6342 356.0078,140.2967 
		364.5141,151.6552 	'
            />
            <polygon
              id='SZ03'
              className={getColor('SZ03') + ' st13'}
              fill={'url(#' + getColor('SZ03') + ')'}
              points='359.0449,170.8066 359.0449,170.8066 359.2779,171.2076 359.7792,171.0297 
		360.0042,170.9894 360.1503,171.0045 360.1503,171.0045 360.671,171.7217 361.1849,173.6564 360.9368,174.0628 360.7348,174.3937 
		360.8389,174.8506 361.1647,175.4552 361.7777,175.7894 362.2177,176.4931 362.4697,176.3487 362.8845,176.2025 363.2977,176.268 
		363.6571,175.9758 363.8384,175.6198 364.1643,175.2285 364.2164,174.9228 364.8663,174.5735 364.8294,174.3484 365.0964,174.3349 
		365.1905,174.1754 365.6557,174.2292 365.9227,173.5339 366.9102,173.4818 366.7759,173.03 366.9354,172.8957 367.4695,173.3222 
		370.1768,171.8829 370.6387,172.2054 370.6219,172.4707 371.1879,173.512 372.3753,173.9319 372.8976,173.8261 373.645,172.7059 
		374.5653,172.328 375.2657,171.8023 375.7242,172.3145 376.4883,172.5463 376.6042,172.7646 377.3449,172.8352 377.402,173.3222 
		377.748,173.6296 377.6084,174.6554 377.585,174.8271 377.7429,175.0135 377.4843,175.3191 377.5195,175.8599 378.6247,178.0517 
		379.4325,177.7091 379.4274,177.5478 379.671,177.2724 379.9212,177.1347 379.9867,176.7887 380.1614,176.9331 380.3209,177.348 
		380.3377,177.7393 380.1866,178.4447 380.2269,179.1483 380.4133,179.4423 380.3377,179.7597 380.2941,180.1477 380.1782,181.1369 
		380.8869,182.1647 381.0011,182.027 381.1069,181.6525 381.4142,181.5484 381.6931,181.3619 381.8795,180.974 381.9735,180.2014 
		382.4119,180.319 383.213,180.3744 383.5069,180.2552 384.5062,179.6942 384.5062,179.6942 384.7733,179.2407 385.136,178.92 
		385.6533,178.7755 386.2025,178.7822 386.2915,178.4883 386.6123,178.3876 386.8121,178.2011 386.9482,177.8417 387.2001,177.7359 
		387.4705,177.7359 387.7274,177.7074 388.0247,177.6772 388.1591,177.175 388.8141,177.1615 389.0794,176.7081 389.4523,176.656 
		389.5833,176.4259 389.5833,176.4259 389.9276,176.4142 390.2786,176.0531 390.7455,175.8683 390.9991,175.5878 391.2409,175.4703 
		391.8321,175.0723 392.2788,175.0823 392.9036,174.466 393.5099,174.5013 393.6846,174.3266 394.7813,174.209 394.9459,173.8412 
		394.4991,173.2651 394.2774,173.1761 394.0776,172.8167 393.8508,172.4287 393.7484,171.9199 394.2909,170.4285 394.5848,170.1765 
		394.6755,168.9657 394.7981,168.7104 395.2381,168.403 395.438,168.2435 395.6512,168.0587 395.3439,168.0201 393.824,167.5096 
		392.8247,166.3507 392.4233,166.6849 390.6346,163.8987 391.7448,163.4317 391.8187,162.8826 391.3282,163.0757 391.162,162.6642 
		391.0075,162.7029 390.6212,162.2527 390.5223,162.0119 390.1342,161.067 389.3011,160.3667 389.1332,160.58 388.7855,160.1971 
		388.4395,159.2364 387.8937,158.9761 387.7527,157.4477 386.6392,156.7256 386.1722,156.7793 385.7742,156.7256 385.4736,156.2637 
		377.1959,150.9305 364.5141,151.6552 	'
            />
            <polygon
              id='SZ02'
              className={getColor('SZ02') + ' st13'}
              fill={'url(#' + getColor('SZ02') + ')'}
              points='377.1959,150.9305 377.1959,150.9305 385.4736,156.2637 385.7692,156.21 
		385.7944,155.9564 386.8524,155.5651 386.4729,154.6816 386.4141,153.8537 386.5602,153.5933 388.144,153.1533 388.4261,153.4187 
		388.9871,153.501 391.2393,152.2581 391.3719,151.8181 391.3719,151.8181 391.7582,151.4873 392.4468,151.3294 392.519,150.1941 
		392.7743,149.1931 393.1975,148.2996 393.6644,147.7941 393.8122,147.3742 394.0255,147.1139 394.0641,146.5681 393.9634,146.2825 
		394.4655,146.0491 394.4655,146.0491 394.7108,145.6242 394.5982,145.2345 395.4514,144.7677 395.757,144.4351 393.6241,143.7549 
		393.1052,143.4745 393.0565,142.9488 393.7316,141.8235 395.1709,141.1148 394.9308,140.3288 395.1844,139.9022 395.1255,139.489 
		395.4749,138.9986 395.2415,138.4477 394.6049,138.2479 394.353,137.7675 394.8367,136.167 394.6906,135.5523 394.8468,135.3827 
		394.5697,134.9863 395.4044,134.2843 395.5068,133.7704 396.491,132.3428 396.5851,132.0237 396.9445,131.4258 397.1578,130.7977 
		399.0942,128.2096 398.1067,127.4555 398.199,127.3128 398.199,127.3127 397.314,126.7519 397.3139,126.7518 397.3139,126.7518 
		396.2492,126.3521 396.2491,126.3521 395.7688,126.2597 395.7436,126.5318 395.2633,126.4949 395.1978,126.8324 395.1977,126.8324 
		394.8723,126.7991 394.7947,127.0911 393.7657,126.9724 393.7938,126.6886 393.7097,126.6911 378.8215,127.1359 	'
            />
            <polygon
              id='SZ01'
              className={getColor('SZ01') + ' st13'}
              fill={'url(#' + getColor('SZ01') + ')'}
              points='364.5141,151.6552 356.0078,140.2967 356.1141,137.6608 376.2714,122.5475 
		378.8215,127.1359 377.1959,150.9305 	'
            />
            <polygon
              id='SO04'
              className={getColor('SO04') + ' st13'}
              fill={'url(#' + getColor('SO04') + ')'}
              points='210.6993,143.4478 205.457,140.2323 204.1366,111.9644 204.9402,110.3858 
		205.6638,109.2571 206.0111,109.4018 207.0819,108.9098 206.9372,108.5625 206.2799,108.2433 206.1803,107.0045 205.8817,106.5732 
		206.114,105.9869 206.3905,106.0312 207.1095,105.9095 207.6957,105.7325 208.4921,105.2127 208.9234,105.0136 209.6756,104.3831 
		210.4277,103.7969 211.4674,103.3102 212.12,103.1554 212.662,103.0116 213.1044,102.912 213.4362,102.8235 213.8344,102.7351 
		214.1441,102.6134 214.2365,102.5646 215.3669,102.3355 215.4493,102.37 215.5738,102.2935 218.2435,101.7518 224.99,130.7227 	'
            />
            <polygon
              id='SO03'
              className={getColor('SO03') + ' st13'}
              fill={'url(#' + getColor('SO03') + ')'}
              points='252.8336,111.5132 247.3911,105.2454 244.7467,94.0739 245.0555,91.909 264.7316,80.656 
		265.3284,81.3472 267.7985,94.9196 	'
            />
            <polygon
              id='SO02'
              className={getColor('SO02') + ' st13'}
              fill={'url(#' + getColor('SO02') + ')'}
              points='238.7895,116.5526 226.4347,100.7273 244.7467,94.0739 247.3911,105.2454 	'
            />
            <polygon
              id='SO01'
              className={getColor('SO01') + ' st13'}
              fill={'url(#' + getColor('SO01') + ')'}
              points='203.3585,140.6792 187.3687,121.7998 189.3985,121.1232 189.7458,121.3548 
		190.2089,121.2969 192.0033,119.9077 195.0711,118.5764 195.8815,117.766 196.4314,117.4187 196.8365,117.5923 197.5601,117.0135 
		197.2417,116.6083 197.0681,116.0005 197.0102,115.277 197.3286,114.9007 198.3415,114.5824 198.9782,114.1772 199.9912,113.3958 
		200.8594,113.309 201.4962,113.2511 202.2486,113.1643 203.1748,113.0196 203.58,112.8748 204.1299,111.9776 204.1366,111.9644 
		205.457,140.2323 	'
            />
            <g
              id='SH02'
              className={getColor('SH02') + ' st13'}
              fill={'url(#' + getColor('SH02') + ')'}
            >
              <polygon
                id='_x3C_Path_x3E__00000044163182645688646640000001608473783973258684_'
                points='334.7699,40.7223 
			334.466,40.6833 334.1267,40.6077 333.7119,40.6228 333.6732,40.7992 333.1576,40.7807 332.8839,40.6816 332.9695,41.1032 
			332.9377,41.4189 333.0226,41.58 333.0234,41.6042 332.8481,41.6117 332.7921,41.5988 332.7143,41.4491 332.5292,41.5383 
			332.4708,41.5249 332.3582,41.2291 332.16,41.0561 331.8896,41.2812 331.5789,41.2325 331.416,40.9319 331.5067,40.6682 
			331.3842,40.5481 331.3025,40.356 331.2901,40.297 330.7342,40.1408 330.4369,40.1962 330.316,40.3356 330.3361,40.5489 
			330.4419,40.7203 330.7291,40.7908 330.9105,40.9184 330.9441,41.1519 330.5309,41.4374 330.1212,41.5986 330.232,41.8623 
			330.3328,41.8724 330.4723,41.8598 330.5813,41.8875 330.7729,41.9405 330.981,42.0789 330.5158,42.1663 330.4668,42.2744 
			330.2354,42.2587 329.9559,42.1415 329.6643,41.8001 329.493,41.5247 329.3469,40.9117 329.179,40.4499 329.4342,39.6823 
			329.5262,39.3044 329.5904,39.0962 329.5803,39.0824 329.5904,39.0408 329.4709,38.9344 329.4527,38.9098 329.4493,38.9152 
			329.3922,38.8644 329.2226,39.0878 329.142,39.0055 328.9472,39.1835 328.7322,39.4388 328.3627,39.689 328.2569,39.5463 
			327.8874,39.2927 327.6607,39.3078 327.4827,39.2557 327.3063,39.3195 326.9708,39.4443 326.3658,38.9836 326.1542,38.8846 
			326.013,38.8709 326.0098,38.8543 325.7511,38.8443 325.5093,38.4042 325.2842,38.112 324.4831,37.4268 324.2547,37.3445 
			324.0767,37.106 323.3478,37.1782 323.0942,37.2202 323.0258,37.2307 322.7255,37.2328 322.6491,37.2236 322.3216,36.6509 
			322.0428,36.1369 321.8473,35.9414 321.827,35.8957 321.7741,35.6969 321.9622,35.1695 322.1125,34.9427 322.1439,34.904 
			322.5366,34.8017 323.0841,34.7245 323.1181,34.6784 323.1227,34.6775 323.1389,34.6503 323.2924,34.4423 323.3186,34.3476 
			323.4149,34.1854 323.5561,34.0014 323.6568,33.9267 323.4295,33.5259 323.4138,33.4948 323.3578,33.2331 323.331,33.1122 
			322.5584,32.0004 322.1402,31.7971 321.8312,31.782 321.6901,31.3588 321.5884,31.3064 322.1604,30.4636 322.7566,29.7079 
			322.8141,29.6206 322.8288,29.6037 322.901,29.5265 322.9178,29.508 322.9329,29.4862 322.9497,29.4644 322.9581,29.4408 
			322.9901,29.3703 323.0038,29.333 323.1775,29.0695 323.1882,29.0713 323.2403,29.0797 323.2655,29.0797 323.2924,29.073 
			323.3142,29.0613 323.3287,29.055 323.5074,29.1218 323.5308,29.1469 324.1841,28.7304 324.2497,28.8262 324.3274,28.7516 
			324.332,28.7522 324.4584,28.6258 324.8341,28.2652 324.9467,28.2047 325.0778,28.0064 325.5947,27.4895 325.6017,27.4842 
			325.6644,27.4713 326.2163,27.5867 326.2785,27.3381 326.0939,27.2531 326.0383,27.1937 326.2451,26.9364 326.5471,26.6696 
			326.6614,26.5857 326.8965,26.5538 327.3701,26.6126 327.9008,26.6932 327.9193,26.6311 327.9496,26.532 327.8188,26.4634 
			327.8234,26.1547 327.8303,26.1121 327.8387,25.7797 327.844,25.7707 328.1293,25.4722 328.1259,25.4101 328.1209,25.2589 
			328.0503,25.185 327.6036,25.18 327.4104,24.6274 327.1854,23.7407 327.3147,23.3544 327.4928,23.178 327.5834,23.0958 
			327.9512,22.869 327.9083,22.7037 327.916,22.6238 328.0016,22.3904 328.0051,22.3127 328.0067,22.2896 328.0064,22.285 
			328.0268,21.8311 328.2871,21.559 329.0815,21.1123 329.3167,20.8771 329.577,19.9333 329.6895,19.5739 330.1984,18.855 
			330.3966,18.6938 331.0163,18.1849 331.2649,17.9616 331.5268,17.5444 331.5386,17.5316 331.5493,17.5209 331.8712,17.3301 
			332.0526,17.1436 332.1063,17.2036 332.202,17.357 332.2604,17.3754 332.3011,17.4208 332.5652,17.4717 332.941,17.5904 
			332.9859,17.5528 332.9981,17.5551 333.7137,17.0402 333.8614,17.1218 334.0981,16.9572 334.602,16.89 334.6147,16.8442 
			334.6524,16.8363 334.7246,16.5553 335.4501,17.058 335.8045,17.5131 335.9276,17.565 336.0027,17.6525 336.3436,16.6432 
			336.7602,16.1645 337.0119,16.1606 337.0423,16.1645 337.1464,16.1679 337.3295,16.1746 337.4138,16.1704 339.5998,31.3152 		'
              />
              <polygon
                id='_x3C_Path_x3E__00000146485473815530619160000013412758936709891216_'
                points='319.3519,56.0304 
			319.3573,56.0271 319.3976,55.9918 319.4363,55.9582 319.4749,55.9196 319.5102,55.8826 319.5438,55.844 319.5572,55.8205 
			319.5673,55.7953 319.5757,55.7718 319.6093,55.671 319.6462,55.545 319.6865,55.3956 319.6982,55.3435 319.7285,55.1873 
			319.7373,55.1494 319.8564,54.8629 319.9048,54.7843 319.9787,54.6734 320.0241,54.6129 320.0745,54.5491 320.1417,54.4685 
			320.2273,54.3711 320.2844,54.3157 320.3012,54.2972 320.4137,54.188 320.4893,54.1125 320.5464,54.0587 320.5499,54.0559 
			320.7614,53.9546 320.9271,53.8773 320.9461,53.8773 320.9982,53.8723 321.0251,53.874 321.0771,53.874 321.1292,53.8807 
			321.1544,53.8857 321.2333,53.9042 321.282,53.916 321.3324,53.9344 321.455,53.9814 321.5742,54.0335 321.717,54.1007 
			321.8111,54.1461 321.8816,54.183 321.9504,54.2216 322.0176,54.2619 322.1285,54.3308 322.3922,54.5004 322.723,54.7087 
			322.8574,54.791 322.9716,54.8548 323.0858,54.9169 323.205,54.9774 323.368,55.0563 323.5342,55.1386 323.7223,55.2276 
			324.08,55.3956 324.3353,55.4896 324.4562,55.5383 324.5049,55.5602 324.5536,55.582 324.6578,55.6374 324.7619,55.6912 
			324.8341,55.7231 324.9063,55.7483 324.9836,55.7668 325.0592,55.7835 325.2825,55.8152 325.2926,55.8188 325.3015,55.818 
			325.3195,55.8205 325.3464,55.8238 325.3716,55.8222 325.4505,55.8087 325.5141,55.7971 325.7713,55.7718 326.0044,55.705 
			326.0148,55.7029 326.0937,55.6861 326.1441,55.6727 326.1945,55.6593 326.2432,55.6425 326.3171,55.6156 326.3182,55.615 
			326.3339,55.6105 327.312,55.1371 327.3583,55.1176 326.5748,56.6365 322.4114,59.7397 320.5258,58.6213 		'
              />
              <polygon
                points='329.1186,51.7133 329.0811,51.7138 328.9308,51.7158 328.959,50.9937 328.9951,50.8821 
			328.9539,50.6051 328.7618,50.2745 328.4579,50.0008 328.4088,49.1131 328.7099,49.1647 328.7467,49.1087 328.8225,49.1633 
			329.1972,49.1029 329.2715,49.0464 329.4218,49.0444 329.5336,48.9874 329.5712,48.9869 329.8318,48.817 329.8686,48.761 
			329.8282,48.5394 329.8274,48.4839 330.0534,48.5364 330.0527,48.4809 330.0902,48.4804 330.2375,48.2564 330.2367,48.2009 
			330.1595,48.0354 330.1205,47.9249 330.5334,47.9194 330.6858,48.084 331.0531,47.4684 331.0524,47.4129 331.1267,47.3564 
			331.1245,47.1898 331.1223,47.0233 331.084,46.9683 331.0833,46.9128 331.1569,46.8008 331.3055,46.6877 331.3806,46.6867 
			331.4954,46.8518 331.6088,46.9058 		'
              />
            </g>
            <g
              id='SH01'
              className={getColor('SH01') + ' st13'}
              fill={'url(#' + getColor('SH01') + ')'}
            >
              <path
                id='_x3C_Path_x3E_'
                d='M354.2579,33.142l0.0375-0.0006l0.0758,0.0543l0.0375-0.0006l0.0375-0.0006
			l0.0375-0.0006l0.075-0.0012l-0.0009-0.0555l0.0384,0.0549l0.0375-0.0006l0.075-0.0012l0.0383,0.0549l0.1133,0.0537l0.0375-0.0006
			l0.0758,0.0543l0.0375-0.0006l0.0375-0.0006l0.0375-0.0006l0.0741-0.0567l0.0741-0.0567l0.0741-0.0567l0.1874-0.003l0.5579-0.2864
			l0.4062-0.3951l0.5177-0.4524l0.4026-0.6172l0.1481-0.1134l0.1874-0.003l0.9807,0.373l0.0384,0.0549l0.1508,0.0531l0.0384,0.0549
			l0.1517,0.1086l0.3418,0.2721l0.4525,0.1593l0.5622-0.0091l0.224-0.0592l0.0375-0.0006l0.0375-0.0006l0.0375-0.0006l0.0375-0.0006
			l0.0366-0.0561l0.0375-0.0006l0.0375-0.0006l0.1856-0.1141l-0.0009-0.0555l-0.0474-0.61l-0.0027-0.1665l-0.0374,0.0006
			l-0.0009-0.0555l-0.754-0.2653l-0.0027-0.1665l0.0651-0.6118l-0.2303-0.3294l-0.116-0.2202l-0.158-0.4972l-0.041-0.2214
			l-0.0812-0.3874l-0.074,0.0567l-0.0768-0.1098l0.074-0.0567l-0.1543-0.2751l-0.0767-0.1098l-0.0027-0.1666l-0.4174-0.3264
			l-0.1115,0.0573l-0.2622,0.0042l-0.0366,0.0561l-0.1097,0.1684l-0.9304,0.4035l-0.0348,0.1671l0.0767,0.1098l0.0392,0.1104
			l-0.2614,0.0597l-0.2605,0.1152l-0.2623,0.0042l-0.0758-0.0543l-0.3023-0.1618l-0.1516-0.1086l-0.0009-0.0555l0.0357-0.1116
			l0.1481-0.1134l-0.0009-0.0555l-0.5271-0.1582l-0.4478,0.1181l-0.183,0.2805l-0.1115,0.0573l-0.264-0.1069l-0.1516-0.1087
			l-0.1899-0.1636l-0.1124,0.0018l-0.0008-0.0555l0.0008,0.0555l-0.189-0.1081l0.2029,0.9963l1.0213,0.5947l0.3574,1.2714
			l0.0009,0.0555l-0.1124,0.0018l-0.1883-0.0526l0.0428,0.3325l-0.1455,0.2799l-0.1133-0.0538l-0.2222,0.1701l-0.1865,0.0585
			l-0.0366,0.0561l-0.0741,0.0567l0.0017,0.111l0.0009,0.0555l-0.4489,0.0626l-0.7853,0.1233l0.0401,0.1659l0.1125-0.0017
			l0.0034,0.222l0.1133,0.0538l0.0758,0.0543l0.1133,0.0538l0.2632,0.0514l0.0017,0.111L354.2579,33.142z M345.8662,41.2092
			l0.1109-0.1127l0.0367-0.056l0.2985-0.1155l0.0742-0.0566l0.0367-0.0561l0.0375-0.0005l0.0375-0.0006l-0.0008-0.0555
			l0.0742-0.0566l0.0725-0.1677l0.0367-0.056l-0.0008-0.0555l0.0367-0.056l0.2152-0.6695l0.1476-0.1688l0.1867-0.0583l0.2267,0.1077
			l0.0758,0.0544l0.0758,0.0544l0.0375-0.0006l0.0383,0.0549l0.0375-0.0006l0.0384,0.0549l0.0383,0.0549l0.0758,0.0544
			l0.0392,0.1105l0.0392,0.1104l0.0392,0.1105l0.0392,0.1104l0.0383,0.0549l0.0008,0.0555l0.0017,0.111l0.0392,0.1105l0.0009,0.0555
			l0.0008,0.0555l0.0025,0.1665l0.0009,0.0555l-0.0375,0.0006l0.0008,0.0555l-0.0367,0.0561l-0.0367,0.056l-0.0367,0.0561
			l-0.0742,0.0566l-0.0367,0.0561l-0.0375,0.0005l-0.0367,0.0561l-0.0375,0.0006l-0.0375,0.0006L347.671,41.46l-0.0375,0.0006
			l-0.075,0.0011l-0.0742,0.0566l-0.1125,0.0017l-0.1125,0.0017l-0.1509-0.0533l-0.075,0.0011l-0.0375,0.0006l-0.0375,0.0006
			l0.0008,0.0555l-0.1117,0.0572l-0.0367,0.0561l-0.0367,0.056l-0.0367,0.0561l0.0008,0.0555l0.0008,0.0555l0.0008,0.0555
			l0.0767,0.1099l0.0384,0.055l0.0383,0.0549l0.0008,0.0555l0.0759,0.0544l0.0383,0.055l0.0375-0.0006l0.0375-0.0006l0.0375-0.0006
			l0.0383,0.0549l0.075-0.0011l0.0375-0.0006l0.075-0.0011l0.075-0.0011l0.1125-0.0017l0.1125-0.0017l0.1117-0.0572l0.0751-0.0011
			l0.1125-0.0017l0.1126-0.0017l-0.0009-0.0555l0.3002-0.0045l0.5227-0.1744l0.0734-0.1121l0.0367-0.0561l0.0751-0.0011
			l0.1476-0.1688l0.0742-0.0567l0.0367-0.056l0.0367-0.0561l0.0358-0.1116l0.0725-0.1677l0.11-0.1682l0.0358-0.1116l0.0367-0.0561
			l0.2892-0.7262l-0.0017-0.111l0.0367-0.0561l0.0358-0.1116l-0.0008-0.0555l-0.0009-0.0555l-0.0017-0.111l-0.0009-0.0555
			l-0.0008-0.0555l-0.0009-0.0555l-0.0009-0.0555l-0.0375,0.0006l-0.0008-0.0555l-0.0383-0.0549l-0.0009-0.0555l-0.0384-0.0549
			l-0.0384-0.0549l-0.0375,0.0005l-0.0383-0.0549l-0.0383-0.0549l-0.0384-0.0549l-0.3042-0.273l-0.5334-0.5472l-0.6825-0.4894
			l-0.0367,0.0561l-0.1859,0.1138l-0.2667-0.2736l-0.1142-0.1093l-0.0758-0.0544l-0.0383-0.0549l-0.0383-0.0549l-0.0383-0.0549
			l-0.0383-0.0549l-0.0008-0.0555l-0.0383-0.0549l-0.0392-0.1105l-0.0383-0.0549l-0.0417-0.277l-0.0783-0.2209l-0.0008-0.0555
			l-0.0008-0.0555l-0.0058-0.3886l0.035-0.1671l-0.639-0.1016l-0.4499,0.0067l-0.0367,0.056l-0.15,0.0022l-0.2168,0.5584
			l-0.1459,0.2798l-0.0726,0.1676l-0.2266-0.1077l-0.4842,0.2292l-0.0742,0.0566l-0.0375,0.0006l-0.0367,0.056l-0.1117,0.0572
			l-0.2226,0.1698l-0.3334,0.2825l0.0008,0.0555l-0.0375,0.0005l-0.0367,0.0561l-0.0375,0.0005l-0.1484,0.1132l-4.0294-6.4384
			l-2.1974-15.1271l0.1123-0.0016l0.1107-0.1126l0.8903-0.5677l0.0374-0.0006l0.3367-0.0047l0.2962-0.2263l0.3734-0.0608
			l0.2961-0.2263l0.2237-0.0587l0.4513,0.1602l0.3407,0.2728l0.3041,0.3288l0.1489-0.0576l-0.0303,0.5002l0.1123-0.0016
			l0.3742-0.0054l0.7053-0.3988l0.0374-0.0006l0.2977-0.1154l0.2969-0.1709l-0.0008-0.0555l-0.1561-0.442l-0.0024-0.1665
			l-0.1138-0.1094l-0.078-0.2209l-0.0032-0.2221l0.0334-0.2781l-0.3017-0.1622l-0.4879-0.104l-0.64-0.2684l-0.0732,0.1121
			l-0.0756-0.0545l-0.0764-0.11l-0.0016-0.111l0.0716-0.2231l-0.0048-0.3331l0.0334-0.2781l-0.0103-0.7217l0.1035-0.6123
			l0.2952-0.2819l-0.0008-0.0555l0.2586-0.2258l0.113,0.0539l0.191,0.2749l0.261-0.0593l0.0764,0.11l0.0406,0.2215l0.1512,0.1089
			l0.1187,0.4425l-0.0318,0.3892l0.2236-0.0588l0.2236-0.0588l0.261-0.0593l0.1488-0.0577l0.0374-0.0006l0.7057-0.3435
			l0.2293,0.3298l0.3423,0.3837l0.0374-0.0006l0.0764,0.1099l0.6634-0.6761l0.3358-0.0605l0.7106-0.0105l0.7513,0.2109l0.7181,0.489
			l-0.0706,0.2787l0.0008,0.0555l-0.0366,0.0561l0.0374-0.0006l0.0756,0.0544l0.3766,0.1609l0.0374-0.0006l-0.1396,0.6684
			l-0.0357,0.1116l-0.0681,0.4452l-0.074,0.0567l-0.2593,0.1705l-0.1871,0.0028l0.0008,0.0555l0.0008,0.0555l0.0017,0.111
			l-0.0366,0.0561l0.0008,0.0555l-0.0366,0.0561l0.0009,0.0555l0.0009,0.0555l0.0008,0.0555l0.0009,0.0555l0.0008,0.0555
			l0.0382,0.0549l0.0008,0.0555l0.0383,0.0549l0.0773,0.1654l0.1147,0.1648l0.0008,0.0555l0.0765,0.1099l0.0748-0.0011
			l0.0374-0.0006l0.0009,0.0555l0.0008,0.0555l0.0008,0.0555l0.0408,0.2215l0.5638,0.1581l-0.0723,0.1677l-0.3583,1.0604
			l-0.0366,0.0561l0.0084,0.5551l0.7212,0.6554l0.1182,0.3869l0.2313,0.4407l0.4143,0.1603l0.0749-0.0011l0.2935-0.3932
			l0.1106-0.1127l0.2229-0.1145l0.2212-0.2255l0.2578-0.2816l0.1123-0.0017l0.1097-0.1683l0.1888,0.1081l0.0757,0.0544
			l0.0374-0.0006l0.1097-0.1683l0.2569-0.3371l-0.0009-0.0555l-0.2288-0.2741l0.4074-0.2839l0.2942-0.3377l0.1845-0.1694
			l-0.0383-0.0549l0.0366-0.0561l-0.1888-0.1081l-0.0383-0.0549l-0.2985,0.0601l-0.0749,0.0012l0.0306-0.4447l0.0714-0.2232
			l0.102-0.6679l-0.0826-0.4985l-0.1896-0.1636l-0.3053-0.384l-0.006-0.3886l0.0306-0.4447l0.0706-0.2787l-0.0052-0.3331
			l0.0748-0.0012l0.2244-0.0035l-0.0026-0.1665l0.0374-0.0006l-0.0434-0.388l0.0731-0.1122l0.0357-0.1116l0.6316-0.2874
			l0.2983-0.0601l0.1565,0.4418l0.2305,0.3851l0.006,0.3886l-0.1853,0.1139l-0.1445,0.3354l0.3358-0.0608l0.2253,0.052
			l0.4158,0.2711l0.2689,0.44l0.3001,0.0508l0.1488-0.0579l0.0374-0.0006l0.4151,0.2156l0.2271,0.163l0.1479-0.1134l0.0739-0.0567
			l0.0739-0.0567l0.2628,0.0514l-0.0704,0.2788l0.2271,0.163l-0.0356,0.1116l0.1959,0.5522l-0.0686,0.3898l0.0418,0.277
			l0.3037,0.2728l0.114,0.1092l0.3029,0.2173l-0.0731,0.1122l-0.1836,0.225l-0.3698,0.2835l0.0392,0.1104l0.0009,0.0555
			l0.0374-0.0006l0.0009,0.0555l0.0766,0.1098l0.0383,0.0549l0.0383,0.0549l0.0009,0.0555l0.0383,0.0549l0.0383,0.0549l0.041,0.2214
			l0.0383,0.0549l0.0401,0.1659l0.0383,0.0549l0.0009,0.0555l0.0383,0.0549l0.041,0.2215l0.0009,0.0555l0.0009,0.0555l0.0374-0.0006
			l0.0383,0.0549l0.0009,0.0555l0.0009,0.0555l-0.0374,0.0006l0.0018,0.111l-0.0375,0.0006l0.0009,0.0555l0.0018,0.111
			l0.0009,0.0555l0.0374-0.0006l0.0009,0.0555l0.0383,0.0549l0.0375-0.0006l0.0383,0.0549l0.1515,0.1086l0.0383,0.0549
			l0.0757,0.0543l0.0374-0.0006l0.0009,0.0555l0.1898,0.1636l0.2255,0.0519l0.1132,0.0537l0.2585-0.2262l0.0374-0.0006l0.107-0.3349
			l0.0365-0.0561l0.0722-0.1677l0.2977-0.1158l0.0365-0.0561l0.1114-0.0573l0.5159-0.5081l0.3012,0.1062l0.5916-0.4538
			l0.2264,0.1074l0.1889,0.108l0.0374-0.0006l0.377,0.1604l0.0374-0.0006l0.0383,0.0549l0.1096-0.1684l0.1506,0.0531l-0.0721,0.1677
			l0.4117-0.0067l0.3049,0.3281l0.2666,0.2733l-0.22,0.2813l0.8327,0.5415l0.116,0.2202l0.451,0.1036l0.0009,0.0555l0.0384,0.0549
			l0.1151,0.1647l-0.0684,0.3898l0.1169,0.2757l0.0009,0.0555l-0.1123,0.0019l-0.1077,0.2794l-0.2621,0.0044l-0.4128-0.0487
			l-0.2977,0.116l-0.1114,0.0574l-0.0374,0.0006l-0.3379-0.05l-0.147,0.169l-0.4137-0.1043l-0.1452,0.28l-0.074,0.0567
			l0.0009,0.0555l-0.179,0.5027l-0.7416,0.4563l0.0392,0.1104l-0.0686,0.3898l-0.1078,0.2794l-0.139,0.6686l-0.0722,0.1677
			l0.1169,0.2757l0.1516,0.1086l0.1151,0.1647l0.1561,0.3861l0.3096,0.6057l0.0384,0.0549l0.2988-0.0604l0.1498-0.0024
			l0.2266,0.1073l0.149-0.058l-0.0329,0.2782l0.5272,0.1579l0.2248-0.0037l0.3764,0.1048l0.1901,0.1634l0.1919,0.2745l-0.1471,0.169
			l-0.3627,0.7278l0.0037,0.2221l-0.1809,0.3917l0.0758,0.0543l-0.0713,0.2233l-0.1773,0.6137l-0.3172,1.2268l0.0421,0.2769
			l0.1572,0.4416l0.0009,0.0555l0.2624-0.0043l0.1125-0.0019l0.0749-0.0012l0.1115-0.0574l0.075-0.0012l0.0375-0.0006l0.0384,0.0549
			l0.075-0.0012l0.1124-0.0019l0.1134,0.0536l0.075-0.0012l0.1133,0.0536l0.1883,0.0524l0.0375-0.0006l0.0759,0.0543l0.075-0.0012
			l0.2258,0.0518l0.075-0.0012l0.1124-0.0019l0.0759,0.0542l0.075-0.0012l0.075-0.0013l0.0375-0.0006l0.0375-0.0006l0.1499-0.0025
			l0.0366-0.0561l0.0375-0.0006l0.0384,0.0549l0.0749-0.0013l0.2633,0.0511l0.1874-0.0031l0.0759,0.0542l0.1499-0.0025l0.075-0.0012
			l0.0759,0.0542l0.075-0.0013l0.0759,0.0542l0.1134,0.0536l0.075-0.0013l0.0759,0.0542l0.1893,0.1079l0.2267,0.1072l0.1134,0.0536
			l0.0759,0.0542l0.1509,0.053l0.0759,0.0542l0.1134,0.0536l0.0759,0.0542l0.075-0.0012l0.3046,0.2725l0.1143,0.1091l0.0384,0.0549
			l0.0385,0.0549l0.1527,0.164l0.0394,0.1104l0.0385,0.0549l0.0375-0.0006l0.0385,0.0549l0.0375-0.0006l0.0375-0.0006l0.0385,0.0549
			l0.0759,0.0542l0.1134,0.0536l-0.813,7.3431L352.8267,52.153L345.8662,41.2092z'
              />
              <polygon
                id='_x3C_Path_x3E__00000101818781542472269810000003085605375749790603_'
                points='368.9328,29.2201 
			368.8433,29.194 368.2253,29.1738 367.8256,28.9874 367.5703,29.0092 367.5736,28.5809 367.6359,28.5212 367.7769,28.4298 
			367.8423,27.9378 367.9666,27.7949 367.7197,27.4809 367.6895,27.2894 367.6686,27.1362 367.7029,26.7553 367.7438,26.7591 
			367.8608,26.8124 367.9327,26.7765 367.9767,26.7805 368.0382,26.7238 368.2001,26.6428 368.4705,26.3741 368.4584,26.3357 
			368.4604,26.3338 368.4542,26.3222 368.3546,26.0063 368.9458,26.186 369.1221,25.8887 369.1346,25.7449 369.1666,25.6917 
			369.2598,25.6788 369.3136,25.5663 369.2961,25.4557 369.3521,25.3405 		'
              />
            </g>
            <polygon
              id='SG12'
              className={getColor('SG12') + ' st13'}
              fill={'url(#' + getColor('SG12') + ')'}
              points='405.6304,94.3638 392.9294,66.6632 397.424,55.7557 413.8966,70.3082 409.3366,92.068 	'
            />
            <polygon
              id='SG11'
              className={getColor('SG11') + ' st13'}
              fill={'url(#' + getColor('SG11') + ')'}
              points='460.2205,161.7921 430.6642,169.2319 429.7576,169.496 429.7817,169.6945 
		429.6608,170.064 430.0588,170.6435 430.1815,171.1238 430.2469,171.1514 431.1539,171.5336 431.4075,171.7486 431.9012,173.3088 
		431.5318,173.8748 431.7031,174.2711 431.3924,175.3611 432.1045,175.9103 432.3849,176.7887 433.7168,177.6536 434.8168,176.9986 
		435.4684,176.9516 436.2511,177.3345 436.7868,176.9718 437.1143,176.9415 438.1153,177.2169 438.426,177.1347 439.2473,177.1363 
		439.6084,177.3228 440.2516,177.9593 440.8008,178.0651 441.8891,177.8132 442.9371,177.7443 443.5283,178.4312 444.0204,178.1608 
		445.8494,178.5521 446.7126,178.4581 448.466,178.4312 449.1848,178.6042 449.7676,178.9351 450.7585,179.402 452.1054,179.3969 
		453.2374,179.8168 454.0788,180.1477 454.4836,180.5423 455.1033,180.6918 455.7399,181.6088 456.0976,181.7633 457.1775,182.8348 
		457.6393,182.4989 457.851,182.0707 458.0424,181.2561 457.8392,180.6565 457.8039,180.3593 458.0156,180.2887 459.4112,180.3106 
		459.7589,179.2962 459.475,178.2918 459.4045,177.7426 459.8731,177.4353 460.4138,176.4881 461.2821,176.1303 461.9926,175.3494 
		460.7716,174.7481 460.6456,173.8463 460.9597,172.8201 461.6147,171.982 461.6919,171.018 462.6005,170.5847 462.4846,170.3059 
		462.8928,170.0859 462.8524,169.7768 462.9371,169.631 	'
            />
            <polygon
              id='SG10'
              className={getColor('SG10') + ' st13'}
              fill={'url(#' + getColor('SG10') + ')'}
              points='439.7534,84.9105 435.2672,72.7083 448.2093,58.7968 453.9696,78.1618 	'
            />
            <polygon
              id='SG09'
              className={getColor('SG09') + ' st13'}
              fill={'url(#' + getColor('SG09') + ')'}
              points='399.0049,143.3659 395.757,144.4351 393.6241,143.7549 393.1052,143.4745 
		393.0565,142.9488 393.7316,141.8235 395.1709,141.1148 394.9308,140.3288 395.1844,139.9022 395.1255,139.489 395.4749,138.9986 
		395.2415,138.4477 394.6049,138.2479 394.353,137.7675 394.8367,136.167 394.6906,135.5523 394.8468,135.3827 394.5697,134.9863 
		395.4044,134.2843 395.5068,133.7704 396.491,132.3428 396.5851,132.0237 396.9445,131.4258 397.1578,130.7977 399.0942,128.2096 
		398.1067,127.4555 398.199,127.3128 397.3139,126.7518 396.2491,126.3521 395.7688,126.2597 395.7436,126.5318 395.2633,126.4949 
		395.1978,126.8324 394.8723,126.7991 394.7947,127.0911 393.7657,126.9724 393.7938,126.6886 400.9333,111.8973 424.2237,136.5528 
			'
            />
            <polygon
              id='SG08'
              className={getColor('SG08') + ' st13'}
              fill={'url(#' + getColor('SG08') + ')'}
              points='450.3647,46.7027 453.2509,48.0882 454.2585,48.9279 460.7632,56.7896 462.315,58.6672 
		462.3207,58.6677 462.3217,58.6689 463.9534,58.7944 464.5,58.8368 464.5018,58.8366 464.5051,58.8368 466.8531,58.4997 
		467.1471,59.6181 468.4317,64.5622 468.3796,65.5564 468.5879,66.0603 468.7441,66.376 469.0279,66.7942 469.6678,67.3938 
		470.3631,67.9279 470.7175,68.1966 470.8552,68.3007 471.8091,69.7804 472.14,70.4925 472.2189,70.7377 472.2592,70.8603 
		472.2945,70.8939 472.6438,71.6009 472.6892,71.707 469.14,80.7571 462.3049,85.2635 461.7483,86.4958 461.8422,86.6637 
		461.7423,87.2 461.5678,87.2612 461.7458,87.4218 461.6348,88.9198 461.9019,89.0373 461.4301,89.6276 458.8094,85.7194 
		453.9696,78.1618 448.2093,58.7968 	'
            />
            <polygon
              id='SG07'
              className={getColor('SG07') + ' st13'}
              fill={'url(#' + getColor('SG07') + ')'}
              points='460.6112,100.5593 460.6135,100.5529 461.3108,99.4549 461.4573,97.917 461.4597,97.913 
		461.46,97.9126 461.6296,97.6489 461.6466,97.6598 461.5197,97.4295 461.7373,97.3537 461.7628,96.2449 461.7692,95.9667 
		461.7525,94.1068 461.7347,94.1025 461.7204,94.0991 461.7279,94.0867 461.7524,94.0925 461.6504,92.8027 461.6509,92.8022 
		461.6502,92.8 461.6444,92.7821 461.3055,91.7354 461.3112,91.7261 461.3983,91.6198 461.3756,91.5422 461.2357,91.4592 
		461.1654,91.4174 461.1759,91.4 461.1797,91.3954 461.3104,91.2781 461.3275,91.2628 461.3409,91.2778 461.1797,91.0577 
		461.4047,90.2197 461.4181,90.2046 461.1628,89.9795 461.1495,89.9946 461.9019,89.0373 461.91,89.0189 461.6429,88.9013 
		461.6348,88.9197 461.7322,87.4368 461.7458,87.4218 461.5678,87.2612 461.7603,87.2165 461.8422,86.6637 461.809,86.6043 
		461.7483,86.4958 462.1654,85.5893 462.3063,85.306 462.3693,85.2643 462.3716,85.2604 462.3582,85.2489 469.14,80.7571 
		475.1632,92.4192 474.8289,92.8296 474.3603,93.4813 474.0949,93.9364 473.9606,94.2941 473.7624,95.0801 473.7108,95.2997 
		473.5949,95.7897 473.4584,96.3599 473.1813,97.5338 472.9344,98.5735 472.7346,99.1478 472.664,99.2923 472.6522,99.3141 
		472.4171,99.7995 472.0544,100.3587 472.0228,100.3951 471.7101,100.7215 469.9634,101.9878 469.5368,102.3338 468.7777,103.0829 
		468.5778,103.4272 468.4435,103.894 468.163,105.1738 468.0169,105.5332 467.7901,106.027 467.4576,106.6283 467.2751,106.8461 
		467.2544,106.8651 466.722,107.2245 466.1123,107.6359 466.0284,107.6914 465.7093,108.0121 465.5766,108.2641 465.5631,108.558 
		465.5883,109.5304 465.5497,109.8243 465.4153,110.3046 464.4832,113.3176 464.3086,113.7308 464.0819,114.152 459.659,108.7009 
		459.6595,108.6754 458.6734,107.4181 459.0276,106.6677 459.2794,106.404 459.6515,106.0928 459.7282,106.1075 459.7959,106.0509 
		459.868,105.8654 460.1438,105.1559 459.9846,104.6603 460.1581,103.9252 460.3295,103.0987 460.2659,102.5849 460.6486,102.1458 
		460.6494,102.1444 460.6361,102.108 461.0937,101.8312 461.1041,101.8484 460.6305,100.5636 	'
            />
            <polygon
              id='SG06'
              className={getColor('SG06') + ' st13'}
              fill={'url(#' + getColor('SG06') + ')'}
              points='432.2576,132.8919 465.1699,140.3429 465.103,140.7302 464.6529,142.3811 
		464.5067,142.7103 464.2397,142.9639 462.9868,144.0841 461.5609,145.3622 460.2006,146.1767 459.5741,146.7226 459.334,147.0031 
		459.2416,147.2567 459.255,147.5875 459.7874,149.351 459.7875,149.3459 459.7891,149.351 459.8059,148.7531 460.5634,148.4597 
		460.6027,149.0703 460.6053,149.1125 460.874,149.7121 461.0722,149.7121 461.1377,149.3661 461.8442,148.2753 462.2411,148.5683 
		462.4033,148.6854 462.5132,148.7665 462.6979,148.6724 462.8575,148.1787 463.3513,148.3533 464.3371,148.219 464.6042,148.0997 
		465.0039,147.5522 466.6442,147.0819 465.6471,147.3679 463.043,154.2896 460.2205,161.7921 430.6642,169.2319 429.7672,169.4932 
		429.6776,168.2468 430.6198,167.8935 430.8079,167.5901 430.6886,166.7101 430.568,166.3348 430.5478,165.7265 430.8079,164.8845 
		430.7928,164.3655 430.823,163.7055 430.4599,163.0755 430.7928,162.157 430.6198,161.3139 430.8768,160.7479 431.1841,160.6304 
		430.9137,159.6529 430.3117,158.6111 430.2218,158.4555 430.2016,157.0195 430.0001,156.5072 429.3535,155.6457 429.3367,155.2896 
		428.5406,154.9806 428.2601,154.4717 427.8302,154.1408 427.501,153.6337 427.2037,153.6269 426.5286,153.679 425.714,153.1634 
		425.2219,153.3918 424.8575,153.2994 422.1989,155.0746 421.6094,154.6699 421.522,154.5574 420.6353,154.9907 420.1398,154.8529 
		419.599,154.3995 419.0901,154.3642 416.7338,152.7318 417.8104,151.8467 418.6669,151.1581 419.636,150.7651 420.5933,150.6542 
		420.909,150.1302 421.3239,150.0664 422.2845,149.0453 422.6237,148.0007 423.44,146.3447 422.9966,144.0405 423.2485,142.9924 
		422.9781,142.7993 422.6221,141.7026 422.6893,140.8091 422.8942,140.5018 422.9294,140.0483 422.8757,139.7947 422.9832,139.5025 
		422.8203,138.6762 422.8858,138.1152 422.9722,136.8909 424.2237,136.5528 429.6429,138.4563 	'
            />
            <polygon
              id='SG05'
              className={getColor('SG05') + ' st13'}
              fill={'url(#' + getColor('SG05') + ')'}
              points='444.6689,114.0007 434.6345,117.5327 434.4759,117.7308 432.2576,132.8919 
		465.1699,140.3429 465.1987,140.1759 465.145,139.5646 464.7184,137.3897 464.4379,136.125 464.1372,134.7384 464.0533,134.3532 
		463.915,133.8837 463.5847,132.7661 463.2908,132.1127 462.8508,131.446 462.2764,130.6079 461.7457,129.659 461.2805,128.779 
		461.052,128.0417 460.4676,125.7677 460.387,125.1664 460.4273,124.5668 460.5869,123.46 460.7766,122.3801 460.8808,121.967 
		461.5895,120.3681 461.9506,119.6224 462.0077,119.2479 462.0564,118.6114 462.1891,117.8774 462.3503,117.345 462.535,116.9436 
		463.2807,115.6404 464.0819,114.152 459.659,108.7009 459.6379,108.7084 459.6388,108.7004 459.6392,108.6822 458.6607,107.4345 
		458.6346,107.5121 458.5647,107.7199 458.3918,108.0524 457.9015,108.5004 457.9136,108.5167 457.7592,108.6578 457.648,108.7593 
		457.4157,109.1072 457.3012,109.2786 457.0158,109.6374 456.8795,109.8088 456.4435,110.0019 455.7148,110.5193 454.9778,111.3753 
		454.23,111.9465 453.963,112.3521 453.3527,112.44 452.5368,113.0297 452.3297,113.1133 452.0278,113.0737 451.6108,113.0192 
		451.0625,113.2322 450.5006,113.8554 449.5372,114.924 449.4022,114.9382 448.7819,115.0036 448.1617,115.1607 446.9673,115.664 
		446.9477,115.6617 445.4394,114.5734 444.6728,114.0036 	'
            />
            <polygon
              id='SG04'
              className={getColor('SG04') + ' st13'}
              fill={'url(#' + getColor('SG04') + ')'}
              points='424.5129,100.9904 409.3366,92.068 413.8966,70.3082 422.5166,63.625 429.1651,71.5505 	
		'
            />
            <polygon
              id='SG03'
              className={getColor('SG03') + ' st13'}
              fill={'url(#' + getColor('SG03') + ')'}
              points='378.8215,127.1359 376.2714,122.5475 373.2689,109.105 392.1216,98.6171 
		400.5173,102.3715 400.9333,111.8973 393.7938,126.6886 	'
            />
            <polygon
              id='SG02'
              className={getColor('SG02') + ' st13'}
              fill={'url(#' + getColor('SG02') + ')'}
              points='429.6429,138.4563 424.2237,136.5528 400.9333,111.8973 400.5173,102.3715 
		405.6304,94.3638 409.3366,92.068 424.5129,100.9904 434.4759,117.7308 432.2576,132.8919 	'
            />
            <polygon
              id='SG01'
              className={getColor('SG01') + ' st13'}
              fill={'url(#' + getColor('SG01') + ')'}
              points='472.6892,71.707 472.753,71.8562 472.8336,71.9922 472.8655,72.0443 472.9092,72.1165 
		473.2031,72.2761 473.4282,72.3533 473.544,72.3584 473.749,72.3231 473.8598,72.2727 473.9199,72.246 473.9219,72.2458 
		474.0697,72.1266 474.1487,71.8461 474.1755,71.5539 474.1768,71.5444 474.3032,71.134 474.3889,70.9106 474.5635,70.8149 
		474.7247,70.8569 474.8389,70.951 475.0791,71.3036 475.1866,71.4598 475.5628,72.2139 475.6669,72.4138 475.7072,72.486 
		475.9356,72.7615 476.0263,72.8723 476.2531,73.052 476.3538,73.1041 476.683,73.1964 477.1381,73.2384 477.9157,73.2653 
		478.4969,73.3174 479.1434,73.3829 479.8135,73.4987 480.4316,73.6801 480.5055,73.7171 480.6885,73.8078 480.8112,73.9035 
		480.8784,73.9824 480.917,74.0278 480.9908,74.147 481.0412,74.226 481.0597,74.3687 481.0547,74.5451 481.0446,74.6055 
		480.8297,74.8726 480.744,74.98 480.0688,75.8198 479.4844,76.4949 479.3585,76.6394 479.2661,76.9652 479.2526,77.0962 
		479.2375,77.2339 479.2929,77.5497 479.3668,77.7445 479.4575,77.9813 479.9059,79.1519 480,79.5919 480.0201,79.7968 
		480.1175,80.6987 480.2771,82.1195 480.2805,82.1514 480.2754,82.2925 480.2536,82.8955 480.2553,82.8956 480.2552,82.8971 
		480.6299,82.9206 480.6802,82.924 480.9405,83.4144 481.0228,83.5689 481.09,83.6949 481.1353,83.7839 481.1605,83.8292 
		481.5468,84.2441 482.3278,84.6304 482.5713,84.7513 482.7476,84.837 482.9138,84.9517 482.9868,85.0025 483.1843,85.2954 
		483.2397,85.6683 483.2532,85.7623 483.2481,85.7976 483.2213,86.1117 483.2103,86.2496 483.1776,86.6062 483.1188,86.8506 
		483.0734,86.9632 482.9962,87.158 482.6754,87.7542 482.2421,88.3252 482.0859,88.5318 481.6577,89.0424 481.5435,89.1196 
		481.1252,89.4068 480.7759,89.5832 480.2401,89.7763 479.8623,89.7897 479.2274,89.8149 479.1972,89.8183 478.3322,89.8972 
		477.8133,90.0971 477.5496,90.2264 477.4522,90.2768 477.3188,90.3435 477.029,90.1357 477.0284,90.1365 477.0273,90.1357 
		476.4445,90.8495 475.6333,91.8421 475.1632,92.4192 469.14,80.7571 	'
            />
            <polygon
              id='OW03'
              className={getColor('OW03') + ' st13'}
              fill={'url(#' + getColor('OW03') + ')'}
              points='309.0888,201.7321 304.5005,199.5175 283.2449,175.7361 283.5714,165.3337 
		285.698,161.771 291.6202,157.3804 307.6003,166.8637 314.1374,185.2051 313.9543,185.8048 314.465,186.4726 314.5523,187.6684 
		314.0972,188.5048 314.0821,189.4839 313.7613,190.4278 313.9175,191.2742 314.2332,191.6756 314.3172,192.7908 314.7723,192.9134 
		314.7001,193.775 314.381,194.215 313.4993,194.6097 313.024,195.2849 313.6,196.3362 314.2399,196.699 315.2577,198.0493 
		315.7196,198.2911 315.7666,198.6656 315.9967,199.1359 317.1928,199.9495 317.7988,199.8917 319.1121,201.2773 318.4588,201.6383 
		318.4302,201.9457 317.9835,202.2262 314.5255,202.6696 313.4331,204.0026 	'
            />
            <polygon
              id='OW02'
              className={getColor('OW02') + ' st13'}
              fill={'url(#' + getColor('OW02') + ')'}
              points='283.0016,215.7083 273.7161,205.5682 275.3527,196.0875 283.2449,175.7361 
		304.5005,199.5175 	'
            />
            <polygon
              id='OW01'
              className={getColor('OW01') + ' st13'}
              fill={'url(#' + getColor('OW01') + ')'}
              points='329.0429,205.0829 329.1991,204.7706 329.1806,204.5909 329.1135,204.4733 
		328.6516,204.5355 327.8773,204.0803 327.1871,204.1223 326.606,204.2617 326.5506,204.433 326.087,204.433 325.8435,204.0467 
		325.3883,203.7897 324.987,203.7763 323.4175,205.1162 322.6777,205.4424 322.5265,204.3054 322.11,203.1633 321.4113,203.0239 
		320.5582,202.211 320.2088,201.6686 319.4195,201.2487 319.1121,201.2773 317.7988,199.8917 317.1928,199.9495 315.9967,199.1359 
		315.7571,198.5901 315.7196,198.2911 315.2577,198.0493 314.2399,196.699 313.6,196.3362 313.024,195.2849 313.4993,194.6097 
		314.381,194.215 314.7001,193.775 314.7723,192.9134 314.3172,192.7908 314.2332,191.6756 313.9175,191.2742 313.7613,190.4278 
		314.0821,189.4839 314.0972,188.5048 314.5523,187.6684 314.465,186.4726 313.9543,185.8048 314.1374,185.2051 333.6458,176.8623 
		333.5775,177.9324 333.2181,178.579 331.1288,179.3885 330.3563,180.4147 330.7694,180.6817 331.3152,180.6549 331.8846,181.199 
		332.3314,181.4291 332.1936,181.8053 332.674,182.3444 333.0065,183.4462 332.4758,183.856 332.0995,184.3061 331.5957,184.4136 
		331.4227,184.8401 331.8493,185.5606 332.0576,186.1871 331.6377,187.5307 332.1667,188.5333 332.7965,188.5468 332.9007,188.2797 
		333.2887,188.1336 334.2073,188.8407 335,188.965 335.4837,188.7936 336.0732,189.8299 336.6795,190.3186 336.4847,190.4312 
		336.5418,190.8225 336.3,191.1634 334.5281,192.119 334.1015,192.9856 333.8362,193.9581 333.7488,195.1303 333.6094,195.5855 
		333.0569,196.2892 333.7371,197.2381 333.5557,198.2357 332.3196,198.978 331.3035,198.7983 331.4849,199.0889 331.364,199.1796 
		331.8493,199.3005 332.239,199.6918 333.4902,199.1275 333.5658,199.9941 333.1442,200.849 333.8244,201.4032 334.1418,201.7845 
		334.382,202.2648 334.8623,203.8637 333.7287,204.5035 332.543,204.8243 332.1164,204.7034 331.6764,204.4767 331.2649,204.611 
		329.4359,205.5297 	'
            />
            <polygon
              id='NW01'
              className={getColor('NW01') + ' st13'}
              fill={'url(#' + getColor('NW01') + ')'}
              points='314.1374,185.2051 307.6003,166.8637 318.5844,157.3105 333.6458,176.8623 	'
            />
            <polygon
              id='LU06'
              className={getColor('LU06') + ' st13'}
              fill={'url(#' + getColor('LU06') + ')'}
              points='283.5714,165.3337 261.8255,156.9454 260.5454,126.5402 273.5338,121.2221 
		285.698,161.771 	'
            />
            <polygon
              id='LU05'
              className={getColor('LU05') + ' st13'}
              fill={'url(#' + getColor('LU05') + ')'}
              points='336.6521,177.4483 333.6458,176.8623 318.5844,157.3105 320.9588,135.0869 
		322.5036,134.4647 336.8878,146.9906 341.0145,154.6342 340.7197,168.9768 	'
            />
            <polygon
              id='LU04'
              className={getColor('LU04') + ' st13'}
              fill={'url(#' + getColor('LU04') + ')'}
              points='285.698,161.771 273.5338,121.2221 277.4679,113.0998 283.4413,112.7249 
		299.0962,137.9588 291.6202,157.3804 	'
            />
            <polygon
              id='LU03'
              className={getColor('LU03') + ' st13'}
              fill={'url(#' + getColor('LU03') + ')'}
              points='267.7004,210.8762 242.0615,199.4646 253.5229,177.5723 275.3527,196.0875 
		273.7161,205.5682 	'
            />
            <polygon
              id='LU02'
              className={getColor('LU02') + ' st13'}
              fill={'url(#' + getColor('LU02') + ')'}
              points='307.6003,166.8637 291.6202,157.3804 299.0962,137.9588 307.9731,129.3485 
		320.9588,135.0869 318.5844,157.3105 	'
            />
            <polygon
              id='LU01'
              className={getColor('LU01') + ' st13'}
              fill={'url(#' + getColor('LU01') + ')'}
              points='275.3527,196.0875 253.5229,177.5723 255.4496,161.026 261.8255,156.9454 
		283.5714,165.3337 283.2449,175.7361 	'
            />
            <polygon
              id='GR09'
              className={getColor('GR09') + ' st13'}
              fill={'url(#' + getColor('GR09') + ')'}
              points='444.6441,226.822 444.6059,226.823 444.5691,226.8794 444.5677,226.8239 
		444.5295,226.8248 444.4899,226.7702 444.4504,226.7157 444.4108,226.6611 444.4095,226.6057 444.3712,226.6066 444.3699,226.5511 
		444.2935,226.5529 444.2921,226.4974 444.2908,226.442 444.2143,226.4438 444.1775,226.5002 444.1393,226.5012 444.1406,226.5566 
		444.1024,226.5576 444.1037,226.6131 444.0273,226.6149 443.9877,226.5603 443.9482,226.5058 443.9099,226.5067 443.8704,226.4521 
		443.7926,226.3985 443.7544,226.3994 443.7162,226.4004 443.7148,226.3449 443.7135,226.2894 443.6753,226.2903 443.674,226.2348 
		443.6726,226.1793 443.6344,226.1803 443.633,226.1248 443.6317,226.0693 443.6686,226.0129 443.6672,225.9574 443.7041,225.901 
		443.741,225.8446 443.7396,225.7891 443.7001,225.7345 443.7383,225.7336 443.7369,225.6781 443.7752,225.6772 443.7738,225.6217 
		443.7725,225.5662 443.7343,225.5671 443.7329,225.5116 443.7711,225.5107 443.8094,225.5098 443.8476,225.5089 443.8462,225.4534 
		443.8844,225.4524 443.9226,225.4515 443.9595,225.3951 443.9977,225.3942 444.0359,225.3933 444.1123,225.3914 444.1506,225.3905 
		444.1492,225.335 444.1874,225.3341 444.2243,225.2777 444.2612,225.2213 444.223,225.2222 444.2599,225.1658 444.2216,225.1667 
		444.1834,225.1676 444.1821,225.1121 444.2203,225.1112 444.2176,225.0002 444.2531,224.8883 444.2136,224.8338 444.2518,224.8328 
		444.2886,224.7764 444.2859,224.6655 444.2846,224.61 444.2832,224.5545 444.2437,224.4999 444.2423,224.4444 444.2041,224.4454 
		444.241,224.389 444.2397,224.3335 444.2383,224.278 444.2765,224.277 444.2752,224.2216 444.3134,224.2206 444.3516,224.2197 
		444.3885,224.1633 444.4253,224.1069 444.4635,224.106 444.4622,224.0505 444.4608,223.995 444.4213,223.9404 444.4199,223.8849 
		444.4186,223.8295 444.4172,223.774 444.379,223.7749 444.3777,223.7194 444.3763,223.6639 444.3381,223.6648 444.3368,223.6094 
		444.2986,223.6103 444.2972,223.5548 444.3341,223.4984 444.3709,223.442 444.3696,223.3865 444.3683,223.331 444.3669,223.2755 
		444.3656,223.22 444.4024,223.1636 444.4393,223.1072 444.4775,223.1063 444.4761,223.0508 444.4748,222.9953 444.513,222.9944 
		444.5117,222.9389 444.5103,222.8834 444.5089,222.8279 444.5471,222.827 444.5458,222.7715 444.5445,222.716 444.5049,222.6615 
		444.5036,222.606 444.5022,222.5505 444.5009,222.495 444.4995,222.4395 444.4982,222.384 444.535,222.3276 444.4968,222.3285 
		444.4955,222.2731 444.4941,222.2175 444.4546,222.163 444.4532,222.1075 444.4519,222.052 444.4137,222.0529 444.4124,221.9975 
		444.3741,221.9984 444.3728,221.9429 444.3346,221.9438 444.3333,221.8883 444.2951,221.8893 444.2937,221.8338 444.2555,221.8347 
		444.2542,221.7792 444.2924,221.7783 444.2528,221.7237 444.2515,221.6682 444.2133,221.6692 444.2119,221.6137 444.1737,221.6146 
		444.1355,221.6155 444.0974,221.6165 444.0578,221.5619 444.0196,221.5628 443.98,221.5083 443.9787,221.4528 443.9774,221.3973 
		443.976,221.3418 443.9378,221.3427 443.8983,221.2882 443.8601,221.2891 443.8206,221.2345 443.781,221.18 443.7797,221.1245 
		443.7415,221.1254 443.7401,221.0699 443.702,221.0709 443.6638,221.0718 443.6624,221.0163 443.6242,221.0172 443.5847,220.9626 
		443.5451,220.9081 443.5833,220.9072 443.582,220.8517 443.5438,220.8526 443.5056,220.8535 443.5042,220.798 443.4661,220.7989 
		443.4265,220.7444 443.4252,220.6889 443.387,220.6898 443.3488,220.6907 443.3475,220.6353 443.3461,220.5798 443.3079,220.5807 
		443.2711,220.6371 443.2328,220.638 443.1947,220.639 443.1551,220.5844 443.1169,220.5853 443.1156,220.5298 443.0774,220.5307 
		443.0392,220.5317 443.0379,220.4762 442.9984,220.4216 442.9602,220.4225 442.922,220.4234 442.8838,220.4244 442.8824,220.3689 
		442.8442,220.3698 442.8429,220.3143 442.8034,220.2598 442.7652,220.2607 442.727,220.2616 442.7256,220.2061 442.6875,220.207 
		442.6861,220.1516 442.6479,220.1525 442.6466,220.097 442.6084,220.0979 442.6097,220.1534 442.5715,220.1543 442.5334,220.1552 
		442.532,220.0997 442.4938,220.1006 442.457,220.1571 442.4188,220.158 442.3806,220.1589 442.3424,220.1598 442.3042,220.1607 
		442.2673,220.2171 442.2292,220.2181 442.1909,220.219 442.1528,220.2199 442.1146,220.2208 442.0764,220.2217 442.075,220.1663 
		442.0369,220.1672 441.9987,220.1681 441.9973,220.1126 441.9591,220.1135 441.9196,220.059 441.9183,220.0034 441.8801,220.0044 
		441.8419,220.0053 441.8405,219.9498 441.8024,219.9507 441.801,219.8952 441.7628,219.8961 441.7246,219.8971 441.6865,219.898 
		441.6469,219.8434 441.6087,219.8443 441.5692,219.7898 441.531,219.7907 441.4915,219.7361 441.4533,219.737 441.4151,219.7379 
		441.3769,219.7389 441.3387,219.7398 441.3006,219.7407 441.261,219.6861 441.2597,219.6306 441.2215,219.6315 441.2584,219.5751 
		441.3347,219.5733 441.5968,219.3449 441.6336,219.2885 441.8192,219.062 442.2628,218.4406 442.3694,218.105 442.4444,218.0476 
		442.6313,217.8766 442.7036,217.7083 442.8102,217.3726 442.8457,217.2607 443.1022,216.8103 443.1759,216.6975 443.2838,216.4173 
		443.3916,216.1371 443.6916,215.9078 444.068,215.6766 444.1048,215.6202 444.4075,215.5018 444.4444,215.4454 444.4812,215.3889 
		444.4798,215.3335 444.518,215.3326 444.5167,215.2771 444.5153,215.2216 444.5917,215.2197 444.6285,215.1633 444.6667,215.1624 
		444.7048,215.1614 444.7035,215.106 444.7417,215.105 445.2339,214.9265 445.272,214.9256 445.3088,214.8692 445.3839,214.8118 
		445.4207,214.7554 445.4588,214.7544 445.5352,214.7526 445.5338,214.6971 445.572,214.6962 445.6088,214.6398 445.647,214.6388 
		445.6838,214.5824 445.7206,214.526 445.7969,214.5241 445.8338,214.4677 445.9088,214.4103 446.0219,214.3521 446.0983,214.3502 
		446.1732,214.2928 446.2101,214.2364 446.285,214.179 446.4705,213.9524 446.3873,213.6769 446.3805,213.3995 446.416,213.2875 
		446.4133,213.1766 446.3301,212.901 446.2879,212.7355 446.3233,212.6236 446.2825,212.5135 446.2416,212.4035 446.1258,212.3508 
		446.0849,212.2408 446.0018,211.9652 446.0004,211.9097 446.0372,211.8533 446.0754,211.8524 446.074,211.7969 446.1108,211.7405 
		446.0727,211.7414 446.1081,211.6295 446.1068,211.574 446.1435,211.5176 446.1422,211.4621 446.179,211.4057 446.1776,211.3502 
		446.2131,211.2383 446.2867,211.1254 446.3235,211.069 446.3984,211.0117 446.4366,211.0107 446.4352,210.9552 446.472,210.8988 
		446.5075,210.7869 446.5456,210.786 446.5811,210.6741 446.6192,210.6731 446.6928,210.5603 446.6915,210.5048 446.6901,210.4493 
		446.6506,210.3948 446.6492,210.3393 446.6873,210.3383 446.761,210.2255 446.7978,210.1691 446.8345,210.1126 446.9081,209.9998 
		446.9449,209.9434 446.9803,209.8315 447.0185,209.8305 447.0934,209.7732 447.1302,209.7168 447.1289,209.6613 447.167,209.6603 
		447.2065,209.7149 447.2815,209.6575 447.3196,209.6566 447.3564,209.6001 447.3932,209.5437 447.4314,209.5428 447.43,209.4873 
		447.4286,209.4318 447.4668,209.4309 447.4273,209.3763 447.4654,209.3754 447.4641,209.3199 447.5009,209.2635 447.4995,209.208 
		447.5363,209.1516 447.5349,209.0961 447.5717,209.0396 447.5703,208.9842 447.6085,208.9832 447.6071,208.9277 447.6452,208.9268 
		447.6439,208.8713 447.6807,208.8149 447.7175,208.7585 447.7161,208.703 447.7542,208.702 447.791,208.6456 447.8278,208.5892 
		447.8646,208.5327 447.9014,208.4763 447.9,208.4208 447.9381,208.4199 447.9368,208.3644 447.9749,208.3634 448.0499,208.3061 
		448.1956,208.0249 448.2296,207.8575 448.3427,207.7992 448.3795,207.7428 448.4149,207.6308 448.4898,207.5735 448.562,207.4051 
		448.6342,207.2368 448.6259,206.9039 448.9582,206.4515 448.8778,206.2869 448.7988,206.1778 448.6407,205.9596 448.5181,205.6296 
		448.6665,205.4593 448.7401,205.3465 448.8408,204.7888 448.9074,204.3985 448.8638,204.1775 448.703,203.8483 448.8923,203.7881 
		448.8909,203.7326 448.9249,203.5652 448.8473,203.5116 448.7315,203.459 448.579,203.4627 448.5,203.3537 448.6879,203.238 
		448.76,203.0696 448.7954,202.9577 448.4399,202.4668 448.3527,202.0248 448.203,202.1395 448.0518,202.1988 447.9361,202.1461 
		447.8585,202.0925 447.819,202.038 447.7019,201.9298 447.5848,201.8216 447.5072,201.768 447.4677,201.7135 447.3901,201.6599 
		447.3873,201.5489 447.3846,201.4379 447.3792,201.216 447.4118,200.9931 447.4063,200.7711 447.4036,200.6602 447.4607,199.8815 
		447.4594,199.826 447.3804,199.7169 447.2647,199.6642 447.1109,199.6125 446.8822,199.6181 446.8427,199.5636 446.7665,199.5654 
		446.6521,199.5682 446.6127,199.5137 446.4629,199.6284 446.4262,199.6848 446.3132,199.7431 446.2002,199.8014 445.9715,199.807 
		445.8953,199.8089 445.8571,199.8098 445.7809,199.8117 445.7047,199.8135 445.7061,199.869 445.6679,199.87 445.6693,199.9254 
		445.5563,199.9837 445.5195,200.0401 445.4474,200.2085 445.2963,200.2677 445.2976,200.3232 445.1846,200.3814 445.1438,200.2714 
		445.0267,200.1632 445.024,200.0522 445.0594,199.9403 444.9029,199.7776 444.9383,199.6657 444.8594,199.5565 444.8567,199.4456 
		444.7042,199.4493 444.624,199.2847 444.5083,199.232 444.5423,199.0646 444.3491,198.9582 444.3831,198.7909 444.4185,198.679 
		444.341,198.6253 444.3764,198.5134 444.375,198.4579 440.4301,199.3304 439.4063,199.5769 436.6752,200.1968 434.1698,200.6996 
		433.8842,201.539 433.6735,202.3212 434.1866,204.6966 434.3126,205.1933 437.2936,207.011 438.2734,209.7083 437.1892,210.6778 
		436.7418,211.1324 436.8021,212.0748 436.9832,214.902 432.5157,223.2229 430.6959,223.8754 429.8672,221.063 426.8823,219.1876 
		423.4958,219.8185 424.0133,222.4718 420.7341,222.8218 419.4502,225.2925 418.9357,226.2475 418.9574,227.2463 419.0069,229.5214 
		416.3141,230.5788 411.6204,238.3951 407.8091,239.196 405.6088,238.2973 403.4056,244.8371 404.1257,252.0394 406.2896,254.7711 
		407.7609,251.7432 409.1413,251.7702 414.2775,251.7736 416.8578,248.7763 420.8084,247.1917 421.9492,245.0571 426.9631,243.1691 
		430.7532,239.7521 440.2893,236.6425 440.0568,228.4869 441.2707,228.0692 443.9656,227.2271 444.5717,226.9903 444.6086,226.9339 
		444.6073,226.8784 	'
            />
            <polygon
              id='GR08'
              className={getColor('GR08') + ' st13'}
              fill={'url(#' + getColor('GR08') + ')'}
              points='441.2215,219.6315 441.2584,219.5751 441.3347,219.5733 441.5968,219.3449 
		441.6336,219.2885 441.8192,219.062 442.2628,218.4406 442.3694,218.105 442.4444,218.0476 442.6313,217.8766 442.7036,217.7083 
		442.8102,217.3726 442.8457,217.2607 443.1022,216.8103 443.1759,216.6975 443.2838,216.4173 443.3916,216.1371 443.6916,215.9078 
		444.068,215.6766 444.1048,215.6202 444.4075,215.5018 444.4444,215.4454 444.4812,215.3889 444.4798,215.3335 444.518,215.3326 
		444.5167,215.2771 444.5153,215.2216 444.5917,215.2197 444.6285,215.1633 444.6667,215.1624 444.7048,215.1614 444.7035,215.106 
		444.7417,215.105 445.2339,214.9265 445.272,214.9256 445.3088,214.8692 445.3839,214.8118 445.4207,214.7554 445.4588,214.7544 
		445.5352,214.7526 445.5338,214.6971 445.572,214.6962 445.6088,214.6398 445.647,214.6388 445.6838,214.5824 445.7206,214.526 
		445.7969,214.5241 445.8338,214.4677 445.9088,214.4103 446.0219,214.3521 446.0983,214.3502 446.1732,214.2928 446.2101,214.2364 
		446.285,214.179 446.4705,213.9524 446.3873,213.6769 446.3805,213.3995 446.416,213.2875 446.4133,213.1766 446.3301,212.901 
		446.2879,212.7355 446.3233,212.6236 446.2825,212.5135 446.2416,212.4035 446.1258,212.3508 446.0849,212.2408 446.0018,211.9652 
		446.0004,211.9097 446.0372,211.8533 446.0754,211.8524 446.074,211.7969 446.1108,211.7405 446.0727,211.7414 446.1081,211.6295 
		446.1068,211.574 446.1435,211.5176 446.1422,211.4621 446.179,211.4057 446.1776,211.3502 446.2131,211.2383 446.2867,211.1254 
		446.3235,211.069 446.3984,211.0117 446.4366,211.0107 446.4352,210.9552 446.472,210.8988 446.5075,210.7869 446.5456,210.786 
		446.5811,210.6741 446.6192,210.6731 446.6928,210.5603 446.6915,210.5048 446.6901,210.4493 446.6506,210.3948 446.6492,210.3393 
		446.6873,210.3383 446.761,210.2255 446.7978,210.1691 446.8345,210.1126 446.9081,209.9998 446.9449,209.9434 446.9803,209.8315 
		447.0185,209.8305 447.0934,209.7732 447.1302,209.7168 447.1289,209.6613 447.167,209.6603 447.2065,209.7149 447.2815,209.6575 
		447.3196,209.6566 447.3564,209.6001 447.3932,209.5437 447.4314,209.5428 447.43,209.4873 447.4286,209.4318 447.4668,209.4309 
		447.4273,209.3763 447.4654,209.3754 447.4641,209.3199 447.5009,209.2635 447.4995,209.208 447.5363,209.1516 447.5349,209.0961 
		447.5717,209.0396 447.5703,208.9842 447.6085,208.9832 447.6071,208.9277 447.6452,208.9268 447.6439,208.8713 447.6807,208.8149 
		447.7175,208.7585 447.7161,208.703 447.7542,208.702 447.791,208.6456 447.8278,208.5892 447.8646,208.5327 447.9014,208.4763 
		447.9,208.4208 447.9381,208.4199 447.9368,208.3644 447.9749,208.3634 448.0499,208.3061 448.1956,208.0249 448.2296,207.8575 
		448.3427,207.7992 448.3795,207.7428 448.4149,207.6308 448.4898,207.5735 448.562,207.4051 448.6342,207.2368 448.6259,206.9039 
		448.9582,206.4515 448.8778,206.2869 448.7988,206.1778 448.6407,205.9596 448.5181,205.6296 448.6665,205.4593 448.7401,205.3465 
		448.8408,204.7888 448.9074,204.3985 448.8638,204.1775 448.703,203.8483 448.8923,203.7881 448.8909,203.7326 448.9249,203.5652 
		448.8473,203.5116 448.7315,203.459 448.579,203.4627 448.5,203.3537 448.6879,203.238 448.76,203.0696 448.7954,202.9577 
		448.4399,202.4668 448.3527,202.0248 448.203,202.1395 448.0518,202.1988 447.9361,202.1461 447.8585,202.0925 447.819,202.038 
		447.7019,201.9298 447.5848,201.8216 447.5072,201.768 447.4677,201.7135 447.3901,201.6599 447.3873,201.5489 447.3846,201.4379 
		447.3792,201.216 447.4118,200.9931 447.4063,200.7711 447.4036,200.6602 447.4607,199.8815 447.4594,199.826 447.3804,199.7169 
		447.2647,199.6642 447.1109,199.6125 446.8822,199.6181 446.8427,199.5636 446.7665,199.5654 446.6521,199.5682 446.6127,199.5137 
		446.4629,199.6284 446.4262,199.6848 446.3132,199.7431 446.2002,199.8014 445.9715,199.807 445.8953,199.8089 445.8571,199.8098 
		445.7809,199.8117 445.7047,199.8135 445.7061,199.869 445.6679,199.87 445.6693,199.9254 445.5563,199.9837 445.5195,200.0401 
		445.4474,200.2085 445.2963,200.2677 445.2976,200.3232 445.1846,200.3814 445.1438,200.2714 445.0267,200.1632 445.024,200.0522 
		445.0594,199.9403 444.9029,199.7776 444.9383,199.6657 444.8594,199.5565 444.8567,199.4456 444.7042,199.4493 444.624,199.2847 
		444.5083,199.232 444.5423,199.0646 444.3491,198.9582 444.3831,198.7909 444.4185,198.679 444.341,198.6253 444.3764,198.5134 
		444.375,198.4579 455.259,196.0776 470.0181,216.1244 466.4558,217.2187 466.2311,217.3913 466.2297,217.3358 466.1519,217.2823 
		466.1137,217.2833 465.9977,217.2309 465.8831,217.2339 465.8068,217.2359 465.7304,217.2379 465.654,217.2399 465.5762,217.1865 
		465.4602,217.134 465.422,217.135 465.3838,217.136 465.306,217.0825 465.1915,217.0855 465.1151,217.0876 465.0769,217.0886 
		464.9976,216.9796 464.9962,216.9241 464.9198,216.9261 464.8817,216.9271 464.8449,216.9836 464.8053,216.9292 464.7686,216.9856 
		464.7304,216.9866 464.6936,217.0431 464.654,216.9886 464.6555,217.0441 464.6173,217.0451 464.0093,217.1721 463.7435,217.2346 
		463.7053,217.2356 463.2104,217.3041 461.9663,217.9473 461.8208,218.2287 461.7811,218.1742 461.627,218.1227 461.4742,218.1266 
		461.2437,218.0771 460.7502,218.2009 460.7134,218.2574 460.5635,218.3724 460.5678,218.5388 460.5693,218.5943 460.227,218.6586 
		460.3445,218.7666 460.3869,218.9321 460.0829,218.9955 460.0843,219.051 460.1239,219.1055 460.165,219.2155 460.2471,219.4355 
		460.3264,219.5444 460.4056,219.6534 460.4834,219.7069 460.5966,219.6485 460.7111,219.6455 460.8653,219.6971 460.905,219.7516 
		460.9445,219.806 461.0238,219.915 461.2162,219.9656 461.2559,220.0201 461.3719,220.0726 461.8079,220.672 461.846,220.671 
		461.7697,220.673 461.6154,220.6215 458.4693,220.1475 458.2361,221.486 454.0925,220.8696 451.2054,223.1073 446.7901,223.8827 
		444.5717,226.9903 444.6086,226.9339 444.6073,226.8784 444.6441,226.822 444.6059,226.823 444.5691,226.8794 444.5677,226.8239 
		444.5295,226.8248 444.4899,226.7702 444.4504,226.7157 444.4108,226.6611 444.4095,226.6057 444.3712,226.6066 444.3699,226.5511 
		444.2935,226.5529 444.2921,226.4974 444.2908,226.442 444.2143,226.4438 444.1775,226.5002 444.1393,226.5012 444.1406,226.5566 
		444.1024,226.5576 444.1037,226.6131 444.0273,226.6149 443.9877,226.5603 443.9482,226.5058 443.9099,226.5067 443.8704,226.4521 
		443.7926,226.3985 443.7544,226.3994 443.7162,226.4004 443.7148,226.3449 443.7135,226.2894 443.6753,226.2903 443.674,226.2348 
		443.6726,226.1793 443.6344,226.1803 443.633,226.1248 443.6317,226.0693 443.6686,226.0129 443.6672,225.9574 443.7041,225.901 
		443.741,225.8446 443.7396,225.7891 443.7001,225.7345 443.7383,225.7336 443.7369,225.6781 443.7752,225.6772 443.7738,225.6217 
		443.7725,225.5662 443.7343,225.5671 443.7329,225.5116 443.7711,225.5107 443.8094,225.5098 443.8476,225.5089 443.8462,225.4534 
		443.8844,225.4524 443.9226,225.4515 443.9595,225.3951 443.9977,225.3942 444.0359,225.3933 444.1123,225.3914 444.1506,225.3905 
		444.1492,225.335 444.1874,225.3341 444.2243,225.2777 444.2612,225.2213 444.223,225.2222 444.2599,225.1658 444.2216,225.1667 
		444.1834,225.1676 444.1821,225.1121 444.2203,225.1112 444.2176,225.0002 444.2531,224.8883 444.2136,224.8338 444.2518,224.8328 
		444.2886,224.7764 444.2859,224.6655 444.2846,224.61 444.2832,224.5545 444.2437,224.4999 444.2423,224.4444 444.2041,224.4454 
		444.241,224.389 444.2397,224.3335 444.2383,224.278 444.2765,224.277 444.2752,224.2216 444.3134,224.2206 444.3516,224.2197 
		444.3885,224.1633 444.4253,224.1069 444.4635,224.106 444.4622,224.0505 444.4608,223.995 444.4213,223.9404 444.4199,223.8849 
		444.4186,223.8295 444.4172,223.774 444.379,223.7749 444.3777,223.7194 444.3763,223.6639 444.3381,223.6648 444.3368,223.6094 
		444.2986,223.6103 444.2972,223.5548 444.3341,223.4984 444.3709,223.442 444.3696,223.3865 444.3683,223.331 444.3669,223.2755 
		444.3656,223.22 444.4024,223.1636 444.4393,223.1072 444.4775,223.1063 444.4761,223.0508 444.4748,222.9953 444.513,222.9944 
		444.5117,222.9389 444.5103,222.8834 444.5089,222.8279 444.5471,222.827 444.5458,222.7715 444.5445,222.716 444.5049,222.6615 
		444.5036,222.606 444.5022,222.5505 444.5009,222.495 444.4995,222.4395 444.4982,222.384 444.535,222.3276 444.4968,222.3285 
		444.4955,222.2731 444.4941,222.2175 444.4546,222.163 444.4532,222.1075 444.4519,222.052 444.4137,222.0529 444.4124,221.9975 
		444.3741,221.9984 444.3728,221.9429 444.3346,221.9438 444.3333,221.8883 444.2951,221.8893 444.2937,221.8338 444.2555,221.8347 
		444.2542,221.7792 444.2924,221.7783 444.2528,221.7237 444.2515,221.6682 444.2133,221.6692 444.2119,221.6137 444.1737,221.6146 
		444.1355,221.6155 444.0974,221.6165 444.0578,221.5619 444.0196,221.5628 443.98,221.5083 443.9787,221.4528 443.9774,221.3973 
		443.976,221.3418 443.9378,221.3427 443.8983,221.2882 443.8601,221.2891 443.8206,221.2345 443.781,221.18 443.7797,221.1245 
		443.7415,221.1254 443.7401,221.0699 443.702,221.0709 443.6638,221.0718 443.6624,221.0163 443.6242,221.0172 443.5847,220.9626 
		443.5451,220.9081 443.5833,220.9072 443.582,220.8517 443.5438,220.8526 443.5056,220.8535 443.5042,220.798 443.4661,220.7989 
		443.4265,220.7444 443.4252,220.6889 443.387,220.6898 443.3488,220.6907 443.3475,220.6353 443.3461,220.5798 443.3079,220.5807 
		443.2711,220.6371 443.2328,220.638 443.1947,220.639 443.1551,220.5844 443.1169,220.5853 443.1156,220.5298 443.0774,220.5307 
		443.0392,220.5317 443.0379,220.4762 442.9984,220.4216 442.9602,220.4225 442.922,220.4234 442.8838,220.4244 442.8824,220.3689 
		442.8442,220.3698 442.8429,220.3143 442.8034,220.2598 442.7652,220.2607 442.727,220.2616 442.7256,220.2061 442.6875,220.207 
		442.6861,220.1516 442.6479,220.1525 442.6466,220.097 442.6084,220.0979 442.6097,220.1534 442.5715,220.1543 442.5334,220.1552 
		442.532,220.0997 442.4938,220.1006 442.457,220.1571 442.4188,220.158 442.3806,220.1589 442.3424,220.1598 442.3042,220.1607 
		442.2673,220.2171 442.2292,220.2181 442.1909,220.219 442.1528,220.2199 442.1146,220.2208 442.0764,220.2217 442.075,220.1663 
		442.0369,220.1672 441.9987,220.1681 441.9973,220.1126 441.9591,220.1135 441.9196,220.059 441.9183,220.0034 441.8801,220.0044 
		441.8419,220.0053 441.8405,219.9498 441.8024,219.9507 441.801,219.8952 441.7628,219.8961 441.7246,219.8971 441.6865,219.898 
		441.6469,219.8434 441.6087,219.8443 441.5692,219.7898 441.531,219.7907 441.4915,219.7361 441.4533,219.737 441.4151,219.7379 
		441.3769,219.7389 441.3387,219.7398 441.3006,219.7407 441.261,219.6861 441.2597,219.6306 	'
            />
            <polygon
              id='GR07'
              className={getColor('GR07') + ' st13'}
              fill={'url(#' + getColor('GR07') + ')'}
              points='465.8753,219.6946 465.8333,219.7696 465.8261,219.7727 465.9464,219.9418 
		466.0365,220.0748 466.2257,220.3896 466.2849,220.5877 466.3172,220.7011 466.3573,220.8403 466.4775,221.1688 466.5403,221.3332 
		466.5469,221.6877 466.5501,221.8602 466.5256,221.9155 466.3552,222.3004 466.344,222.3074 465.1381,223.2472 465.0252,223.3917 
		464.9046,223.5615 464.7499,223.5497 463.3929,224.6068 463.3863,224.6119 463.386,224.6117 463.3444,224.5841 463.3029,224.5202 
		463.2178,224.4895 463.178,224.4491 463.1376,224.3786 463.0833,224.3239 463.0777,224.2672 463.0277,224.208 463.0195,224.1823 
		463.026,224.1347 463.0031,224.0704 463.0025,223.9968 462.9829,223.9045 462.9521,223.8568 462.9255,223.7882 462.9272,223.6985 
		462.9075,223.6324 462.9243,223.5683 462.8666,223.438 462.8572,223.427 462.8247,223.3832 462.8238,223.3414 461.9722,222.0894 
		461.9325,221.9155 461.8914,221.7357 461.8901,221.6145 461.9158,221.5454 461.9036,221.437 461.9198,221.3389 461.8873,221.2243 
		461.8795,221.2069 461.8347,221.1054 461.6283,220.6388 461.6294,220.639 461.6761,220.6531 461.7126,220.6679 461.752,220.6824 
		461.7722,220.6857 461.7943,220.6894 461.8226,220.6948 461.8365,220.6976 461.8253,220.6829 461.376,220.0956 461.2654,220.0368 
		461.2043,219.9688 461.0206,219.8958 460.9643,219.8316 460.9141,219.7743 460.8511,219.7025 460.7,219.673 460.5997,219.6566 
		460.5779,219.6456 460.4977,219.6949 460.4042,219.6452 460.3267,219.5708 460.2621,219.43 460.1742,219.2382 460.1206,219.121 
		460.0898,219.054 460.0684,219.0072 460.3752,218.9386 460.3576,218.7757 460.2251,218.6378 460.5635,218.6178 460.5632,218.5153 
		460.5628,218.3778 460.7009,218.2388 460.7576,218.1941 461.2371,218.0916 461.4729,218.1071 461.6085,218.0992 461.7643,218.1893 
		461.8232,218.2234 461.9812,217.9746 463.2215,217.3096 463.6867,217.2204 463.7549,217.2073 464.0123,217.1593 464.6276,217.0446 
		464.6387,217.0216 464.6449,217.0098 464.6568,217.0068 464.6716,217.0086 464.6988,217.0189 464.7174,216.9965 464.7225,216.9962 
		464.7416,216.9831 464.7651,216.9702 464.8071,216.949 464.8333,216.9574 464.8498,216.9581 464.8657,216.9428 464.8719,216.9306 
		464.9018,216.9336 464.979,216.9487 464.998,216.9614 465.0838,217.0706 465.1089,217.085 465.2097,217.0678 465.3087,217.0818 
		465.3699,217.109 465.4158,217.1117 465.4627,217.1231 465.5905,217.2104 465.6537,217.2429 465.7221,217.2517 465.7967,217.2384 
		465.8768,217.2138 465.984,217.2134 466.1223,217.2632 466.1659,217.2868 466.2108,217.3313 466.2471,217.3907 466.4722,217.2249 
		470.0029,216.1499 470.1268,216.3184 470.1833,216.3953 471.4779,218.1562 471.5637,218.2728 471.6551,218.397 486.4668,190.2155 
		488.004,190.3168 508.8155,229.885 508.8159,229.906 508.8053,229.9349 508.8246,229.9361 510.3126,232.1718 507.3277,233.1187 
		507.8557,237.5385 500.8277,240.0001 500.8129,239.9785 495.5973,241.7892 494.6252,242.1263 493.8922,240.6055 491.5882,235.8219 
		491.7254,232.379 488.68,232.3601 487.4003,232.3519 487.1267,231.0932 483.7909,230.3358 484.6528,221.8213 482.8037,222.862 
		481.2239,219.7775 477.21,221.8546 473.7495,220.1423 472.6636,221.4026 471.6694,220.6901 469.1533,218.8859 468.9391,218.9429 
		468.8397,218.9694 468.0029,219.1922 467.3485,219.3664 466.3279,219.638 466.2592,219.6308 466.1657,219.6541 466.0978,219.6634 
		466.014,219.6927 465.9048,219.7388 	'
            />
            <polygon
              id='GR06'
              className={getColor('GR06') + ' st13'}
              fill={'url(#' + getColor('GR06') + ')'}
              points='478.1995,148.6123 478.7869,148.7345 478.8798,148.8589 478.9335,148.9328 
		478.9351,148.9326 478.9352,148.9328 479.0148,148.9257 479.1115,148.9176 479.5107,148.8818 480.262,148.8152 480.8615,148.3853 
		480.8732,148.3309 480.9321,148.1787 481.2092,147.475 481.265,147.3318 481.2899,147.2902 482.9475,147.5304 483.0903,147.4764 
		483.1524,147.4733 483.5168,147.3423 483.7654,147.255 483.7973,147.2567 484.5396,147.2886 484.7328,147.297 484.8369,147.2247 
		485.038,147.0845 485.2316,147.0215 485.6935,146.7159 485.9843,146.7125 486.0075,146.8687 486.0545,147.1693 486.0781,147.3238 
		486.0781,147.3239 486.0814,147.3457 486.8322,147.9721 487.2427,148.0482 487.4888,148.2291 487.5845,148.2962 488.0717,148.4648 
		488.0766,148.4676 488.5586,148.486 489.3051,148.1673 489.3715,148.3483 489.442,148.5398 489.1129,148.7951 489.086,148.8152 
		489.1871,149.0636 489.2372,149.1897 490.5522,149.8128 490.7134,150.0513 491.5296,149.9347 491.5531,149.9328 491.5918,149.9382 
		491.753,149.9707 493.2595,150.2764 493.2655,150.2743 493.2729,150.2764 493.657,150.1405 493.6844,150.184 493.7919,150.357 
		494.0187,150.3547 494.1267,150.3653 494.2034,150.7617 494.2082,150.765 494.5729,151.1648 494.7912,151.1628 494.8114,151.1766 
		494.8745,151.1621 495.3152,151.1581 495.8375,150.97 496.3884,151.0053 497.2281,150.7181 499.0537,150.7634 499.2623,150.735 
		499.3174,151.0355 499.3187,151.0363 499.3191,151.0389 499.9007,151.4193 499.9355,151.4839 500.1941,151.9676 500.2926,151.9866 
		500.6509,152.0583 500.7971,152.1926 501.4367,152.3521 501.9828,152.9501 502.0835,153.1315 502.102,153.1634 502.6717,153.5579 
		502.7973,153.6454 503.4943,153.6689 504.3038,154.0502 505.2628,154.9655 505.5903,155.0209 505.8937,155.1888 505.9665,155.2292 
		505.9669,155.2292 505.9698,155.2308 506.3427,155.2846 506.4771,154.8714 508.0239,154.6716 508.1352,154.4743 508.1599,154.4616 
		508.4689,154.2282 508.5999,154.0585 508.7293,153.7529 508.8233,153.3918 508.8675,153.3261 509.3036,153.4976 511.0752,153.5916 
		511.188,153.7243 511.5205,154.1123 511.6213,154.2298 511.5407,154.2836 511.1947,154.5103 511.0419,154.7404 510.9277,154.9101 
		510.3332,155.2073 510.2878,155.2292 510.3562,155.3432 510.4032,155.4222 510.5213,155.6222 510.6405,156.089 510.7177,156.3863 
		510.7192,156.387 510.7194,156.388 512.7332,157.3747 512.7365,157.4897 512.7365,157.5183 512.8104,158.3446 512.8423,158.4991 
		512.8691,158.6251 513.0254,158.9778 513.0388,159.0029 513.1295,159.1625 513.2386,159.2968 513.2252,159.3355 513.1547,159.5471 
		512.9831,159.7578 512.7097,159.9586 512.3234,160.2424 512.1185,160.674 512.1607,160.768 488.004,190.3168 486.4668,190.2155 
		483.5361,186.6817 479.9914,180.0662 	'
            />
            <polygon
              id='GR05'
              className={getColor('GR05') + ' st13'}
              fill={'url(#' + getColor('GR05') + ')'}
              points='406.1042,207.3419 412.609,206.2357 416.8025,203.258 420.6687,208.0661 
		416.4785,211.2912 411.7092,218.8924 404.7534,221.0275 401.7287,219.5825 401.8873,211.82 	'
            />
            <polygon
              id='GR04'
              className={getColor('GR04') + ' st13'}
              fill={'url(#' + getColor('GR04') + ')'}
              points='465.6471,147.3679 466.6851,147.0702 467.8489,146.6453 468.3755,146.8046 
		468.5997,147.1777 468.6225,147.1894 468.991,147.3792 469.3924,147.779 469.6124,148.1199 469.787,149.3241 469.7884,149.325 
		469.7887,149.3274 470.1095,149.5391 470.4874,149.6701 471.087,149.23 471.6697,148.8992 472.0963,148.8858 472.8168,148.5901 
		473.1897,148.8051 474.016,148.3399 474.5131,147.957 474.8423,147.8865 475.0556,147.5791 475.2555,147.5388 475.5342,147.5875 
		475.9088,147.0333 476.4546,147.2281 477.7864,148.5264 478.1995,148.6123 479.9914,180.0662 464.6035,174.4395 460.8309,173.2215 
		460.9597,172.8201 461.6147,171.982 461.6919,171.018 462.6005,170.5847 462.4846,170.3059 462.8928,170.0859 462.8524,169.7768 
		462.9371,169.631 460.2205,161.7921 	'
            />
            <polygon
              id='GR03'
              className={getColor('GR03') + ' st13'}
              fill={'url(#' + getColor('GR03') + ')'}
              points='508.8165,229.9356 508.8155,229.885 488.004,190.3168 512.1607,160.768 512.3066,161.0922 
		512.1251,161.3274 511.6482,161.9488 511.2082,162.4996 511.0974,162.7767 511.213,162.991 511.297,163.1476 511.2384,163.6249 
		510.8471,164.1674 510.6456,164.4478 510.6472,164.4495 510.6472,164.4495 511.5155,165.3094 511.7405,165.5078 511.5877,166.302 
		511.534,166.5774 511.2485,166.8226 511.4315,167.224 511.4668,167.3013 511.5222,168.623 511.5238,168.6233 511.5239,168.6247 
		512.0438,168.6999 511.7943,169.1319 511.754,169.2008 511.7339,169.2478 511.5021,169.7601 511.5048,169.7595 511.5037,169.7617 
		512.0059,169.6643 512.6895,169.9616 513.8802,170.2387 514.3676,170.6273 514.552,170.9508 514.6461,171.0465 514.7603,171.107 
		514.8879,171.154 515.029,171.2414 515.1126,171.2922 515.1147,171.2951 515.689,171.322 516.1458,171.1893 516.4871,171.3884 
		516.5287,171.5017 516.6799,171.9182 516.8361,172.029 516.8527,172.0393 517.1074,172.2177 517.7665,172.6807 518.4608,172.9713 
		519.4208,173.3743 520.6334,173.5473 520.9542,173.2148 522.1937,172.815 522.6187,173.2132 522.7781,173.5993 522.7791,173.5992 
		522.7798,173.601 523.2467,173.4952 523.8329,173.2551 524.0596,172.9074 524.8058,173.0147 525.0723,173.7051 525.1244,174.5852 
		525.2192,174.6057 525.4459,174.6555 525.4468,174.6557 525.4546,174.6574 525.821,174.738 526.1992,175.1831 526.258,175.252 
		526.2583,175.252 526.2597,175.2536 527.2053,175.346 527.4393,175.5034 527.5411,175.5727 527.8182,175.7592 527.9006,175.7734 
		528.2869,175.8415 528.873,175.4804 529.4205,175.4938 529.7795,175.3344 529.8807,175.4888 529.9307,175.5635 530.1185,175.8489 
		530.1913,175.9607 530.2434,176.0397 530.2444,176.0401 530.2451,176.0413 530.4265,176.1393 530.4315,176.1421 530.4358,176.1443 
		530.9412,176.4175 531.0311,176.4662 531.7634,177.7326 531.7647,177.7337 531.7651,177.7343 532.0724,177.9879 532.5242,177.9627 
		532.6071,178.1293 532.6955,178.3103 532.8383,178.5958 533.1104,179.145 533.1134,179.1462 533.1136,179.1467 533.6326,179.3465 
		534.5361,179.9583 534.3327,180.5442 534.296,180.6498 534.2389,180.8043 534.1868,180.9387 534.1871,180.9398 534.1868,180.9404 
		534.2338,181.2015 534.2508,181.2954 534.2704,181.4057 534.2884,181.5065 534.4287,182.2924 534.4302,182.293 534.4304,182.294 
		534.5322,182.3395 534.5768,182.3594 534.9645,182.5325 535.0267,182.5678 535.1778,182.6534 535.4095,182.7861 535.4116,182.7858 
		535.6387,182.7474 536.1954,182.6535 537.1998,182.4838 537.3333,182.5134 538.3094,183.4603 539.6558,183.1295 540.2681,184.8614 
		537.2276,187.5312 536.0405,191.6736 532.0842,192.1837 530.8284,195.2044 529.3168,195.7456 527.4272,196.4216 526.6892,199.5224 
		523.8021,202.9763 519.8688,204.0607 521.0514,207.9424 521.2288,208.5242 523.4783,210.3273 523.2552,214.2703 519.7209,214.0993 
		515.773,216.6491 515.5862,216.7529 515.4012,216.889 513.2771,216.8381 511.6888,221.9574 511.6227,222.1705 511.6224,222.1827 
		514.8093,227.9537 512.6037,228.4895 511.7506,231.63 510.2946,232.1421 510.1023,231.8558 508.8246,229.9361 	'
            />
            <polygon
              id='GR02'
              className={getColor('GR02') + ' st13'}
              fill={'url(#' + getColor('GR02') + ')'}
              points='471.6551,218.397 455.2719,196.0584 455.4484,195.8223 483.5361,186.6817 
		486.4668,190.2155 	'
            />
            <polygon
              id='GR01'
              className={getColor('GR01') + ' st13'}
              fill={'url(#' + getColor('GR01') + ')'}
              points='434.1536,200.6854 436.677,200.2002 439.3946,199.5693 455.2719,196.0584 
		455.4484,195.8223 483.5361,186.6817 479.9914,180.0662 464.6035,174.4395 460.8363,173.2232 460.6456,173.8463 460.7716,174.7481 
		461.9926,175.3494 461.2821,176.1303 460.4138,176.4881 459.8731,177.4353 459.4045,177.7426 459.475,178.2918 459.7589,179.2962 
		459.4112,180.3106 458.0156,180.2887 457.8039,180.3593 457.8392,180.6565 458.0424,181.2561 457.851,182.0707 457.6393,182.4989 
		457.1775,182.8348 456.0976,181.7633 455.7399,181.6088 455.1033,180.6918 454.4836,180.5423 454.0788,180.1477 453.2374,179.8168 
		452.1054,179.3969 450.7585,179.402 449.7676,178.9351 449.1848,178.6042 448.466,178.4312 446.7126,178.4581 445.8494,178.5521 
		444.0204,178.1608 443.5283,178.4312 442.9371,177.7443 441.8891,177.8132 440.8008,178.0651 440.2516,177.9593 439.6084,177.3228 
		439.2473,177.1363 438.426,177.1347 438.1153,177.2169 437.1143,176.9415 436.7868,176.9718 436.2511,177.3345 435.4684,176.9516 
		434.8168,176.9986 433.7168,177.6536 432.3849,176.7887 432.1045,175.9103 431.3924,175.3611 430.6752,175.9086 430.2604,176.8827 
		429.5936,176.8911 428.5859,177.4168 428.3441,178.1826 427.5279,179.4624 426.9014,179.9982 426.6881,180.4953 426.8382,180.8298 
		427.0099,181.1135 434.8622,192.8389 437.5128,194.0502 429.2404,201.1793 423.2475,201.0537 422.4273,198.7242 421.9824,201.9908 
		416.8025,203.258 420.6687,208.0661 426.431,207.0233 428.9666,209.1265 429.2337,206.2002 431.6366,203.5729 434.2917,205.1752 
		433.6609,202.3234 	'
            />
            <polygon
              id='GL02'
              className={getColor('GL02') + ' st13'}
              fill={'url(#' + getColor('GL02') + ')'}
              points='399.0049,143.3659 422.9722,136.8909 422.8858,138.1152 422.8203,138.6762 
		422.9832,139.5025 422.8757,139.7947 422.9294,140.0483 422.8942,140.5018 422.6893,140.8091 422.6221,141.7026 422.9781,142.7993 
		423.2485,142.9924 422.9966,144.0405 423.44,146.3447 422.6237,148.0007 422.2845,149.0453 421.3239,150.0664 420.909,150.1302 
		420.5933,150.6542 419.636,150.7651 418.6669,151.1581 417.8104,151.8467 416.7338,152.7318 419.0901,154.3642 419.599,154.3995 
		420.1398,154.8529 420.6353,154.9907 421.522,154.5573 421.6094,154.6699 422.1989,155.0746 424.8575,153.2994 425.2219,153.3918 
		425.7141,153.1634 426.5286,153.679 427.2037,153.6269 427.501,153.6336 427.8302,154.1408 428.2601,154.4717 428.5406,154.9806 
		429.3367,155.2896 429.3535,155.6457 430.0001,156.5072 430.2016,157.0195 430.2218,158.4554 430.3117,158.6111 430.9137,159.6529 
		431.1841,160.6304 430.8768,160.7479 430.6198,161.3139 430.7928,162.157 430.4569,162.9857 430.4599,163.0755 430.823,163.7055 
		430.8079,164.8845 430.5478,165.7265 430.568,166.3348 430.6886,166.7101 430.8079,167.5901 430.6198,167.8935 429.6776,168.2468 
		429.7672,169.4932 429.7817,169.6945 429.7817,169.6945 429.6608,170.064 430.0588,170.6435 430.1815,171.1238 430.2469,171.1514 
		430.2469,171.1514 431.1539,171.5336 431.4075,171.7486 431.9012,173.3088 431.5318,173.8748 431.7031,174.2711 431.3924,175.3611 
		430.8566,175.7407 430.6752,175.9086 430.2604,176.8827 429.5936,176.8911 428.5859,177.4168 428.3441,178.1826 428.3441,178.1826 
		427.5279,179.4624 426.9014,179.9982 426.6881,180.4953 426.0768,180.9437 425.8114,181.6827 425.2606,182.1782 424.2075,182.5325 
		419.7234,178.3016 404.8755,166.873 390.5223,162.0119 390.1342,161.067 389.3011,160.3667 389.1332,160.58 388.7855,160.1971 
		388.4395,159.2364 387.8937,158.9761 387.7527,157.4477 386.6392,156.7256 386.1722,156.7793 385.7742,156.7256 385.4736,156.2637 
		385.7692,156.21 385.7944,155.9564 386.8524,155.5651 386.4729,154.6816 386.4141,153.8537 386.5602,153.5933 388.144,153.1533 
		388.4261,153.4187 388.9871,153.501 391.2393,152.2581 391.3719,151.8181 391.7582,151.4873 392.4468,151.3294 392.519,150.1941 
		392.7743,149.1931 393.1975,148.2996 393.6644,147.7941 393.8122,147.3742 394.0255,147.1139 394.0641,146.5681 393.9634,146.2825 
		394.4655,146.0491 394.7108,145.6242 394.5982,145.2345 395.4514,144.7677 395.757,144.4351 	'
            />
            <polygon
              id='GL01'
              className={getColor('GL01') + ' st13'}
              fill={'url(#' + getColor('GL01') + ')'}
              points='424.2075,182.5325 425.2606,182.1782 425.8114,181.6827 425.2606,182.1782 
		424.2075,182.5325 423.8062,182.9675 423.1663,182.6366 422.3937,182.5124 419.2749,182.4452 419.7905,183.5352 419.0266,183.75 
		418.7042,183.8408 418.7039,183.8409 418.4855,184.0793 418.4855,184.0793 417.7432,185.8411 416.9723,186.1115 416.2367,186.3601 
		416.0368,186.7867 415.5179,187.1595 415.14,187.1931 414.3708,187.6667 414.0601,188.0496 413.2119,187.5492 413.0356,186.3315 
		411.86,184.8838 411.8784,184.2137 410.5617,184.039 409.198,183.5217 408.1147,183.6242 407.9955,183.5402 407.5722,183.7099 
		407.1373,184.2977 406.5981,185.0803 405.9348,185.1072 405.6526,185.2146 405.5334,185.5018 405.4426,187.2704 405.6895,188.2579 
		404.9019,188.8239 404.6365,189.2286 404.1662,190.3707 404.267,191.061 403.7061,191.4388 403.3886,192.0905 403.1585,192.9117 
		402.6631,193.644 402.4851,194.4619 402.0266,194.8129 401.1046,195.6375 400.3605,195.8256 399.6266,195.8391 397.6935,196.358 
		396.9999,196.3446 395.5639,196.6184 394.5629,197.0265 394.1481,196.8921 393.9751,196.9979 393.6644,197.3657 393.3604,197.5186 
		392.734,197.5858 392.4821,197.7184 392.3242,198.0056 391.4962,198.2256 390.8093,198.585 390.4415,198.2978 389.4976,198.2659 
		389.1348,198.1047 389.0291,197.7587 389.0945,197.3036 389.1533,196.9408 389.0811,196.2254 389.0374,195.8777 388.0012,196.0943 
		387.3227,195.7047 387.1547,195.4494 386.9163,195.3419 386.0833,195.4662 385.7921,195.3115 385.7643,195.2967 385.6566,195.2395 
		384.2005,195.5989 384.0427,195.2395 384.0561,195.0128 384.5616,194.3158 384.7447,192.559 384.6557,192.3054 383.7807,191.5161 
		383.7353,190.5991 383.3356,190.2095 383.8126,189.8534 384.2173,189.6602 384.5633,189.4537 385.0865,189.2241 385.5659,189.0137 
		386.0698,188.8541 386.5484,188.5333 387.0221,187.796 387.5729,187.1729 388.0533,186.4927 388.7335,186.654 389.2659,186.6003 
		389.8268,186.1619 390.2383,185.9066 391.1318,185.6413 391.7985,185.1609 392.2704,184.6638 392.8784,184.2406 394.0809,183.7905 
		394.3026,183.0095 394.2774,182.6937 394.2052,181.4459 393.5888,179.5162 393.6493,179.056 393.0615,178.93 392.3712,178.0718 
		392.2301,177.4185 391.2409,175.4703 391.8321,175.0723 392.2788,175.0823 392.9036,174.466 393.5099,174.5013 393.6846,174.3266 
		394.7813,174.209 394.9459,173.8412 394.4991,173.2651 394.2774,173.1761 394.0776,172.8167 393.8508,172.4287 393.7484,171.9199 
		394.2909,170.4285 394.5848,170.1765 394.6755,168.9657 394.7981,168.7104 395.2381,168.403 395.438,168.2435 395.6512,168.0587 
		395.3439,168.0201 393.824,167.5096 392.8247,166.3507 392.4233,166.6849 390.6346,163.8987 391.7448,163.4317 391.8187,162.8826 
		391.3282,163.0757 391.162,162.6642 391.0075,162.7029 390.6212,162.2528 390.6212,162.2527 390.5223,162.0119 404.8755,166.873 
		419.7234,178.3016 	'
            />
            <polygon
              id='FR06'
              className={getColor('FR06') + ' st13'}
              fill={'url(#' + getColor('FR06') + ')'}
              points='193.1242,224.4432 170.492,221.8436 170.8601,220.4205 168.8576,217.8784 
		174.2696,200.9427 177.3085,196.8995 195.4506,215.197 195.4487,222.8337 	'
            />
            <polygon
              id='FR05'
              className={getColor('FR05') + ' st13'}
              fill={'url(#' + getColor('FR05') + ')'}
              points='161.3307,167.6834 167.9707,166.0381 161.9439,179.8611 161.329,179.49 161.2994,179.501 
		161.2836,179.5037 159.7951,180.5056 159.4878,181.1642 160.3522,183.505 160.1428,183.984 155.7726,184.6592 155.522,183.7691 
		153.0326,181.7078 154.909,179.8381 153.7958,175.6524 153.7394,175.5811 154.1293,174.9705 155.7755,173.3479 156.5532,173.3505 
		160.6728,171.2883 161.5012,167.8013 	'
            />
            <polygon
              id='FR04'
              className={getColor('FR04') + ' st13'}
              fill={'url(#' + getColor('FR04') + ')'}
              points='183.0101,247.4644 174.0031,247.2271 173.8754,247.0432 173.8589,246.1484 
		173.5848,245.9464 170.4573,245.0501 172.1277,230.1984 172.5824,228.6823 170.1962,222.9867 170.492,221.8436 193.1242,224.4432 	
		'
            />
            <polygon
              id='FR03'
              className={getColor('FR03') + ' st13'}
              fill={'url(#' + getColor('FR03') + ')'}
              points='161.9439,179.8611 167.9707,166.0381 169.3545,164.8373 180.561,176.2744 
		179.6323,179.3026 166.9022,186.6445 167.0247,186.2684 162.7721,185.1759 162.7405,185.1377 163.5479,182.1902 162.9221,180.4511 
			'
            />
            <polygon
              id='FR02'
              className={getColor('FR02') + ' st13'}
              fill={'url(#' + getColor('FR02') + ')'}
              points='165.9643,195.3061 174.2696,200.9427 168.8576,217.8784 167.9374,216.7096 
		168.7965,209.5296 168.1974,208.5841 168.1719,207.8796 166.6424,204.6702 166.6651,204.5933 169.6319,203.1021 169.1232,199.3663 
		167.5535,198.1903 164.6869,201.321 162.4228,201.5432 161.1082,199.0343 162.1479,197.1511 	'
            />
            <polygon
              id='FR01'
              className={getColor('FR01') + ' st13'}
              fill={'url(#' + getColor('FR01') + ')'}
              points='174.2696,200.9427 165.9643,195.3061 166.6851,194.9574 164.9236,192.7125 
		166.9022,186.6445 179.6323,179.3026 177.3085,196.8995 	'
            />
            <polygon
              id='BS01'
              className={getColor('BS01') + ' st13'}
              fill={'url(#' + getColor('BS01') + ')'}
              points='208.3484,66.3382 209.0454,65.9394 209.7021,65.8487 209.9624,66.2182 210.2144,66.1006 
		210.3806,66.3727 210.5267,66.329 210.6057,66.1863 210.5906,65.5447 211.0356,65.0577 211.1213,64.9182 211.5378,64.0164 
		211.5613,63.8535 211.4857,63.5344 211.0978,62.9969 211.0038,63.0117 210.9248,62.9297 210.6889,63.0613 210.6712,63.0641 
		210.0095,62.5821 209.9932,62.5975 209.991,62.5955 209.9467,62.6415 209.6282,62.9432 208.8221,63.7057 207.8883,63.7141 
		207.7035,63.4907 207.7892,63.012 207.4583,62.4528 207.3559,62.1958 207.4835,61.5962 207.5147,61.5688 207.591,61.5559 
		207.9572,61.1786 208.1503,61.0084 208.5752,60.6742 208.6035,60.6652 208.6323,60.6624 208.644,60.6522 208.817,60.5969 
		208.9061,60.7246 210.0095,60.4172 210.8055,59.5137 210.7669,59.3877 211.5731,58.8704 212.2029,58.6823 212.5169,58.3061 
		212.7336,58.3212 213.5599,57.5252 214.1208,57.1893 214.5474,56.9693 214.8229,56.8265 215.0143,56.0674 214.954,56.0025 
		214.969,55.9364 214.765,55.605 214.838,55.4644 215.7869,54.8363 215.9027,54.6425 216.0121,54.5834 217.028,54.8027 
		217.5016,54.7322 218.2927,54.8917 218.3397,53.7782 218.8402,52.2633 220.0293,52.6866 220.8304,53.1736 220.7229,53.8152 
		220.8892,54.0973 220.78,54.4887 221.0202,54.45 221.4803,54.4198 221.8297,54.4265 222.1673,54.45 222.4309,54.5273 
		222.619,54.6633 222.7114,54.6196 222.7332,54.6072 222.7954,54.6297 223.0742,54.4836 223.3681,54.2435 223.675,53.8915 
		223.7342,53.8454 224.453,53.0342 224.8259,52.4884 225.1971,52.1357 225.6623,51.951 225.4994,51.6302 225.4994,51.4102 
		225.9222,50.967 226,50.8997 226.4029,51.0356 226.675,51.128 226.8295,51.1314 227.2175,51.2019 227.4929,51.3161 
		228.0421,51.5042 228.6988,51.8065 229.6846,51.8048 229.7602,51.5983 229.9903,51.2607 230.4169,50.8576 230.6654,50.5973 
		230.8855,50.5267 231.3305,50.5486 231.7773,50.3958 231.951,50.1794 232.0132,50.2189 231.5606,50.7904 230.9342,50.9416 
		230.7629,51.0541 230.3158,51.6781 230.2223,51.7772 229.9937,51.9476 229.2715,52.6815 229.3084,53.1031 230.4068,53.5481 
		230.4572,53.8773 230.5529,54.5071 230.7914,54.6717 230.7931,55.1722 231.0618,55.3553 231.2556,55.411 230.902,56.4501 
		230.7494,56.2068 230.7561,55.6962 230.4924,55.8138 230.1079,56.0993 230.0323,56.3428 229.7216,56.7711 229.9752,56.8466 
		229.9937,57.0683 229.7854,57.1355 229.3571,57.0851 229.3538,56.7576 229.0817,56.6922 228.6177,56.824 228.4474,56.8409 
		228.3511,56.7979 227.6558,56.9827 227.3955,57.2346 227.3451,57.3707 227.1301,57.3421 226.3055,57.8191 225.8168,57.5285 
		225.4422,57.5755 225.1399,57.2699 224.794,57.0516 224.5253,57.594 224.605,57.6364 224.5941,57.6562 224.8947,57.8375 
		225.1886,58.1298 225.9091,59.2769 226.2417,59.7824 226.3074,59.8437 226.3089,59.8462 226.3374,59.8899 226.3676,59.9319 
		226.3844,59.9503 226.4214,59.989 226.4617,60.0226 226.5893,60.1132 226.6271,60.1416 226.6364,60.1502 226.641,60.152 
		226.6968,60.1939 226.7354,60.2241 226.7808,60.251 226.8026,60.2661 226.8513,60.2846 226.9,60.3047 226.9504,60.3181 
		226.9773,60.3265 227.0277,60.3366 227.1517,60.3511 227.2007,60.3702 227.6944,60.4895 227.948,60.6624 228.0941,60.8623 
		228.1882,61.2872 228.3074,61.6097 228.5325,61.9775 228.5547,62.002 228.5745,62.0362 228.6736,62.1572 228.7592,62.2546 
		228.7995,62.2899 228.818,62.31 228.8398,62.3251 228.86,62.3386 228.8835,62.352 228.8912,62.3553 227.8579,65.3868 
		209.7863,67.6826 	'
            />
            <polygon
              id='BL05'
              className={getColor('BL05') + ' st13'}
              fill={'url(#' + getColor('BL05') + ')'}
              points='218.5599,101.159 219.066,95.0157 
		228.7512,75.838 243.4733,86.3213 245.0555,91.909 244.7467,94.0739 226.4347,100.7273 	'
            />
            <polygon
              id='BL04'
              className={getColor('BL04') + ' st13'}
              fill={'url(#' + getColor('BL04') + ')'}
              points='228.8912,62.3553 228.907,62.3621 228.9085,62.3627 229.2547,62.5687 229.7201,62.7149 
		229.7484,62.7265 229.8475,62.7601 229.9214,62.7853 229.9953,62.8071 230.1246,62.8407 230.175,62.8542 230.2506,62.8676 
		230.3027,62.876 230.3816,62.8878 230.5126,62.9012 230.5899,62.9079 230.6957,62.9096 231.0081,62.9113 231.1323,62.9197 
		231.218,62.923 231.4531,62.9415 231.5573,62.9449 231.6631,62.9465 231.6831,62.9462 231.8142,62.9549 232.0932,62.917 
		232.1837,62.9062 232.2878,62.8911 232.3651,62.876 232.4188,62.8626 232.4894,62.8391 232.5414,62.8189 232.6086,62.7836 
		232.701,62.7333 232.7463,62.7081 232.8135,62.6627 233.0033,62.5267 233.2804,62.3285 233.3425,62.2781 233.3644,62.2647 
		233.3879,62.2546 233.4366,62.2361 233.6129,62.1807 233.6868,62.1589 233.712,62.1522 233.7372,62.1387 233.8044,62.1018 
		233.8716,62.0598 234.2864,61.786 234.3082,61.7709 234.3536,61.7457 234.4006,61.7239 234.5215,61.6668 234.5988,61.6248 
		234.6542,61.5878 234.755,61.5022 234.7953,61.4703 234.8826,61.4115 234.9716,61.3544 235.1026,61.2704 235.2504,61.1824 
		235.4089,61.1276 235.4335,61.126 235.541,61.1293 235.593,61.126 235.7224,61.1092 235.9155,61.0857 236.06,61.0672 
		236.1893,61.0504 236.3472,61.0336 236.6864,61.0084 236.8409,60.9916 237.076,60.9647 238.3239,60.822 238.6346,60.7834 
		238.7387,60.7666 238.816,60.7531 238.8681,60.7447 238.9453,60.7279 239.172,60.6692 239.2241,60.6725 239.251,60.6725 
		239.2762,60.6692 239.3013,60.6608 239.3517,60.6423 239.3971,60.6188 239.5264,60.5499 239.56,60.5315 239.6053,60.5079 
		239.6826,60.4827 239.7027,60.4693 239.7229,60.4525 239.738,60.4307 239.7548,60.4122 239.7985,60.3467 239.9362,60.1536 
		239.9815,60.0914 240.0285,60.0276 240.0487,60.0091 240.0672,59.9906 240.1075,59.9587 240.131,59.9419 240.1781,59.9218 
		240.2251,59.9016 240.3477,59.858 240.5945,59.7656 240.7172,59.7169 240.959,59.6195 241.0816,59.5725 241.2019,59.5296 
		241.6795,59.423 241.7404,59.3861 245.5701,67.9153 243.4733,86.3213 228.7512,75.838 227.8579,65.3868 	'
            />
            <polygon
              id='BL03'
              className={getColor('BL03') + ' st13'}
              fill={'url(#' + getColor('BL03') + ')'}
              points='181.8335,81.2848 181.8412,81.2748 181.9419,81.1656 182.1569,81.0732 182.3702,80.8733 
		182.4609,80.7776 182.5892,80.5153 182.6265,80.4689 182.6508,80.4644 183.3465,80.5586 183.5038,80.6063 183.6584,80.6248 
		183.8381,80.645 184.0209,80.584 184.6933,80.5046 184.876,80.5391 185.0137,80.4938 185.2488,80.4938 185.5159,80.393 
		185.6229,80.2971 185.6284,80.2923 185.7546,80.1572 186.003,79.9851 186.1423,79.9799 186.4614,80.0588 186.6881,80.1125 
		187.1265,80.1125 187.2508,80.22 187.5027,80.5123 187.7815,80.6987 187.9158,80.9237 187.9527,80.9466 187.9578,80.9641 
		188.069,81.0187 188.0704,81.0195 188.0729,81.0205 188.2383,81.1018 188.7619,81.2472 188.7741,81.2529 189.1687,81.3789 
		189.2124,81.3723 189.2964,81.3957 190.0874,81.369 190.1915,81.3822 190.3377,81.3839 190.5543,81.4595 190.8415,81.3487 
		191.0766,81.3503 191.3101,81.4309 191.3861,81.4355 192.2517,81.6807 192.474,81.7652 192.4889,81.7479 192.5025,81.7517 
		192.7242,81.5703 192.9429,81.6719 193.0719,81.7467 193.0865,81.7386 193.1474,81.7668 193.7289,81.3835 194.0425,81.2102 
		194.9697,81.0984 195.3022,81.0783 195.3017,81.0638 195.3173,81.0631 195.3173,80.6088 195.5988,80.3493 195.9194,80.1426 
		196.6912,79.8589 197.4671,79.251 197.6031,79.0478 197.9323,78.5607 197.9134,78.4322 197.9273,78.4079 197.9076,78.3931 
		197.8819,78.2181 198.5336,77.7159 198.5213,77.5984 198.5268,77.5933 198.5175,77.5626 198.4647,77.0559 198.7351,76.6394 
		199.2272,76.6528 200.6279,76.1842 201.2997,75.1094 201.9211,74.5719 202.0252,74.278 201.9916,74.1168 201.8724,74.0076 
		201.3198,73.6482 200.9822,73.8497 200.7992,73.3997 200.4717,73.057 200.3272,73.0285 200.2399,73.1695 199.5597,72.701 
		199.4593,72.6856 199.3128,72.58 199.2414,72.6522 198.9904,72.6136 198.6444,72.3113 198.3029,72.5438 197.9439,72.6555 
		197.6166,72.7363 197.7106,72.0863 198.1624,71.2046 198.9708,69.7635 198.9784,69.754 199.3313,69.4159 200.2701,70.0575 
		200.8764,70.301 201.3668,70.8821 201.8123,71.0009 202.1394,71.1945 202.4064,71.1811 202.4793,71.1131 202.7927,71.0736 
		203.9045,72.6859 204.194,72.7227 204.2052,72.7279 204.2344,72.7279 204.5511,72.7682 206.0207,72.3382 206.1299,72.3063 
		206.4876,71.9654 206.8285,71.213 207.2702,71.04 207.8396,70.8183 207.8295,70.2439 208.9732,69.6258 208.6894,68.6702 
		208.9665,68.5527 208.7465,67.2427 208.0109,66.4264 207.4768,66.0485 207.3669,65.4202 207.8317,65.855 208.0277,66.3038 
		208.335,66.3458 208.3484,66.3382 209.7863,67.6826 219.066,95.0157 218.5599,101.159 218.2435,101.7518 215.5738,102.2935 
		216.3674,101.8059 216.6771,101.3967 216.8319,100.9764 216.4116,100.3348 215.9913,99.627 215.7037,99.096 215.4604,98.7863 
		215.2613,98.4545 214.7746,98.543 214.7525,98.1669 214.3985,98.1669 214.2334,97.9134 213.182,97.4868 212.6211,97.5154 
		212.2801,97.0031 212.868,95.9635 212.6295,95.1473 211.8989,95.2229 211.6789,94.677 211.0004,94.6132 210.3739,94.2152 
		210.6913,93.3956 210.7165,93.1554 210.6762,93.0043 209.991,92.9136 207.5977,92.9606 206.8856,93.1756 206.412,93.3032 
		205.9586,93.3569 204.9576,93.0899 204.5982,93.105 203.7198,93.2696 202.3326,93.1554 201.7279,92.67 200.0165,91.3936 
		199.4993,91.7917 199.5983,91.4491 199.1583,91.5834 196.4056,91.3298 196.9851,90.5455 196.6525,89.6722 196.7735,88.8375 
		195.6398,88.557 195.0251,88.3303 194.8,88.3303 194.4071,87.0891 193.4951,87.1563 192.8972,85.4046 191.8408,85.0771 
		190.5343,84.9778 188.416,86.4099 182.2479,81.9542 	'
            />
            <polygon
              id='BL02'
              className={getColor('BL02') + ' st13'}
              fill={'url(#' + getColor('BL02') + ')'}
              points='245.0555,91.909 243.4733,86.3213 245.5701,67.9153 261.9115,65.2751 264.7316,80.656 	'
            />
            <polygon
              id='BL01'
              className={getColor('BL01') + ' st13'}
              fill={'url(#' + getColor('BL01') + ')'}
              points='219.066,95.0157 209.7863,67.6826 227.8579,65.3868 228.7512,75.838 	'
            />
            <polygon
              id='BE25'
              className={getColor('BE25') + ' st13'}
              fill={'url(#' + getColor('BE25') + ')'}
              points='196.5275,278.4735 183.0101,247.4644 193.1242,224.4432 195.4487,222.8337 
		207.2904,235.1448 199.0895,275.512 197.0422,278.112 196.5523,278.4645 	'
            />
            <polygon
              id='BE24'
              className={getColor('BE24') + ' st13'}
              fill={'url(#' + getColor('BE24') + ')'}
              points='244.6823,240.7816 241.8001,199.5565 242.0615,199.4646 267.7004,210.8762 
		265.4036,221.8615 	'
            />
            <polygon
              id='BE23'
              className={getColor('BE23') + ' st13'}
              fill={'url(#' + getColor('BE23') + ')'}
              points='218.717,224.804 215.6694,196.7275 237.99,195.7321 240.6465,199.0871 223.548,223.8379 	
		'
            />
            <polygon
              id='BE22'
              className={getColor('BE22') + ' st13'}
              fill={'url(#' + getColor('BE22') + ')'}
              points='231.761,171.868 228.9752,168.4995 233.7834,137.3108 239.9391,139.3398 
		251.1019,158.7443 	'
            />
            <polygon
              id='BE21'
              className={getColor('BE21') + ' st13'}
              fill={'url(#' + getColor('BE21') + ')'}
              points='195.4506,215.197 177.3085,196.8995 179.6323,179.3026 180.561,176.2744 
		185.6965,174.1897 201.5597,194.5853 	'
            />
            <polygon
              id='BE20'
              className={getColor('BE20') + ' st13'}
              fill={'url(#' + getColor('BE20') + ')'}
              points='174.0031,247.2271 183.0101,247.4644 196.5275,278.4735 195.3677,278.8946 
		195.0419,279.2221 194.7833,278.7821 193.8864,279.4405 193.3188,280.2046 192.9627,280.2819 192.5428,280.8982 192.3766,281.0595 
		192.0054,281.0326 191.5183,281.7128 190.6954,282.3208 189.9951,282.4988 189.5315,283.1353 188.8161,283.7114 188.0788,283.619 
		186.7352,284.3865 184.9969,284.803 183.8683,284.887 183.3493,284.1749 182.9362,283.3755 182.9883,282.9623 183.1881,282.6701 
		182.9883,282.215 183.042,282.0016 183.2217,281.8673 183.4283,281.2425 183.5559,279.9443 183.2469,279.0491 181.7773,280.6295 
		181.2382,280.7924 180.684,280.5355 177.0261,282.1931 176.9236,282.7507 176.9639,284.0154 176.7422,284.7812 176.9891,285.935 
		176.6835,286.1752 176.1763,286.9595 175.8488,287.3592 175.3768,287.4012 175.0443,287.6951 174.6177,287.8681 173.2993,288.0982 
		171.729,287.596 171.9238,283.9868 171.4552,282.4333 171.5174,282.4047 171.7004,282.1696 172.1707,282.0453 172.3437,282.1125 
		172.478,282.0185 172.4982,281.7598 172.8862,281.5096 172.5922,281.3937 172.3823,280.9117 171.4502,281.481 171.0555,281.4743 
		170.3837,280.4078 170.209,279.5513 169.9303,279.2473 169.942,279.029 169.942,278.5352 170.0747,278.3555 169.7724,278.2027 
		169.2853,278.3656 168.1685,278.3001 168.2911,277.3931 168.7915,276.4291 168.8184,276.11 169.1644,275.67 169.4398,274.9663 
		169.591,274.2979 169.9991,273.8226 169.9084,272.8233 170.2762,271.3554 169.8463,270.4435 169.3559,270.0807 169.072,269.6356 
		168.8957,268.9218 168.103,268.0838 168.3717,266.7939 169.2887,266.762 169.6683,267.071 170.7079,266.9887 171.9305,266.5302 
		172.1908,266.2582 172.3504,265.8249 172.4293,264.9784 172.384,264.7584 173.2153,264.31 172.5167,263.7289 172.9567,263.1159 
		172.7703,262.9026 173.0188,262.0208 172.4915,260.7965 172.3168,259.8762 172.2244,258.237 172.6107,258.3428 172.9113,258.1664 
		173.7108,257.9934 173.6352,257.0613 173.254,256.6834 173.4908,256.5844 173.6789,256.5692 173.9308,256.3828 174.1777,256.4735 
		174.3439,256.1695 174.4346,255.9041 174.6362,255.7564 174.7705,255.4104 174.7302,255.1148 174.7974,254.7991 175.0762,254.4111 
		175.0107,254.1172 175.276,253.6368 175.2374,253.3967 175.1165,253.1313 175.1803,252.8374 175.3147,252.4646 175.3298,251.7978 
		175.2811,251.3964 175.1921,250.7061 175.0762,250.1973 175.1014,249.9571 174.8629,249.6514 174.9704,249.0502 174.9838,248.7563 
		174.9821,248.637 	'
            />
            <polygon
              id='BE19'
              className={getColor('BE19') + ' st13'}
              fill={'url(#' + getColor('BE19') + ')'}
              points='231.7095,134.1366 224.99,130.7227 218.2435,101.7518 218.5599,101.159 226.4347,100.7273 
		238.7895,116.5526 	'
            />
            <polygon
              id='BE18'
              className={getColor('BE18') + ' st13'}
              fill={'url(#' + getColor('BE18') + ')'}
              points='213.9562,166.7451 189.4137,165.601 190.639,152.9603 203.3585,140.6792 205.457,140.2323 
		210.6993,143.4478 	'
            />
            <polygon
              id='BE17'
              className={getColor('BE17') + ' st13'}
              fill={'url(#' + getColor('BE17') + ')'}
              points='283.0016,215.7083 293.985,238.7504 298.1237,247.3673 299.6242,250.4803 
		300.3439,250.3098 301.2475,250.1939 301.9411,250.1805 302.7086,250.209 303.241,250.2594 304.6148,249.7136 305.4042,249.7018 
		306.2069,248.9679 306.7528,248.6874 307.4464,248.3952 308.0729,248.328 308.6456,248.0173 309.1578,247.1272 310.0563,246.7493 
		311.1312,246.6367 312.4026,245.3217 312.3774,244.9808 312.9383,244.089 315.4576,243.6842 316.2856,243.0494 317.2177,242.2499 
		317.3654,241.6756 318.5008,240.5285 319.0046,239.5695 318.5159,238.9682 318.8518,237.7792 318.5629,236.7479 318.6049,236.1719 
		319.0281,235.6361 319.3775,234.6217 319.705,233.7635 319.7419,232.8499 319.4262,232.566 319.4111,231.78 319.422,231.6955 
		319.4396,231.5592 319.5102,231.0125 319.9351,230.1661 320.1215,230.2332 320.9243,229.988 322.241,228.0516 322.7331,227.7745 
		322.7331,227.7745 323.2806,226.2411 323.8147,226.3016 324.7484,226.4074 324.4294,223.8932 323.6568,223.4767 323.4318,222.7797 
		323.1177,222.4925 323.0841,222.291 323.2235,221.4529 322.9917,220.5964 323.2722,219.8507 323.1513,219.582 323.2588,219.0092 
		324.3907,219.4157 324.9097,219.3855 325.1935,219.6038 325.2339,219.9783 325.6504,220.0287 325.9124,219.98 326.9553,220.2084 
		327.5364,220.0136 328.6146,220.2857 329.278,219.9363 330.0456,219.676 330.0456,219.676 330.148,218.6616 330.3781,218.0267 
		330.3714,217.7379 329.975,216.7537 330.2051,216.0382 330.185,215.5529 329.5132,215.269 329.3351,214.8576 329.4023,214.1337 
		329.3351,212.5617 329.6173,212.0007 328.4501,210.595 328.4568,209.5621 328.6969,208.8282 328.6298,208.2555 328.1494,207.629 
		328.4954,207.3755 328.8162,207.483 329.1219,206.9875 329.4359,205.5297 329.0429,205.0829 329.1991,204.7706 329.1806,204.5909 
		329.1135,204.4733 328.6516,204.5355 327.8773,204.0803 327.1871,204.1223 326.606,204.2617 326.5506,204.433 326.087,204.433 
		325.8435,204.0467 325.3883,203.7897 324.987,203.7763 323.4175,205.1162 322.6777,205.4424 322.5265,204.3054 322.11,203.1633 
		321.4113,203.0239 320.5582,202.211 320.2088,201.6686 319.4195,201.2487 319.1121,201.2773 318.4588,201.6383 318.4302,201.9457 
		315.9175,202.3783 314.5255,202.6696 313.4331,204.0026 309.0888,201.7321 304.5005,199.5175 	'
            />
            <polygon
              id='BE16'
              className={getColor('BE16') + ' st13'}
              fill={'url(#' + getColor('BE16') + ')'}
              points='265.4036,221.8615 244.6823,240.7816 243.4003,245.217 243.4001,246.4933 
		244.1571,260.2775 244.3482,261.7107 244.8705,264.5652 245.5675,264.2075 246.1234,263.4719 247.2705,262.8455 247.603,262.7397 
		248.0431,262.6187 249.5496,261.873 249.9745,261.1794 252.0251,259.7485 252.492,259.5554 252.8699,259.7149 254.536,259.6561 
		255.3219,259.6998 256.3112,259.6057 257.6279,259.0868 258.1452,258.682 258.7212,258.8735 259.0017,258.766 259.4552,258.42 
		259.9875,258.2605 260.0665,257.9514 260.7484,258.0203 261.2808,257.2175 262.3086,257.1117 262.5202,256.7725 262.3372,256.4702 
		262.8796,256.0435 263.5262,255.8857 263.7563,254.9334 264.7052,254.0937 265.9111,253.8753 266.1916,254.0298 267.6141,253.0608 
		268.0105,253.1196 268.4085,252.431 268.3497,251.5929 268.6688,250.995 268.1398,250.4777 268.1482,250.125 267.8341,249.7942 
		267.9517,249.5087 267.5738,249.0586 267.3252,248.6589 267.3471,248.1987 267.9802,247.7738 268.2237,247.1608 269.0299,246.7207 
		269.3406,246.6871 269.5086,246.5394 269.7403,246.5142 270.3248,246.5394 271.1628,245.3268 270.56,246.199 	'
            />
            <polygon
              id='BE15'
              className={getColor('BE15') + ' st13'}
              fill={'url(#' + getColor('BE15') + ')'}
              points='241.8001,199.5565 240.6465,199.0871 237.99,195.7321 231.761,171.868 251.1019,158.7443 
		255.4496,161.026 253.5229,177.5723 242.0615,199.4646 	'
            />
            <polygon
              id='BE14'
              className={getColor('BE14') + ' st13'}
              fill={'url(#' + getColor('BE14') + ')'}
              points='239.9391,139.3398 233.7834,137.3108 231.7095,134.1366 238.7895,116.5526 
		247.3911,105.2454 252.8336,111.5132 256.9281,123.6481 	'
            />
            <polygon
              id='BE13'
              className={getColor('BE13') + ' st13'}
              fill={'url(#' + getColor('BE13') + ')'}
              points='215.6694,196.7275 209.5271,190.2832 214.6765,168.3045 228.9752,168.4995 
		231.761,171.868 237.99,195.7321 	'
            />
            <polygon
              id='BE12'
              className={getColor('BE12') + ' st13'}
              fill={'url(#' + getColor('BE12') + ')'}
              points='162.5494,142.6404 167.0706,149.6855 169.3545,164.8373 167.9707,166.0381 
		161.3307,167.6834 158.8919,165.9961 155.7185,166.7319 155.2129,166.6564 151.1486,166.5993 148.9132,165.9913 148.7956,165.7226 
		147.0506,161.1594 147.012,161.1275 147.5226,160.5044 147.709,160.1316 147.8685,159.7973 148.0953,159.1709 148.1356,158.8115 
		148.1289,158.4555 148.065,157.8038 148.0415,156.8247 148.0818,156.5308 148.1792,156.3361 148.1302,156.2359 148.7644,155.6217 
		149.5485,154.9047 150.3851,154.522 152.1795,155.2744 153.7423,154.6377 154.379,152.5539 159.5307,151.8014 159.878,150.7017 
		156.7523,146.0131 162.0197,144.9712 	'
            />
            <polygon
              id='BE11'
              className={getColor('BE11') + ' st13'}
              fill={'url(#' + getColor('BE11') + ')'}
              points='255.4496,161.026 251.1019,158.7443 239.9391,139.3398 256.9281,123.6481 
		260.5454,126.5402 261.8255,156.9454 	'
            />
            <polygon
              id='BE10'
              className={getColor('BE10') + ' st13'}
              fill={'url(#' + getColor('BE10') + ')'}
              points='299.6214,250.4746 299.6214,250.4746 298.1237,247.3673 293.985,238.7504 
		283.0016,215.7083 273.7161,205.5682 267.7004,210.8762 265.4036,221.8615 270.56,246.199 271.1628,245.3268 271.188,245.0396 
		271.7708,244.6063 272.2763,244.6483 274.1355,243.659 275.3078,243.9076 276.0216,243.7984 276.433,243.9143 276.5624,244.225 
		277.6255,244.8045 279.0614,245.0026 280.0356,245.8424 280.1968,245.4846 281.2397,245.3536 281.878,245.0396 282.3314,245.3839 
		283.0973,245.7517 284.1805,245.7953 284.4946,246.185 285.0858,246.3949 285.6198,246.3647 286.8106,246.6888 287.2892,247.3136 
		287.9174,247.7687 288.3423,248.4086 289.0317,248.5932 289.0317,248.5932 291.4641,249.3994 291.4644,249.3995 292.1698,249.4617 
		292.6619,249.4751 293.1557,249.3139 293.9014,249.4348 294.6135,249.4449 294.6622,249.7287 294.5026,250.1939 294.6471,250.8103 
		295.2383,251.0656 295.4633,251.4602 295.9554,251.4082 296.8623,250.9144 297.954,250.7129 298.6342,250.8623 	'
            />
            <polygon
              id='BE09'
              className={getColor('BE09') + ' st13'}
              fill={'url(#' + getColor('BE09') + ')'}
              points='232.2316,263.2458 237.9457,270.0532 239.0058,269.4274 239.2694,269.0444 
		240.603,268.2064 240.8398,267.81 241.4041,267.5967 242.0372,266.9333 242.3379,266.8712 242.8367,266.4715 243.6462,266.2128 
		243.8931,265.5847 244.4674,265.1816 244.8705,264.5652 245.5675,264.2075 244.8705,264.5652 244.3482,261.7107 244.1571,260.2775 
		243.4001,246.4933 243.4003,245.217 223.548,223.8379 218.717,224.804 210.8031,234.3709 	'
            />
            <polygon
              id='BE08'
              className={getColor('BE08') + ' st13'}
              fill={'url(#' + getColor('BE08') + ')'}
              points='243.4003,245.217 223.548,223.8379 240.6465,199.0871 241.8001,199.5565 
		244.6823,240.7816 	'
            />
            <polygon
              id='BE07'
              className={getColor('BE07') + ' st13'}
              fill={'url(#' + getColor('BE07') + ')'}
              points='228.9752,168.4995 214.6765,168.3045 213.9562,166.7451 210.6993,143.4478 
		224.99,130.7227 231.7095,134.1366 233.7834,137.3108 	'
            />
            <polygon
              id='BE06'
              className={getColor('BE06') + ' st13'}
              fill={'url(#' + getColor('BE06') + ')'}
              points='190.639,152.9603 183.3516,142.1495 183.5269,130.9161 183.5523,130.9055 
		184.7679,128.2429 188.646,128.5323 189.0512,126.5643 188.2409,123.6701 187.8357,123.728 187.3147,121.8178 187.3687,121.7998 
		203.3585,140.6792 	'
            />
            <polygon
              id='BE05'
              className={getColor('BE05') + ' st13'}
              fill={'url(#' + getColor('BE05') + ')'}
              points='207.2904,235.1448 
		195.4487,222.8337 195.4506,215.197 201.5597,194.5853 209.5271,190.2832 215.6694,196.7275 218.717,224.804 210.8031,234.3709 	
		'
            />
            <polygon
              id='BE04'
              className={getColor('BE04') + ' st13'}
              fill={'url(#' + getColor('BE04') + ')'}
              points='183.5269,130.9161 183.3516,142.1495 167.0706,149.6855 162.5494,142.6404 
		162.5985,142.4243 164.9717,141.2667 165.5506,135.4783 170.1233,136.8675 170.6443,136.7518 174.754,130.4425 175.3907,130.2688 
		177.3009,130.5582 179.4426,132.4105 180.7739,132.0632 	'
            />
            <polygon
              id='BE03'
              className={getColor('BE03') + ' st13'}
              fill={'url(#' + getColor('BE03') + ')'}
              points='201.5597,194.5853 185.6965,174.1897 189.4137,165.601 213.9562,166.7451 
		214.6765,168.3045 209.5271,190.2832 	'
            />
            <polygon
              id='BE02'
              className={getColor('BE02') + ' st13'}
              fill={'url(#' + getColor('BE02') + ')'}
              points='210.8031,234.3709 207.2904,235.1448 199.0895,275.512 197.0422,278.112 
		198.4076,278.0263 199.1701,277.1967 199.7411,276.9968 200.4129,277.6115 202.2267,277.8684 202.4988,278.0969 202.4182,278.4244 
		202.8532,278.856 203.0698,278.5251 203.8693,278.4832 204.2841,277.9406 204.3412,277.4687 205.0835,277.1648 205.6176,277.86 
		205.9098,279.1398 205.8192,279.5664 206.0543,279.8821 206.491,279.9577 207.0368,279.6571 207.6615,280.0367 208.0445,279.9359 
		208.6844,278.9265 211.1431,279.1768 212.7134,278.6225 213.0023,277.4385 214.9001,276.4661 213.79,275.5239 213.009,275.3711 
		211.5358,274.3794 211.4471,274.3197 212.0416,273.1407 212.1306,272.5881 212.8696,272.2136 214.094,272.1649 214.8161,271.8744 
		215.4728,271.8811 215.797,272.086 215.8709,272.0171 216.2168,271.7383 217.0499,271.6308 217.6998,271.2177 218.5194,271.179 
		218.8956,271.829 219.9016,272.2707 220.2577,271.8542 220.6624,271.5233 220.6356,271.3101 220.4458,270.3981 220.6389,270.116 
		221.042,270.1882 221.4753,269.8439 221.9674,269.0612 221.7826,268.3911 221.7944,267.9511 221.8918,267.538 222.9012,267.3112 
		223.3009,267.2188 223.6082,266.9249 223.6889,266.4446 224.0113,265.9794 225.3683,266.8846 228.7676,268.1241 230.2881,268.8361 
		232.2206,269.7901 232.6607,269.7515 232.2206,269.7901 232.2203,269.79 232.2206,269.7901 232.6607,269.7515 233.3661,270.6702 
		233.9001,271.0044 234.2226,271.3756 234.2226,271.3756 235.1665,271.7635 234.2226,271.3756 234.2226,271.3756 234.6844,271.7618 
		235.1665,271.7635 235.5746,271.5855 236.1792,270.7105 236.6713,270.3779 237.6319,270.2704 238.1068,269.9581 238.1067,269.9581 
		237.6319,270.2704 236.6713,270.3779 237.6319,270.2704 238.1068,269.9581 238.1067,269.9581 237.9457,270.0532 	'
            />
            <polygon
              id='BE01'
              className={getColor('BE01') + ' st13'}
              fill={'url(#' + getColor('BE01') + ')'}
              points='180.561,176.2744 169.3545,164.8373 167.0706,149.6855 183.3516,142.1495 
		190.639,152.9603 189.4137,165.601 185.6965,174.1897 	'
            />
            <polygon
              id='AR02'
              className={getColor('AR02') + ' st13'}
              fill={'url(#' + getColor('AR02') + ')'}
              points='451.4106,90.5092 451.1541,90.312 451.0658,90.2281 451.0624,90.2082 450.29,90.3413 
		450.1169,90.3711 450.1203,90.391 449.0034,89.5714 449.0219,89.5634 448.8344,89.128 449.0202,89.0625 448.6608,88.8425 
		448.429,88.8274 448.1822,88.6561 447.8748,88.5234 447.7237,88.3236 447.5137,88.4294 447.3407,88.7233 447.2349,88.8307 
		446.9948,88.7636 446.9948,88.7636 446.847,88.8425 446.7412,88.8828 446.6874,88.7636 446.7126,88.51 445.9535,88.3639 
		445.7671,88.2698 445.7419,88.1103 445.8477,87.8566 445.8326,87.6702 445.9014,87.5107 445.9149,87.3242 445.8074,87.2302 
		445.6344,87.2705 445.5168,87.1496 445.1205,87.2403 445.1406,87.5107 444.9861,87.6685 444.7678,87.6434 444.7678,87.6433 
		444.5192,87.4972 444.101,87.551 443.9029,87.6299 443.9028,87.6299 443.5552,87.5375 443.3419,87.4972 443.142,87.5896 
		443.0345,87.776 442.9153,87.7895 442.7289,87.6971 442.1814,87.9104 442.1814,87.9104 442.1814,87.9104 442.1814,87.9104 
		442.2754,88.1103 442.5156,88.1103 442.6483,88.1909 442.8347,88.4965 443.2747,88.7636 443.2881,88.9366 443.3687,89.1095 
		443.3419,89.4438 443.3956,89.6033 443.3956,89.736 443.0749,89.9224 443.0883,90.0971 443.2881,90.2298 443.2478,90.4834 
		443.3956,90.6564 443.488,90.9234 443.661,90.9771 443.7148,91.0695 443.5821,91.271 443.5686,91.3768 443.6677,91.565 
		443.7819,91.6959 443.8608,92.0167 444.0439,92.1343 444.2449,92.4442 444.1378,92.4897 444.1129,92.5004 444.0609,92.5225 
		443.0408,92.9569 442.5107,93.138 442.5074,93.1395 441.5233,93.6904 441.5132,93.702 441.4962,94.0782 441.875,95.0414 
		441.528,95.0919 441.5212,95.0729 440.9821,95.266 440.9759,95.2697 440.9406,95.2997 440.6353,95.5599 440.3442,95.7828 
		440.2914,95.8232 440.1497,96.2528 439.7534,84.9105 453.9696,78.1618 458.8094,85.7194 461.4301,89.6276 461.1628,89.9795 
		461.4181,90.2046 461.1797,91.0577 461.3104,91.2781 461.1654,91.4174 461.4534,91.565 461.3055,91.7354 461.6504,92.8027 
		461.7347,94.1025 459.7587,93.5932 458.751,94.1894 457.0532,94.3059 454.2669,92.4855 454.0855,92.7238 453.7379,92.4551 
		453.4776,92.6129 453.0185,91.5767 452.7538,91.4002 452.5847,91.2049 452.4771,90.9393 452.3017,90.7485 452.3674,90.0433 
		452.3494,90.0299 451.4135,90.5304 	'
            />
            <polygon
              id='AR01'
              className={getColor('AR01') + ' st13'}
              fill={'url(#' + getColor('AR01') + ')'}
              points='437.9513,105.2483 437.9653,105.2307 437.9456,105.1965 438.0027,104.9835 
		438.0027,104.9835 437.9472,104.9353 437.9424,104.8933 437.85,104.6145 437.902,104.188 438.0498,103.894 438.1556,103.454 
		438.3001,103.187 438.3891,103.1131 438.1153,102.3976 438.5285,101.7577 438.1725,101.1044 438.1288,100.6812 438.3303,100.5183 
		437.9826,99.697 437.8584,99.6534 437.5964,99.7054 437.3562,99.6836 437.3847,99.3007 437.5695,98.8556 439.7663,97.7287 
		440.1523,96.3252 439.7534,84.9105 435.2672,72.7083 429.1651,71.5505 424.5129,100.9904 434.4759,117.7308 434.6345,117.5327 
		444.6514,114.0069 443.7456,113.7168 442.8414,113.7425 442,113.1849 440.7091,110.4261 440.522,109.05 439.1684,106.6669 
		439.1384,106.666 438.7709,106.3165 438.675,106.1383 438.586,105.9727 438.5897,105.9787 438.485,105.6025 438.3289,105.5473 
		438.1939,105.5046 438.0882,105.4711 	'
            />
            <polygon
              id='AI01'
              className={getColor('AI01') + ' st13'}
              fill={'url(#' + getColor('AI01') + ')'}
              points='452.2868,90.7621 452.3017,90.7485 452.4771,90.9393 452.4979,90.9907 452.5847,91.2049 
		452.7538,91.4002 453.0185,91.5767 453.0073,91.5935 453.4675,92.591 453.7379,92.4551 454.0855,92.7238 454.0704,92.7105 
		454.2669,92.4855 454.282,92.4988 457.0532,94.3059 458.7612,94.2068 458.751,94.1894 459.7587,93.5932 459.7689,93.6106 
		461.7394,94.083 461.7726,94.0909 461.7893,95.9669 461.7829,96.2454 461.7829,96.2477 461.7423,96.2581 461.7171,97.3532 
		461.4906,97.4184 461.5119,97.457 461.6466,97.6598 461.6296,97.6489 461.46,97.9126 461.4597,97.913 461.4573,97.917 
		461.3108,99.4549 460.5872,100.5746 460.6079,100.5792 460.6154,100.5809 460.684,100.767 461.0794,101.8398 460.6115,102.0993 
		460.6186,102.1188 460.2248,102.5811 460.2893,103.0938 460.2872,103.104 460.3097,103.0946 460.1384,103.9209 459.9649,104.6556 
		460.1246,105.1621 459.8606,105.8288 459.8492,105.8581 459.7771,106.0436 459.7153,106.092 459.6901,106.0868 459.2933,106.4187 
		459.0422,106.6816 458.6806,107.3119 458.6155,107.5057 458.5461,107.712 458.3755,108.04 457.8729,108.4992 457.7757,108.588 
		457.6172,108.7328 457.3324,109.1594 457.2687,109.2548 457.0226,109.5642 457.0316,109.65 456.8922,109.8252 456.5835,109.962 
		456.4535,110.0196 455.7285,110.5343 455.6798,110.5909 454.9918,111.3901 454.245,111.9604 453.9749,112.3708 453.3604,112.4593 
		452.5466,113.0475 452.3324,113.1339 452.0742,113.1002 452.0251,113.0937 451.6133,113.0398 451.0742,113.2493 450.5156,113.8689 
		449.7509,114.717 449.547,114.9432 449.4127,114.9574 449.4044,114.9582 448.7855,115.0235 448.1682,115.1799 447.05,115.651 
		446.9703,115.6846 446.9359,115.6781 445.4275,114.5896 444.7513,114.087 444.6635,114.0218 444.6604,114.0208 444.6433,113.9945 
		443.7456,113.7168 442.8414,113.7425 441.9807,113.1909 441.8938,112.9118 440.9397,110.9099 440.7091,110.4261 440.712,110.4303 
		440.659,110.082 440.5027,109.0568 439.1523,106.6794 438.7709,106.3165 438.675,106.1383 438.586,105.9727 438.5897,105.9787 
		438.485,105.6025 438.0882,105.471 437.9513,105.2483 438.0027,104.9835 437.9472,104.9353 437.85,104.6145 437.902,104.188 
		438.0498,103.894 438.1556,103.454 438.3001,103.187 438.3891,103.1131 438.1153,102.3976 438.5285,101.7577 438.1725,101.1044 
		438.1288,100.6812 438.3303,100.5183 437.9826,99.697 437.8584,99.6534 437.5964,99.7054 437.3562,99.6836 437.3847,99.3007 
		437.5696,98.8556 439.7661,97.7288 440.3037,95.8392 440.9406,95.2997 441.528,95.0919 441.8975,95.0381 441.5163,94.0791 
		441.5132,93.702 442.5107,93.138 444.2589,92.4601 444.0442,92.1347 443.8608,92.0167 443.7819,91.6959 443.6677,91.565 
		443.5686,91.3768 443.5821,91.271 443.7148,91.0695 443.661,90.9771 443.488,90.9234 443.3956,90.6564 443.2478,90.4834 
		443.2881,90.2298 443.0883,90.0971 443.0749,89.9224 443.3956,89.736 443.3956,89.6033 443.3419,89.4438 443.3687,89.1095 
		443.2881,88.9366 443.2747,88.7636 442.8347,88.4965 442.6483,88.1909 442.5156,88.1103 442.2754,88.1103 442.1814,87.9104 
		442.7289,87.6971 442.9153,87.7895 443.0345,87.776 443.142,87.5896 443.3419,87.4972 443.9028,87.6299 444.101,87.551 
		444.5192,87.4972 444.7678,87.6434 444.9861,87.6685 445.1406,87.5107 445.1205,87.2403 445.5168,87.1496 445.6344,87.2705 
		445.8074,87.2302 445.9149,87.3242 445.9014,87.5107 445.8326,87.6702 445.8477,87.8566 445.7419,88.1103 445.7671,88.2698 
		445.9535,88.3639 446.7126,88.51 446.6874,88.7636 446.7412,88.8828 446.9948,88.7636 447.2349,88.8307 447.3407,88.7233 
		447.5137,88.4294 447.7237,88.3236 447.8748,88.5234 448.1822,88.6561 448.429,88.8274 448.6608,88.8425 449.0202,89.0625 
		448.8153,89.1347 449.0219,89.5634 450.1169,90.3711 451.0624,90.2082 451.4135,90.5304 452.3583,90.0254 452.3674,90.0433 	'
            />
            <polygon
              id='AG11'
              className={getColor('AG11') + ' st13'}
              fill={'url(#' + getColor('AG11') + ')'}
              points='260.5454,126.5402 256.9281,123.6481 252.8336,111.5132 267.7985,94.9196 
		275.097,105.4016 277.4679,113.0998 273.5338,121.2221 	'
            />
            <polygon
              id='AG10'
              className={getColor('AG10') + ' st13'}
              fill={'url(#' + getColor('AG10') + ')'}
              points='289.5606,50.8278 289.6372,50.8156 289.6674,50.8089 289.7917,50.7837 289.8689,50.7686 
		289.9479,50.7619 289.9999,50.7585 290.0251,50.7619 290.0503,50.7652 290.1528,50.7904 290.3325,50.829 290.3532,50.834 
		290.8833,51.0776 290.9707,51.0886 290.9875,51.0944 291.0379,51.1095 291.0883,51.1213 291.1403,51.128 291.1655,51.1297 
		291.2176,51.128 291.2696,51.1213 291.3486,51.1062 291.4258,51.0877 291.4745,51.0743 291.5266,51.0591 291.5719,51.039 
		291.5988,51.0239 291.6408,51.0004 291.6828,50.9668 291.7248,50.9315 291.8575,50.8072 291.9784,50.7048 292.017,50.6712 
		292.0556,50.6343 292.0909,50.5939 292.1379,50.5335 292.1816,50.4696 292.237,50.3823 292.2924,50.29 292.3193,50.2446 
		292.3428,50.1976 292.4285,50.0078 292.4554,49.9608 292.4822,49.9154 292.5259,49.8533 292.6065,49.7475 292.6458,49.6928 
		292.8775,49.4871 292.9357,49.462 293.1053,49.3931 293.2044,49.3578 293.3791,49.3007 293.6797,49.2067 293.7032,49.1983 
		293.7805,49.1764 293.8292,49.1596 293.8527,49.1462 293.8762,49.1328 293.9165,49.1042 293.9551,49.069 293.9954,49.0354 
		294.0122,49.0169 294.071,48.9598 294.1432,48.8842 294.1785,48.8439 294.2121,48.8036 294.2255,48.7818 294.2407,48.7616 
		294.2793,48.6928 294.375,48.5063 294.469,48.3182 294.5715,48.1083 294.6252,47.9874 294.6672,47.89 294.7006,47.8096 
		295.0938,47.0116 295.3455,46.6791 295.5005,46.5322 295.7354,46.3314 295.8757,46.2243 295.9167,46.2038 295.9873,46.1702 
		296.1552,46.0929 296.2292,46.0644 296.303,46.0358 296.3786,46.014 296.4273,46.0022 296.5063,45.9888 296.5566,45.9821 
		296.6372,45.9737 296.7145,45.9669 296.7935,45.9636 296.8707,45.9653 296.9244,45.9636 297.0034,45.972 297.0555,45.9804 
		297.1327,45.9905 297.21,46.0056 297.2872,46.019 297.3645,46.0358 297.4434,46.0576 297.4904,46.0711 297.5627,46.0963 
		297.6365,46.1215 297.7155,46.1483 297.786,46.1769 297.8599,46.2071 297.9305,46.2407 298.001,46.2777 298.0464,46.3028 
		298.09,46.3297 298.1337,46.3583 298.2177,46.4221 298.2798,46.4725 298.3806,46.5564 298.4192,46.59 298.4578,46.6287 
		298.4914,46.6673 298.5082,46.6874 298.5367,46.7294 298.5518,46.753 298.5754,46.7983 298.6039,46.8705 298.6392,46.9729 
		298.6476,46.9965 298.6711,47.0721 298.6913,47.1476 298.7299,47.2988 298.7501,47.376 298.7752,47.4499 298.8374,47.6246 
		298.8592,47.6985 298.876,47.7758 298.8844,47.8261 298.8928,47.9034 298.9012,48.0327 298.9045,48.0882 298.9113,48.1402 
		298.9281,48.2426 298.9465,48.3468 298.9617,48.4224 298.9885,48.5248 299.0087,48.5869 299.0222,48.6239 299.0574,48.6928 
		299.096,48.7633 299.1263,48.807 299.1414,48.8288 299.1599,48.8489 299.18,48.8641 299.1985,48.8825 299.222,48.8943 
		299.2438,48.906 299.2707,48.9128 299.2959,48.9178 299.3513,48.9245 299.4034,48.9262 299.4286,48.9245 299.4806,48.9212 
		299.5075,48.9128 299.5579,48.906 299.6083,48.8909 299.6318,48.8775 299.657,48.8641 299.6805,48.8523 299.699,48.8355 
		299.7191,48.8154 299.7359,48.8002 299.7695,48.7599 299.8031,48.7196 299.8652,48.6357 299.9744,48.4862 300.0365,48.4022 
		300.1188,48.2998 300.3053,48.0781 300.3825,47.9739 300.4144,47.9336 300.443,47.8883 300.4548,47.867 300.8218,47.4621 
		300.8376,47.46 300.8897,47.46 301.0056,47.4483 301.0829,47.4785 301.1702,47.5289 301.2475,47.5322 301.3012,47.5322 
		301.3516,47.5322 301.4053,47.5306 301.4574,47.5255 301.5615,47.5121 301.6891,47.4869 301.7681,47.4701 301.8185,47.4583 
		301.8672,47.4432 301.9411,47.4147 302.0385,47.3744 302.2534,47.2786 302.5659,47.1443 302.6632,47.1057 302.7372,47.0788 
		302.7875,47.0637 302.8396,47.0536 303.1486,46.9998 303.278,46.983 303.3317,46.9797 303.3586,46.9797 303.3837,46.983 
		303.4358,46.9881 303.461,46.9965 303.4879,47.0082 303.5097,47.02 303.5282,47.0351 303.5483,47.0569 303.5618,47.0737 
		303.5786,47.0973 303.6038,47.1426 303.6306,47.1896 303.6525,47.2366 303.681,47.3038 303.7583,47.5037 303.8389,47.6985 
		303.8826,47.7942 303.9178,47.8614 303.933,47.8849 303.9648,47.9269 304.0018,47.9672 304.0219,47.9857 304.0623,48.0143 
		304.0858,48.026 304.111,48.0361 304.1362,48.0428 304.1882,48.0546 304.242,48.0596 304.2924,48.0562 304.3461,48.0529 
		304.3693,48.0506 304.3746,48.0512 304.3806,48.0495 304.4502,48.0428 304.5527,48.026 304.6551,48.0109 304.7845,47.9823 
		304.8617,47.9655 304.9625,47.9387 305.0397,47.9168 305.1136,47.8933 305.2127,47.8597 305.4327,47.7808 305.5677,47.7315 
		306.0407,47.6649 306.5479,47.7187 307.1794,47.8883 307.5369,48.0663 307.5539,48.0764 307.7957,48.2326 307.9162,48.3039 
		308.0007,48.3586 308.2339,48.6197 308.2391,48.6273 308.2677,48.6726 308.2828,48.6978 308.2929,48.7213 308.303,48.7465 
		308.3044,48.7514 308.3127,48.8148 308.313,48.8204 308.3097,48.8456 308.3063,48.8725 308.2794,49.0035 308.2727,49.0555 
		308.2627,49.2134 308.2526,49.2923 308.2459,49.3175 308.2358,49.3394 308.2291,49.3662 308.1854,49.4603 308.1132,49.8465 
		308.0813,50.0263 308.0426,50.258 308.0258,50.3622 308.0175,50.4411 308.0023,50.599 307.9973,50.6762 307.9956,50.7283 
		307.9956,50.7803 307.999,50.8324 308.004,50.8845 308.0107,50.9382 308.0275,51.0138 308.041,51.0642 308.0577,51.1162 
		308.0846,51.1868 308.1283,51.2842 308.2072,51.4505 308.2912,51.6419 308.3382,51.736 308.3634,51.7796 308.3903,51.8233 
		308.4171,51.8704 308.4642,51.9342 308.4944,51.9762 308.5465,52.0383 308.6305,52.134 308.6657,52.1727 308.7061,52.2062 
		308.7463,52.2432 308.8085,52.2902 308.8958,52.3507 308.9597,52.3927 309.0302,52.4346 309.0721,52.4615 309.1225,52.4817 
		309.1696,52.5018 309.2183,52.5203 309.2922,52.5472 309.5424,52.6244 309.6953,52.6664 309.7456,52.6815 309.7691,52.6933 
		309.8178,52.7185 309.8817,52.7588 309.9472,52.8041 310.0076,52.8545 310.0446,52.8898 310.0832,52.9267 310.2092,53.0611 
		310.2612,53.1182 310.3956,53.2442 310.4342,53.2794 310.4695,53.3181 310.4997,53.3584 310.5518,53.4205 310.5955,53.486 
		310.7231,53.6758 310.7668,53.748 310.8726,53.9294 310.9179,53.9966 310.9448,54.0385 310.9767,54.0805 311.0439,54.1612 
		311.1329,54.2552 311.2449,54.3662 311.4537,54.6247 311.5722,54.7063 311.5897,54.7238 311.6519,54.7742 311.6938,54.8044 
		311.7593,54.8464 311.8517,54.9001 311.9424,54.9505 312.0364,54.9958 312.1322,55.0395 312.2531,55.0882 312.3522,55.1235 
		312.453,55.1537 312.5285,55.1722 312.6075,55.1856 312.6847,55.1974 313.0257,55.2243 313.155,55.2327 313.2591,55.2394 
		313.3397,55.2411 313.3716,55.2411 313.6672,55.2427 313.8285,55.2327 313.9074,55.2243 313.9847,55.2125 314.1408,55.1856 
		314.2164,55.1756 314.297,55.1705 314.3995,55.1705 314.6363,55.1722 314.8177,55.1823 315.1065,55.2008 315.518,55.231 
		315.6809,55.2444 315.7812,55.2501 316.4787,55.3687 316.5706,55.3912 316.6718,55.4292 316.8213,55.4745 316.8986,55.4947 
		316.9489,55.5081 316.9977,55.5148 317.1051,55.5232 317.3889,55.5719 317.4931,55.5854 317.5972,55.5954 317.8324,55.6156 
		317.9861,55.6272 318.5042,55.7567 318.8327,55.9257 318.9643,56.0254 319.1373,56.0825 319.1625,56.0892 319.1894,56.0909 
		319.2162,56.0926 319.2415,56.0875 319.265,56.0808 319.2901,56.0674 319.312,56.0539 319.3355,56.0405 319.3519,56.0304 
		320.5258,58.6213 307.1278,77.7505 	'
            />
            <polygon
              id='AG09'
              className={getColor('AG09') + ' st13'}
              fill={'url(#' + getColor('AG09') + ')'}
              points='327.0876,94.9459 305.1442,85.1638 307.1278,77.7505 320.5258,58.6213 322.4114,59.7397 
		329.9768,78.4515 	'
            />
            <polygon
              id='AG08'
              className={getColor('AG08') + ' st13'}
              fill={'url(#' + getColor('AG08') + ')'}
              points='241.7404,59.3861 242.0987,59.1695 242.0994,59.1694 242.18,59.1593 242.3362,59.1492 
		242.4135,59.1425 242.9055,59.0753 243.0617,59.0552 243.27,59.0216 243.3204,59.0149 243.3691,58.9981 243.3959,58.988 
		243.4161,58.9779 243.4396,58.9662 243.5303,58.9074 243.621,58.8587 243.6932,58.8217 243.7386,58.8016 243.7654,58.7898 
		243.7906,58.7864 243.8158,58.7797 243.9182,58.7629 243.9989,58.7545 244.0241,58.7495 244.0493,58.7411 244.0711,58.731 
		244.0912,58.7159 244.1097,58.6991 244.1483,58.6588 244.1668,58.6387 244.2038,58.6051 244.328,58.5043 244.3885,58.4573 
		244.4087,58.4405 244.4322,58.4254 244.454,58.4136 244.5027,58.3951 244.6992,58.3212 244.7983,58.2793 244.8688,58.2457 
		244.9209,58.2238 244.9427,58.2121 244.9646,58.1986 244.9847,58.1801 244.9998,58.1617 245.0133,58.1415 245.025,58.1163 
		245.0653,58.0173 245.0905,57.9702 245.1795,57.7821 245.2854,57.5722 245.3307,57.4781 245.3508,57.4278 245.3828,57.3287 
		245.3912,57.3035 245.3996,57.2766 245.4147,57.2548 245.4264,57.2346 245.4466,57.2161 245.4818,57.1809 245.5608,57.1087 
		245.5977,57.07 245.633,57.0314 245.7153,56.9289 245.7506,56.8886 245.8077,56.8366 245.8665,56.7896 245.9521,56.7241 
		246.0579,56.6485 246.1251,56.6065 246.2847,56.5091 246.4123,56.4234 246.4996,56.3647 246.5634,56.3193 246.6273,56.2706 
		246.6659,56.237 246.7012,56.2 246.7398,56.1631 246.7734,56.1245 246.8036,56.0808 246.817,56.059 246.8557,55.9884 
		246.8977,55.8944 246.9229,55.8474 247.0035,55.7113 247.027,55.6626 247.0354,55.6408 247.0522,55.5921 247.0673,55.54 
		247.0891,55.4393 247.1529,55.1285 247.1781,55.0009 247.1966,54.8733 247.2033,54.7943 247.2235,54.5323 247.2319,54.4551 
		247.2436,54.3778 247.2688,54.2485 247.2974,54.1209 247.336,53.9697 247.3679,53.8421 247.4099,53.7178 247.4519,53.5935 
		247.5695,53.2744 247.6584,53.0292 247.7072,52.9083 247.7626,52.7857 247.7895,52.7386 247.8029,52.7168 247.8331,52.6748 
		247.8486,52.658 247.9377,52.6096 247.9389,52.6093 248.0179,52.5875 248.1405,52.5438 248.1892,52.527 248.2144,52.5203 
		248.2933,52.5052 248.347,52.4968 248.3991,52.4918 248.4512,52.4918 248.4781,52.4934 248.5284,52.5002 248.5805,52.5119 
		248.6544,52.5304 248.7081,52.5421 248.9668,52.5808 249.2254,52.6244 249.325,52.646 249.4971,52.6999 249.5496,52.7201 
		249.5999,52.742 249.6167,52.7504 249.6688,52.7739 249.6912,52.7847 249.8141,52.8776 249.8183,52.8831 249.8334,52.9016 
		249.8603,52.9469 249.9117,53.0509 249.9845,53.224 250.0251,53.2577 250.0467,53.2945 250.0954,53.3567 250.1307,53.397 
		250.1676,53.4339 250.2197,53.4743 250.2516,53.4927 250.302,53.5129 250.4279,53.5481 250.48,53.5616 250.5321,53.5733 
		250.6076,53.5801 250.6597,53.5834 250.7088,53.5834 250.9284,53.6103 251.2285,53.5526 251.2609,53.5515 251.313,53.5465 
		251.3399,53.5414 251.3903,53.5314 251.4423,53.5196 251.5397,53.4894 251.7178,53.4339 251.79,53.4071 251.8387,53.3869 
		251.9126,53.355 251.958,53.3332 252.0033,53.3097 252.1192,53.2442 252.1645,53.2173 252.2351,53.182 252.403,53.1064 
		252.4483,53.0846 252.4937,53.0594 252.5155,53.0443 252.5592,53.0141 252.6214,52.967 252.7204,52.8797 252.8531,52.7521 
		252.8934,52.7185 252.9321,52.6849 252.974,52.6547 252.9975,52.6412 253.0429,52.616 253.1151,52.5808 253.2344,52.5321 
		253.2847,52.5136 253.3351,52.4985 253.4107,52.4766 253.5131,52.4582 253.7735,52.4178 254.0304,52.3775 254.1597,52.3591 
		254.2908,52.3507 254.4486,52.3456 254.6048,52.344 254.8416,52.3456 254.8937,52.354 255.0482,52.3775 255.1019,52.3843 
		255.1792,52.3893 255.2313,52.3876 255.2816,52.3843 255.3354,52.3792 255.4378,52.3641 255.6406,52.3305 255.8762,52.3171 
		256.5043,52.3507 256.8755,52.4649 257.2365,52.6782 257.8529,53.1988 257.9488,53.2908 257.9839,53.3348 258.1166,53.4978 
		258.1519,53.5381 258.1888,53.5733 258.2274,53.6103 258.2694,53.6388 258.4106,53.7335 258.4223,53.7446 258.7296,54.1578 
		259.2755,55.3435 259.4485,55.797 259.5072,56.1698 259.4753,56.4772 259.3292,56.8366 259.1293,57.1708 258.995,57.5302 
		258.995,57.9971 259.0756,58.4102 259.1428,58.6639 259.3695,59.0619 259.6617,59.3692 259.6965,59.3974 259.8163,59.5355 
		259.87,59.5943 259.9422,59.6682 260.0195,59.7387 260.0799,59.7908 260.1219,59.8227 260.1656,59.8513 260.2109,59.8798 
		260.2781,59.9168 260.3251,59.9403 260.3973,59.9722 260.446,59.9906 260.4981,60.0058 260.5485,60.0142 260.6006,60.0209 
		260.7299,60.0343 260.782,60.0393 260.8609,60.0545 261.0154,60.083 261.0927,60.0981 261.2757,60.1216 261.3799,60.1284 
		261.4571,60.13 261.5377,60.125 261.6116,60.1132 261.7695,60.0914 261.9257,60.0729 262.0029,60.0645 262.055,60.0612 
		262.0802,60.0612 262.1071,60.0645 262.1591,60.0679 262.2364,60.0796 262.2901,60.0914 262.3388,60.1032 262.3875,60.12 
		262.485,60.1603 262.7553,60.2527 262.8401,60.2973 261.9115,65.2751 245.5701,67.9153 	'
            />
            <polygon
              id='AG07'
              className={getColor('AG07') + ' st13'}
              fill={'url(#' + getColor('AG07') + ')'}
              points='320.9588,135.0869 307.9731,129.3485 306.5138,109.8466 327.4278,99.2471 
		332.6496,110.4389 322.5036,134.4647 	'
            />
            <polygon
              id='AG06'
              className={getColor('AG06') + ' st13'}
              fill={'url(#' + getColor('AG06') + ')'}
              points='299.0962,137.9588 283.4413,112.7249 299.253,94.756 306.5138,109.8466 307.9731,129.3485 
			'
            />
            <polygon
              id='AG05'
              className={getColor('AG05') + ' st13'}
              fill={'url(#' + getColor('AG05') + ')'}
              points='277.4679,113.0998 275.097,105.4016 285.8819,77.9325 299.2569,94.3484 299.253,94.756 
		283.4413,112.7249 	'
            />
            <polygon
              id='AG04'
              className={getColor('AG04') + ' st13'}
              fill={'url(#' + getColor('AG04') + ')'}
              points='262.8465,60.2947 262.9596,60.3495 263.1858,60.4591 263.2237,60.5144 263.2613,60.5141 
		263.3369,60.5692 263.3745,60.5689 263.412,60.5687 263.4872,60.5682 263.6379,60.6227 263.6755,60.6225 263.7131,60.6223 
		263.7883,60.6218 263.8258,60.6215 263.8634,60.6213 263.901,60.6211 263.9386,60.6208 263.9762,60.6206 264.0134,60.5648 
		264.051,60.5646 264.0886,60.5643 264.1258,60.5086 264.1631,60.4528 264.2379,60.3968 264.3127,60.3408 264.3499,60.285 
		264.3496,60.2296 264.3868,60.1738 264.424,60.118 264.4612,60.0623 264.4981,59.951 264.5349,59.8397 264.609,59.6727 
		264.6079,59.5062 264.6448,59.3949 264.6817,59.2836 264.6813,59.2281 264.6806,59.1171 264.7171,58.9503 264.716,58.7837 
		264.7532,58.728 264.7528,58.6725 264.7901,58.6167 264.7897,58.5612 264.8269,58.5054 264.8645,58.5052 264.9017,58.4494 
		264.9385,58.3382 265.0133,58.2822 265.0506,58.2264 265.0881,58.2261 265.1629,58.1702 265.2001,58.1144 265.2377,58.1141 
		265.2749,58.0584 265.3125,58.0581 265.3501,58.0579 265.3873,58.0021 265.4625,58.0016 265.5376,58.0011 265.5748,57.9454 
		265.65,57.9449 265.6875,57.9446 265.8003,57.9439 265.8379,57.9436 265.8755,57.9434 265.9886,57.9981 266.0641,58.0531 
		266.1392,58.0526 266.3279,58.1624 266.403,58.1619 266.6292,58.2714 266.7423,58.3262 266.7799,58.3259 266.8175,58.3257 
		266.9682,58.3802 267.0434,58.3797 267.1561,58.3789 267.3068,58.4334 267.4195,58.4326 267.5323,58.4318 267.6454,58.4866 
		267.7205,58.4861 267.8333,58.4853 267.9836,58.4843 268.0963,58.4835 268.1715,58.483 268.2467,58.4825 268.4721,58.4809 
		268.5848,58.4801 268.6976,58.4793 268.7352,58.4791 268.7728,58.4788 268.8103,58.4786 268.8479,58.4783 268.9227,58.4223 
		268.9979,58.4218 269.5984,58.3065 269.6735,58.306 269.7487,58.3055 270.1241,58.2473 270.1992,58.2467 270.312,58.246 
		270.5374,58.2444 270.6126,58.2438 270.6877,58.2433 270.7629,58.2427 270.8756,58.242 270.9136,58.2972 270.9512,58.2969 
		270.9887,58.2966 271.1015,58.2958 271.2146,58.3505 271.5161,58.4594 271.6288,58.4586 271.6668,58.5138 271.7043,58.5135 
		271.7799,58.5685 271.8175,58.5683 271.8555,58.6235 271.9315,58.734 271.969,58.7337 272.1206,58.8991 272.2337,58.9538 
		272.3469,59.0085 272.4229,59.119 272.498,59.1185 272.5736,59.1734 272.6487,59.1728 272.7619,59.2275 272.7995,59.2273 
		272.8375,59.2825 272.8751,59.2822 272.9126,59.282 273.0254,59.2811 273.101,59.3361 273.1385,59.3358 273.1761,59.3355 
		273.2513,59.335 273.4016,59.3338 273.5895,59.3325 273.6271,59.3322 273.6647,59.3319 273.7019,59.2761 273.7394,59.2758 
		273.8518,59.2195 273.9641,59.1631 274.1888,59.0504 274.2264,59.0501 274.4142,59.0487 274.6393,58.9915 274.8272,58.9901 
		274.9396,58.9337 275.0899,58.9326 275.2398,58.8759 275.4277,58.8745 275.5776,58.8178 275.6152,58.8176 275.7275,58.7612 
		275.8402,58.7603 275.9525,58.704 275.9901,58.7037 276.1024,58.6473 276.2148,58.5909 276.2899,58.5903 276.5893,58.4215 
		276.664,58.3654 276.7016,58.3651 276.7387,58.3093 276.8135,58.2532 276.851,58.2529 276.9253,58.1413 276.9625,58.0855 
		277.0001,58.0852 277.0372,58.0294 277.1119,57.9733 277.1866,57.9172 277.2242,57.9169 277.3737,57.8047 277.4108,57.7489 
		277.4484,57.7486 277.4855,57.6928 277.6345,57.5251 277.7093,57.469 277.7464,57.4132 277.9334,57.3007 278.0081,57.2445 
		278.0453,57.1887 278.0828,57.1884 278.0824,57.1329 278.1195,57.0771 278.1938,56.9655 278.2309,56.9097 278.3056,56.8536 
		278.6067,56.9067 278.6442,56.9064 278.6818,56.9061 278.7194,56.9058 278.757,56.9055 278.7945,56.9052 278.9064,56.7933 
		279.0186,56.7369 279.1313,56.736 279.2061,56.6799 279.2436,56.6796 279.4691,56.6778 279.6949,56.7315 280.1494,57.1719 
		280.187,57.1716 280.263,57.282 280.3011,57.3372 280.3767,57.3922 280.4903,57.5023 280.5283,57.5575 280.6039,57.6124 
		280.6791,57.6118 280.7171,57.667 280.7927,57.7219 280.8303,57.7215 280.9435,57.7761 281.1323,57.8856 281.2079,57.9405 
		281.2455,57.9402 281.2831,57.9399 281.3211,57.9951 281.3586,57.9948 281.3962,57.9945 281.4338,57.9942 281.5085,57.9381 
		281.5836,57.9374 281.6217,57.9926 281.6968,57.992 281.772,57.9914 281.8467,57.9353 281.8843,57.935 281.9594,57.9343 
		282.0722,57.9334 282.1469,57.8773 282.1844,57.877 282.2596,57.8763 282.2967,57.8205 282.3343,57.8202 282.3719,57.8199 
		282.4837,57.7079 282.6706,57.5953 282.7453,57.5392 282.7829,57.5389 282.8576,57.4827 282.9323,57.4266 282.9694,57.3708 
		283.0441,57.3146 283.0811,57.2588 283.1558,57.2026 283.1929,57.1468 283.2301,57.091 283.2672,57.0352 283.3043,56.9793 
		283.3414,56.9235 283.3785,56.8677 283.4527,56.756 283.4893,56.6447 283.5265,56.5889 283.5255,56.4778 283.5621,56.3665 
		283.5992,56.3107 283.5983,56.1996 283.6349,56.0883 283.6706,55.8659 283.6697,55.7549 283.7058,55.5881 283.7054,55.5325 
		283.7045,55.4215 283.703,55.255 283.7016,55.0884 283.6997,54.8664 283.6993,54.8109 283.6988,54.7553 283.6984,54.6998 
		283.7354,54.644 283.7345,54.533 283.7716,54.4772 283.7711,54.4217 283.8082,54.3658 283.8448,54.2545 283.8819,54.1986 
		283.919,54.1428 283.9561,54.087 283.9927,53.9756 284.0298,53.9198 284.0669,53.864 284.104,53.8081 284.1786,53.752 
		284.2158,53.6962 284.2899,53.5845 284.5505,53.3047 284.588,53.3044 284.5876,53.2488 284.6251,53.2485 284.6998,53.1924 
		284.812,53.1359 284.8495,53.1356 284.8866,53.0797 284.9242,53.0794 284.9993,53.0788 285.112,53.0778 285.2993,53.0207 
		285.3744,53.02 285.412,53.0197 285.4495,53.0194 285.4871,53.0191 285.5622,53.0184 285.8251,53.0161 286.2388,53.068 
		286.427,53.1219 286.5022,53.1213 286.6148,53.1203 284.8517,75.3418 265.3156,81.3741 264.7459,80.6562 261.9004,65.297 	'
            />
            <polygon
              id='AG03'
              className={getColor('AG03') + ' st13'}
              fill={'url(#' + getColor('AG03') + ')'}
              points='286.6312,53.106 286.6478,53.1049 286.6846,53.1098 287.0879,53.049 287.1583,53.046 
		287.4471,53.0443 287.5764,53.0376 287.6806,53.0325 287.7595,53.0241 287.8116,53.0174 287.8653,53.0073 287.8905,53.0006 
		287.9157,52.9922 287.9392,52.9805 287.9594,52.9654 287.9795,52.9502 287.9946,52.9301 288.0114,52.9099 288.0719,52.8209 
		288.1391,52.7403 288.1727,52.6983 288.1878,52.6748 288.1996,52.653 288.2079,52.6295 288.2147,52.6043 288.2163,52.5791 
		288.2197,52.5505 288.2147,52.4985 288.2046,52.4464 288.1693,52.3204 288.1425,52.1928 288.1273,52.1155 288.1189,52.0635 
		288.1122,52.0114 288.1139,51.9845 288.1156,51.9577 288.124,51.9073 288.134,51.8569 288.1441,51.8317 288.1525,51.8048 
		288.1626,51.7813 288.1878,51.736 288.213,51.6906 288.2449,51.647 288.2633,51.6302 288.2802,51.6083 288.3003,51.5932 
		288.3221,51.5781 288.344,51.5664 288.3927,51.5429 288.4884,51.4975 288.6127,51.4538 288.6597,51.432 288.7067,51.4102 
		288.7504,51.3816 288.7924,51.3497 288.8713,51.2825 289.0662,51.1062 289.1266,51.0558 289.2475,50.9567 289.2929,50.9265 
		289.3349,50.8962 289.3802,50.8727 289.4054,50.8643 289.4306,50.8542 289.481,50.8442 289.5314,50.8324 289.5606,50.8278 
		307.1278,77.7505 305.1442,85.1638 299.2569,94.3484 285.8819,77.9325 284.8399,75.3176 	'
            />
            <polygon
              id='AG02'
              className={getColor('AG02') + ' st13'}
              fill={'url(#' + getColor('AG02') + ')'}
              points='306.5138,109.8466 299.253,94.756 299.2569,94.3484 305.1442,85.1638 327.0876,94.9459 
		327.4278,99.2471 	'
            />
            <polygon
              id='AG01'
              className={getColor('AG01') + ' st13'}
              fill={'url(#' + getColor('AG01') + ')'}
              points='275.097,105.4016 267.7985,94.9196 265.3284,81.3472 284.8399,75.3176 285.8819,77.9325 	
		'
            />
          </g>
        </StyledSVG>
      </MapContainer>
    </Swissmap>
  )
}
const Swissmap = styled.div`
  text-align: center;
  .btn {
    cursor: pointer;
  }
`

const MapContainer = styled.div`
  box-sizing: border-box;
  position: relative;
  margin: 0 auto;
  max-width: 900px;
  //laptops
  @media (max-height: 1400px) and (orientation: landscape) {
    max-width: 85vh;
  }
  @media (max-height: 1000px) and (orientation: landscape) {
    max-width: 70vh;
  }
  @media (max-width: 1024px) {
    max-width: 87%;
  }
`

const BaseMap = styled.div`
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  img {
    width: 100%;
  }
`

const StyledSVG = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  overflow: visible;

  .st0 {
    fill: none;
  }
  .st1 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #f4f4f4;
  }
  .st2 {
    fill: none;
    stroke: #a3a3a3;
    stroke-width: 1.4173;
    stroke-linecap: square;
    stroke-linejoin: bevel;
    stroke-miterlimit: 10;
  }
  .st3 {
    fill: none;
    stroke: #bfbfbf;
    stroke-width: 0.737;
    stroke-linecap: square;
    stroke-linejoin: bevel;
    stroke-miterlimit: 10;
  }
  .st4 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #ffffff;
  }
  .st5 {
    fill: none;
    stroke: #e2e2e2;
    stroke-width: 0.737;
    stroke-linecap: square;
    stroke-linejoin: bevel;
    stroke-miterlimit: 10;
  }
  .st13 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    -webkit-transition: fill 0.4s;
    -moz-transition: fill 0.4s;
    -o-transition: fill 0.4s;
    transition: fill 0.4s;
    opacity: 0.6;
  }
  .rot.st13 {
    fill: var(--red-main);
  }
  .blau.st13 {
    fill: var(--blue-main);
  }
  .gelb.st13 {
    fill: var(--yellow-main);
  }
  .beige.st13 {
    fill: var(--beige-dark-2);
  }
  .highlight.st13 {
    fill: var(--purple-main) !important;
    opacity: 1;
  }
  .missing.st13 {
    fill: var(--gray-6);
    opacity: 0;
  }
  .regions {
    _opacity: 0.6;
  }
  .diagonalHatch {
    .stripe {
      stroke-width: 2.85;
    }
  }
  .diagonalHatch.blaugelb,
  .diagonalHatch.gelbblau {
    .stripe {
      stroke: var(--blue-main);
    }
    .background {
      fill: var(--yellow-main);
    }
  }
  .diagonalHatch.blaurot,
  .diagonalHatch.rotblau {
    .stripe {
      stroke: var(--blue-main);
    }
    .background {
      fill: var(--red-main);
    }
  }
  .diagonalHatch.rotgelb,
  .diagonalHatch.gelbrot {
    .stripe {
      stroke: var(--red-main);
    }
    .background {
      fill: var(--yellow-main);
    }
  }
  .diagonalHatch.rotbeige,
  .diagonalHatch.beigerot {
    .stripe {
      stroke: var(--red-main);
    }
    .background {
      fill: var(--beige-dark-2);
    }
  }
  .diagonalHatch.blaubeige,
  .diagonalHatch.beigeblau {
    .stripe {
      stroke: var(--blue-main);
    }
    .background {
      fill: var(--beige-dark-2);
    }
  }
  .diagonalHatch.gelbbeige,
  .diagonalHatch.beigegelb {
    .stripe {
      stroke: var(--yellow-main);
    }
    .background {
      fill: var(--beige-dark-2);
    }
  }
`

export default SwissMap
